/*! jQuery v1.11.3 | (c) 2005, 2015 jQuery Foundation, Inc. | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=c.slice,e=c.concat,f=c.push,g=c.indexOf,h={},i=h.toString,j=h.hasOwnProperty,k={},l="1.11.3",m=function(a,b){return new m.fn.init(a,b)},n=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,o=/^-ms-/,p=/-([\da-z])/gi,q=function(a,b){return b.toUpperCase()};m.fn=m.prototype={jquery:l,constructor:m,selector:"",length:0,toArray:function(){return d.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:d.call(this)},pushStack:function(a){var b=m.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a,b){return m.each(this,a,b)},map:function(a){return this.pushStack(m.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(d.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor(null)},push:f,sort:c.sort,splice:c.splice},m.extend=m.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||m.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(e=arguments[h]))for(d in e)a=g[d],c=e[d],g!==c&&(j&&c&&(m.isPlainObject(c)||(b=m.isArray(c)))?(b?(b=!1,f=a&&m.isArray(a)?a:[]):f=a&&m.isPlainObject(a)?a:{},g[d]=m.extend(j,f,c)):void 0!==c&&(g[d]=c));return g},m.extend({expando:"jQuery"+(l+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===m.type(a)},isArray:Array.isArray||function(a){return"array"===m.type(a)},isWindow:function(a){return null!=a&&a==a.window},isNumeric:function(a){return!m.isArray(a)&&a-parseFloat(a)+1>=0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},isPlainObject:function(a){var b;if(!a||"object"!==m.type(a)||a.nodeType||m.isWindow(a))return!1;try{if(a.constructor&&!j.call(a,"constructor")&&!j.call(a.constructor.prototype,"isPrototypeOf"))return!1}catch(c){return!1}if(k.ownLast)for(b in a)return j.call(a,b);for(b in a);return void 0===b||j.call(a,b)},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?h[i.call(a)]||"object":typeof a},globalEval:function(b){b&&m.trim(b)&&(a.execScript||function(b){a.eval.call(a,b)})(b)},camelCase:function(a){return a.replace(o,"ms-").replace(p,q)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b,c){var d,e=0,f=a.length,g=r(a);if(c){if(g){for(;f>e;e++)if(d=b.apply(a[e],c),d===!1)break}else for(e in a)if(d=b.apply(a[e],c),d===!1)break}else if(g){for(;f>e;e++)if(d=b.call(a[e],e,a[e]),d===!1)break}else for(e in a)if(d=b.call(a[e],e,a[e]),d===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(n,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(r(Object(a))?m.merge(c,"string"==typeof a?[a]:a):f.call(c,a)),c},inArray:function(a,b,c){var d;if(b){if(g)return g.call(b,a,c);for(d=b.length,c=c?0>c?Math.max(0,d+c):c:0;d>c;c++)if(c in b&&b[c]===a)return c}return-1},merge:function(a,b){var c=+b.length,d=0,e=a.length;while(c>d)a[e++]=b[d++];if(c!==c)while(void 0!==b[d])a[e++]=b[d++];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,f=0,g=a.length,h=r(a),i=[];if(h)for(;g>f;f++)d=b(a[f],f,c),null!=d&&i.push(d);else for(f in a)d=b(a[f],f,c),null!=d&&i.push(d);return e.apply([],i)},guid:1,proxy:function(a,b){var c,e,f;return"string"==typeof b&&(f=a[b],b=a,a=f),m.isFunction(a)?(c=d.call(arguments,2),e=function(){return a.apply(b||this,c.concat(d.call(arguments)))},e.guid=a.guid=a.guid||m.guid++,e):void 0},now:function(){return+new Date},support:k}),m.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(a,b){h["[object "+b+"]"]=b.toLowerCase()});function r(a){var b="length"in a&&a.length,c=m.type(a);return"function"===c||m.isWindow(a)?!1:1===a.nodeType&&b?!0:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var s=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N=M.replace("w","w#"),O="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+N+"))|)"+L+"*\\]",P=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+O+")*)|.*)\\)|)",Q=new RegExp(L+"+","g"),R=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),S=new RegExp("^"+L+"*,"+L+"*"),T=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),U=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),V=new RegExp(P),W=new RegExp("^"+N+"$"),X={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M.replace("w","w*")+")"),ATTR:new RegExp("^"+O),PSEUDO:new RegExp("^"+P),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},Y=/^(?:input|select|textarea|button)$/i,Z=/^h\d$/i,$=/^[^{]+\{\s*\[native \w/,_=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,aa=/[+~]/,ba=/'|\\/g,ca=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),da=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ea=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(fa){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s,w,x;if((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,d=d||[],k=b.nodeType,"string"!=typeof a||!a||1!==k&&9!==k&&11!==k)return d;if(!e&&p){if(11!==k&&(f=_.exec(a)))if(j=f[1]){if(9===k){if(h=b.getElementById(j),!h||!h.parentNode)return d;if(h.id===j)return d.push(h),d}else if(b.ownerDocument&&(h=b.ownerDocument.getElementById(j))&&t(b,h)&&h.id===j)return d.push(h),d}else{if(f[2])return H.apply(d,b.getElementsByTagName(a)),d;if((j=f[3])&&c.getElementsByClassName)return H.apply(d,b.getElementsByClassName(j)),d}if(c.qsa&&(!q||!q.test(a))){if(s=r=u,w=b,x=1!==k&&a,1===k&&"object"!==b.nodeName.toLowerCase()){o=g(a),(r=b.getAttribute("id"))?s=r.replace(ba,"\\$&"):b.setAttribute("id",s),s="[id='"+s+"'] ",l=o.length;while(l--)o[l]=s+ra(o[l]);w=aa.test(a)&&pa(b.parentNode)||b,x=o.join(",")}if(x)try{return H.apply(d,w.querySelectorAll(x)),d}catch(y){}finally{r||b.removeAttribute("id")}}}return i(a.replace(R,"$1"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split("|"),e=a.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function oa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function pa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=g.documentElement,e=g.defaultView,e&&e!==e.top&&(e.addEventListener?e.addEventListener("unload",ea,!1):e.attachEvent&&e.attachEvent("onunload",ea)),p=!f(g),c.attributes=ja(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ja(function(a){return a.appendChild(g.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=$.test(g.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!g.getElementsByName||!g.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c&&c.parentNode?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=$.test(g.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\f]' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ja(function(a){var b=g.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=$.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",P)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=$.test(o.compareDocumentPosition),t=b||$.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===g||a.ownerDocument===v&&t(v,a)?-1:b===g||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,h=[a],i=[b];if(!e||!f)return a===g?-1:b===g?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)h.unshift(c);c=b;while(c=c.parentNode)i.unshift(c);while(h[d]===i[d])d++;return d?la(h[d],i[d]):h[d]===v?-1:i[d]===v?1:0},g):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(U,"='$1']"),!(!c.matchesSelector||!p||r&&r.test(b)||q&&q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:X,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ca,da),a[3]=(a[3]||a[4]||a[5]||"").replace(ca,da),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return X.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&V.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ca,da).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(Q," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h;if(q){if(f){while(p){l=b;while(l=l[p])if(h?l.nodeName.toLowerCase()===r:1===l.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){k=q[u]||(q[u]={}),j=k[a]||[],n=j[0]===w&&j[1],m=j[0]===w&&j[2],l=n&&q.childNodes[n];while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if(1===l.nodeType&&++m&&l===b){k[a]=[w,n,m];break}}else if(s&&(j=(b[u]||(b[u]={}))[a])&&j[0]===w)m=j[1];else while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if((h?l.nodeName.toLowerCase()===r:1===l.nodeType)&&++m&&(s&&((l[u]||(l[u]={}))[a]=[w,m]),l===b))break;return m-=e,m===d||m%d===0&&m/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(R,"$1"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(ca,da),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return W.test(a||"")||ga.error("unsupported lang: "+a),a=a.replace(ca,da).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Z.test(a.nodeName)},input:function(a){return Y.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:oa(function(){return[0]}),last:oa(function(a,b){return[b-1]}),eq:oa(function(a,b,c){return[0>c?c+b:c]}),even:oa(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:oa(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:oa(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:oa(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function qa(){}qa.prototype=d.filters=d.pseudos,d.setFilters=new qa,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=S.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=T.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(R," ")}),h=h.slice(c.length));for(g in d.filter)!(e=X[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function ra(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function sa(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(i=b[u]||(b[u]={}),(h=i[d])&&h[0]===w&&h[1]===f)return j[2]=h[2];if(i[d]=j,j[2]=a(b,c,g))return!0}}}function ta(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ua(a,b,c){for(var d=0,e=b.length;e>d;d++)ga(a,b[d],c);return c}function va(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function wa(a,b,c,d,e,f){return d&&!d[u]&&(d=wa(d)),e&&!e[u]&&(e=wa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ua(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:va(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=va(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=va(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function xa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=sa(function(a){return a===b},h,!0),l=sa(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[sa(ta(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return wa(i>1&&ta(m),i>1&&ra(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(R,"$1"),c,e>i&&xa(a.slice(i,e)),f>e&&xa(a=a.slice(e)),f>e&&ra(a))}m.push(c)}return ta(m)}function ya(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,m,o,p=0,q="0",r=f&&[],s=[],t=j,u=f||e&&d.find.TAG("*",k),v=w+=null==t?1:Math.random()||.1,x=u.length;for(k&&(j=g!==n&&g);q!==x&&null!=(l=u[q]);q++){if(e&&l){m=0;while(o=a[m++])if(o(l,g,h)){i.push(l);break}k&&(w=v)}c&&((l=!o&&l)&&p--,f&&r.push(l))}if(p+=q,c&&q!==p){m=0;while(o=b[m++])o(r,s,g,h);if(f){if(p>0)while(q--)r[q]||s[q]||(s[q]=F.call(i));s=va(s)}H.apply(i,s),k&&!f&&s.length>0&&p+b.length>1&&ga.uniqueSort(i)}return k&&(w=v,j=t),r};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=xa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,ya(e,d)),f.selector=a}return f},i=ga.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ca,da),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=X.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ca,da),aa.test(j[0].type)&&pa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&ra(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,aa.test(a)&&pa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ja(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ka("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ka("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ja(function(a){return null==a.getAttribute("disabled")})||ka(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);m.find=s,m.expr=s.selectors,m.expr[":"]=m.expr.pseudos,m.unique=s.uniqueSort,m.text=s.getText,m.isXMLDoc=s.isXML,m.contains=s.contains;var t=m.expr.match.needsContext,u=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,v=/^.[^:#\[\.,]*$/;function w(a,b,c){if(m.isFunction(b))return m.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return m.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(v.test(b))return m.filter(b,a,c);b=m.filter(b,a)}return m.grep(a,function(a){return m.inArray(a,b)>=0!==c})}m.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?m.find.matchesSelector(d,a)?[d]:[]:m.find.matches(a,m.grep(b,function(a){return 1===a.nodeType}))},m.fn.extend({find:function(a){var b,c=[],d=this,e=d.length;if("string"!=typeof a)return this.pushStack(m(a).filter(function(){for(b=0;e>b;b++)if(m.contains(d[b],this))return!0}));for(b=0;e>b;b++)m.find(a,d[b],c);return c=this.pushStack(e>1?m.unique(c):c),c.selector=this.selector?this.selector+" "+a:a,c},filter:function(a){return this.pushStack(w(this,a||[],!1))},not:function(a){return this.pushStack(w(this,a||[],!0))},is:function(a){return!!w(this,"string"==typeof a&&t.test(a)?m(a):a||[],!1).length}});var x,y=a.document,z=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,A=m.fn.init=function(a,b){var c,d;if(!a)return this;if("string"==typeof a){if(c="<"===a.charAt(0)&&">"===a.charAt(a.length-1)&&a.length>=3?[null,a,null]:z.exec(a),!c||!c[1]&&b)return!b||b.jquery?(b||x).find(a):this.constructor(b).find(a);if(c[1]){if(b=b instanceof m?b[0]:b,m.merge(this,m.parseHTML(c[1],b&&b.nodeType?b.ownerDocument||b:y,!0)),u.test(c[1])&&m.isPlainObject(b))for(c in b)m.isFunction(this[c])?this[c](b[c]):this.attr(c,b[c]);return this}if(d=y.getElementById(c[2]),d&&d.parentNode){if(d.id!==c[2])return x.find(a);this.length=1,this[0]=d}return this.context=y,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):m.isFunction(a)?"undefined"!=typeof x.ready?x.ready(a):a(m):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),m.makeArray(a,this))};A.prototype=m.fn,x=m(y);var B=/^(?:parents|prev(?:Until|All))/,C={children:!0,contents:!0,next:!0,prev:!0};m.extend({dir:function(a,b,c){var d=[],e=a[b];while(e&&9!==e.nodeType&&(void 0===c||1!==e.nodeType||!m(e).is(c)))1===e.nodeType&&d.push(e),e=e[b];return d},sibling:function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c}}),m.fn.extend({has:function(a){var b,c=m(a,this),d=c.length;return this.filter(function(){for(b=0;d>b;b++)if(m.contains(this,c[b]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=t.test(a)||"string"!=typeof a?m(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&m.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?m.unique(f):f)},index:function(a){return a?"string"==typeof a?m.inArray(this[0],m(a)):m.inArray(a.jquery?a[0]:a,this):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(m.unique(m.merge(this.get(),m(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function D(a,b){do a=a[b];while(a&&1!==a.nodeType);return a}m.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return m.dir(a,"parentNode")},parentsUntil:function(a,b,c){return m.dir(a,"parentNode",c)},next:function(a){return D(a,"nextSibling")},prev:function(a){return D(a,"previousSibling")},nextAll:function(a){return m.dir(a,"nextSibling")},prevAll:function(a){return m.dir(a,"previousSibling")},nextUntil:function(a,b,c){return m.dir(a,"nextSibling",c)},prevUntil:function(a,b,c){return m.dir(a,"previousSibling",c)},siblings:function(a){return m.sibling((a.parentNode||{}).firstChild,a)},children:function(a){return m.sibling(a.firstChild)},contents:function(a){return m.nodeName(a,"iframe")?a.contentDocument||a.contentWindow.document:m.merge([],a.childNodes)}},function(a,b){m.fn[a]=function(c,d){var e=m.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=m.filter(d,e)),this.length>1&&(C[a]||(e=m.unique(e)),B.test(a)&&(e=e.reverse())),this.pushStack(e)}});var E=/\S+/g,F={};function G(a){var b=F[a]={};return m.each(a.match(E)||[],function(a,c){b[c]=!0}),b}m.Callbacks=function(a){a="string"==typeof a?F[a]||G(a):m.extend({},a);var b,c,d,e,f,g,h=[],i=!a.once&&[],j=function(l){for(c=a.memory&&l,d=!0,f=g||0,g=0,e=h.length,b=!0;h&&e>f;f++)if(h[f].apply(l[0],l[1])===!1&&a.stopOnFalse){c=!1;break}b=!1,h&&(i?i.length&&j(i.shift()):c?h=[]:k.disable())},k={add:function(){if(h){var d=h.length;!function f(b){m.each(b,function(b,c){var d=m.type(c);"function"===d?a.unique&&k.has(c)||h.push(c):c&&c.length&&"string"!==d&&f(c)})}(arguments),b?e=h.length:c&&(g=d,j(c))}return this},remove:function(){return h&&m.each(arguments,function(a,c){var d;while((d=m.inArray(c,h,d))>-1)h.splice(d,1),b&&(e>=d&&e--,f>=d&&f--)}),this},has:function(a){return a?m.inArray(a,h)>-1:!(!h||!h.length)},empty:function(){return h=[],e=0,this},disable:function(){return h=i=c=void 0,this},disabled:function(){return!h},lock:function(){return i=void 0,c||k.disable(),this},locked:function(){return!i},fireWith:function(a,c){return!h||d&&!i||(c=c||[],c=[a,c.slice?c.slice():c],b?i.push(c):j(c)),this},fire:function(){return k.fireWith(this,arguments),this},fired:function(){return!!d}};return k},m.extend({Deferred:function(a){var b=[["resolve","done",m.Callbacks("once memory"),"resolved"],["reject","fail",m.Callbacks("once memory"),"rejected"],["notify","progress",m.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return m.Deferred(function(c){m.each(b,function(b,f){var g=m.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&m.isFunction(a.promise)?a.promise().done(c.resolve).fail(c.reject).progress(c.notify):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?m.extend(a,d):d}},e={};return d.pipe=d.then,m.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=d.call(arguments),e=c.length,f=1!==e||a&&m.isFunction(a.promise)?e:0,g=1===f?a:m.Deferred(),h=function(a,b,c){return function(e){b[a]=this,c[a]=arguments.length>1?d.call(arguments):e,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(e>1)for(i=new Array(e),j=new Array(e),k=new Array(e);e>b;b++)c[b]&&m.isFunction(c[b].promise)?c[b].promise().done(h(b,k,c)).fail(g.reject).progress(h(b,j,i)):--f;return f||g.resolveWith(k,c),g.promise()}});var H;m.fn.ready=function(a){return m.ready.promise().done(a),this},m.extend({isReady:!1,readyWait:1,holdReady:function(a){a?m.readyWait++:m.ready(!0)},ready:function(a){if(a===!0?!--m.readyWait:!m.isReady){if(!y.body)return setTimeout(m.ready);m.isReady=!0,a!==!0&&--m.readyWait>0||(H.resolveWith(y,[m]),m.fn.triggerHandler&&(m(y).triggerHandler("ready"),m(y).off("ready")))}}});function I(){y.addEventListener?(y.removeEventListener("DOMContentLoaded",J,!1),a.removeEventListener("load",J,!1)):(y.detachEvent("onreadystatechange",J),a.detachEvent("onload",J))}function J(){(y.addEventListener||"load"===event.type||"complete"===y.readyState)&&(I(),m.ready())}m.ready.promise=function(b){if(!H)if(H=m.Deferred(),"complete"===y.readyState)setTimeout(m.ready);else if(y.addEventListener)y.addEventListener("DOMContentLoaded",J,!1),a.addEventListener("load",J,!1);else{y.attachEvent("onreadystatechange",J),a.attachEvent("onload",J);var c=!1;try{c=null==a.frameElement&&y.documentElement}catch(d){}c&&c.doScroll&&!function e(){if(!m.isReady){try{c.doScroll("left")}catch(a){return setTimeout(e,50)}I(),m.ready()}}()}return H.promise(b)};var K="undefined",L;for(L in m(k))break;k.ownLast="0"!==L,k.inlineBlockNeedsLayout=!1,m(function(){var a,b,c,d;c=y.getElementsByTagName("body")[0],c&&c.style&&(b=y.createElement("div"),d=y.createElement("div"),d.style.cssText="position:absolute;border:0;width:0;height:0;top:0;left:-9999px",c.appendChild(d).appendChild(b),typeof b.style.zoom!==K&&(b.style.cssText="display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1",k.inlineBlockNeedsLayout=a=3===b.offsetWidth,a&&(c.style.zoom=1)),c.removeChild(d))}),function(){var a=y.createElement("div");if(null==k.deleteExpando){k.deleteExpando=!0;try{delete a.test}catch(b){k.deleteExpando=!1}}a=null}(),m.acceptData=function(a){var b=m.noData[(a.nodeName+" ").toLowerCase()],c=+a.nodeType||1;return 1!==c&&9!==c?!1:!b||b!==!0&&a.getAttribute("classid")===b};var M=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,N=/([A-Z])/g;function O(a,b,c){if(void 0===c&&1===a.nodeType){var d="data-"+b.replace(N,"-$1").toLowerCase();if(c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:M.test(c)?m.parseJSON(c):c}catch(e){}m.data(a,b,c)}else c=void 0}return c}function P(a){var b;for(b in a)if(("data"!==b||!m.isEmptyObject(a[b]))&&"toJSON"!==b)return!1;

return!0}function Q(a,b,d,e){if(m.acceptData(a)){var f,g,h=m.expando,i=a.nodeType,j=i?m.cache:a,k=i?a[h]:a[h]&&h;if(k&&j[k]&&(e||j[k].data)||void 0!==d||"string"!=typeof b)return k||(k=i?a[h]=c.pop()||m.guid++:h),j[k]||(j[k]=i?{}:{toJSON:m.noop}),("object"==typeof b||"function"==typeof b)&&(e?j[k]=m.extend(j[k],b):j[k].data=m.extend(j[k].data,b)),g=j[k],e||(g.data||(g.data={}),g=g.data),void 0!==d&&(g[m.camelCase(b)]=d),"string"==typeof b?(f=g[b],null==f&&(f=g[m.camelCase(b)])):f=g,f}}function R(a,b,c){if(m.acceptData(a)){var d,e,f=a.nodeType,g=f?m.cache:a,h=f?a[m.expando]:m.expando;if(g[h]){if(b&&(d=c?g[h]:g[h].data)){m.isArray(b)?b=b.concat(m.map(b,m.camelCase)):b in d?b=[b]:(b=m.camelCase(b),b=b in d?[b]:b.split(" ")),e=b.length;while(e--)delete d[b[e]];if(c?!P(d):!m.isEmptyObject(d))return}(c||(delete g[h].data,P(g[h])))&&(f?m.cleanData([a],!0):k.deleteExpando||g!=g.window?delete g[h]:g[h]=null)}}}m.extend({cache:{},noData:{"applet ":!0,"embed ":!0,"object ":"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"},hasData:function(a){return a=a.nodeType?m.cache[a[m.expando]]:a[m.expando],!!a&&!P(a)},data:function(a,b,c){return Q(a,b,c)},removeData:function(a,b){return R(a,b)},_data:function(a,b,c){return Q(a,b,c,!0)},_removeData:function(a,b){return R(a,b,!0)}}),m.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=m.data(f),1===f.nodeType&&!m._data(f,"parsedAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=m.camelCase(d.slice(5)),O(f,d,e[d])));m._data(f,"parsedAttrs",!0)}return e}return"object"==typeof a?this.each(function(){m.data(this,a)}):arguments.length>1?this.each(function(){m.data(this,a,b)}):f?O(f,a,m.data(f,a)):void 0},removeData:function(a){return this.each(function(){m.removeData(this,a)})}}),m.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=m._data(a,b),c&&(!d||m.isArray(c)?d=m._data(a,b,m.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=m.queue(a,b),d=c.length,e=c.shift(),f=m._queueHooks(a,b),g=function(){m.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return m._data(a,c)||m._data(a,c,{empty:m.Callbacks("once memory").add(function(){m._removeData(a,b+"queue"),m._removeData(a,c)})})}}),m.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?m.queue(this[0],a):void 0===b?this:this.each(function(){var c=m.queue(this,a,b);m._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&m.dequeue(this,a)})},dequeue:function(a){return this.each(function(){m.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=m.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=m._data(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var S=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,T=["Top","Right","Bottom","Left"],U=function(a,b){return a=b||a,"none"===m.css(a,"display")||!m.contains(a.ownerDocument,a)},V=m.access=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===m.type(c)){e=!0;for(h in c)m.access(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,m.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(m(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},W=/^(?:checkbox|radio)$/i;!function(){var a=y.createElement("input"),b=y.createElement("div"),c=y.createDocumentFragment();if(b.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",k.leadingWhitespace=3===b.firstChild.nodeType,k.tbody=!b.getElementsByTagName("tbody").length,k.htmlSerialize=!!b.getElementsByTagName("link").length,k.html5Clone="<:nav></:nav>"!==y.createElement("nav").cloneNode(!0).outerHTML,a.type="checkbox",a.checked=!0,c.appendChild(a),k.appendChecked=a.checked,b.innerHTML="<textarea>x</textarea>",k.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue,c.appendChild(b),b.innerHTML="<input type='radio' checked='checked' name='t'/>",k.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,k.noCloneEvent=!0,b.attachEvent&&(b.attachEvent("onclick",function(){k.noCloneEvent=!1}),b.cloneNode(!0).click()),null==k.deleteExpando){k.deleteExpando=!0;try{delete b.test}catch(d){k.deleteExpando=!1}}}(),function(){var b,c,d=y.createElement("div");for(b in{submit:!0,change:!0,focusin:!0})c="on"+b,(k[b+"Bubbles"]=c in a)||(d.setAttribute(c,"t"),k[b+"Bubbles"]=d.attributes[c].expando===!1);d=null}();var X=/^(?:input|select|textarea)$/i,Y=/^key/,Z=/^(?:mouse|pointer|contextmenu)|click/,$=/^(?:focusinfocus|focusoutblur)$/,_=/^([^.]*)(?:\.(.+)|)$/;function aa(){return!0}function ba(){return!1}function ca(){try{return y.activeElement}catch(a){}}m.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,n,o,p,q,r=m._data(a);if(r){c.handler&&(i=c,c=i.handler,e=i.selector),c.guid||(c.guid=m.guid++),(g=r.events)||(g=r.events={}),(k=r.handle)||(k=r.handle=function(a){return typeof m===K||a&&m.event.triggered===a.type?void 0:m.event.dispatch.apply(k.elem,arguments)},k.elem=a),b=(b||"").match(E)||[""],h=b.length;while(h--)f=_.exec(b[h])||[],o=q=f[1],p=(f[2]||"").split(".").sort(),o&&(j=m.event.special[o]||{},o=(e?j.delegateType:j.bindType)||o,j=m.event.special[o]||{},l=m.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&m.expr.match.needsContext.test(e),namespace:p.join(".")},i),(n=g[o])||(n=g[o]=[],n.delegateCount=0,j.setup&&j.setup.call(a,d,p,k)!==!1||(a.addEventListener?a.addEventListener(o,k,!1):a.attachEvent&&a.attachEvent("on"+o,k))),j.add&&(j.add.call(a,l),l.handler.guid||(l.handler.guid=c.guid)),e?n.splice(n.delegateCount++,0,l):n.push(l),m.event.global[o]=!0);a=null}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,n,o,p,q,r=m.hasData(a)&&m._data(a);if(r&&(k=r.events)){b=(b||"").match(E)||[""],j=b.length;while(j--)if(h=_.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=m.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,n=k[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),i=f=n.length;while(f--)g=n[f],!e&&q!==g.origType||c&&c.guid!==g.guid||h&&!h.test(g.namespace)||d&&d!==g.selector&&("**"!==d||!g.selector)||(n.splice(f,1),g.selector&&n.delegateCount--,l.remove&&l.remove.call(a,g));i&&!n.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||m.removeEvent(a,o,r.handle),delete k[o])}else for(o in k)m.event.remove(a,o+b[j],c,d,!0);m.isEmptyObject(k)&&(delete r.handle,m._removeData(a,"events"))}},trigger:function(b,c,d,e){var f,g,h,i,k,l,n,o=[d||y],p=j.call(b,"type")?b.type:b,q=j.call(b,"namespace")?b.namespace.split("."):[];if(h=l=d=d||y,3!==d.nodeType&&8!==d.nodeType&&!$.test(p+m.event.triggered)&&(p.indexOf(".")>=0&&(q=p.split("."),p=q.shift(),q.sort()),g=p.indexOf(":")<0&&"on"+p,b=b[m.expando]?b:new m.Event(p,"object"==typeof b&&b),b.isTrigger=e?2:3,b.namespace=q.join("."),b.namespace_re=b.namespace?new RegExp("(^|\\.)"+q.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=d),c=null==c?[b]:m.makeArray(c,[b]),k=m.event.special[p]||{},e||!k.trigger||k.trigger.apply(d,c)!==!1)){if(!e&&!k.noBubble&&!m.isWindow(d)){for(i=k.delegateType||p,$.test(i+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),l=h;l===(d.ownerDocument||y)&&o.push(l.defaultView||l.parentWindow||a)}n=0;while((h=o[n++])&&!b.isPropagationStopped())b.type=n>1?i:k.bindType||p,f=(m._data(h,"events")||{})[b.type]&&m._data(h,"handle"),f&&f.apply(h,c),f=g&&h[g],f&&f.apply&&m.acceptData(h)&&(b.result=f.apply(h,c),b.result===!1&&b.preventDefault());if(b.type=p,!e&&!b.isDefaultPrevented()&&(!k._default||k._default.apply(o.pop(),c)===!1)&&m.acceptData(d)&&g&&d[p]&&!m.isWindow(d)){l=d[g],l&&(d[g]=null),m.event.triggered=p;try{d[p]()}catch(r){}m.event.triggered=void 0,l&&(d[g]=l)}return b.result}},dispatch:function(a){a=m.event.fix(a);var b,c,e,f,g,h=[],i=d.call(arguments),j=(m._data(this,"events")||{})[a.type]||[],k=m.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=m.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,g=0;while((e=f.handlers[g++])&&!a.isImmediatePropagationStopped())(!a.namespace_re||a.namespace_re.test(e.namespace))&&(a.handleObj=e,a.data=e.data,c=((m.event.special[e.origType]||{}).handle||e.handler).apply(f.elem,i),void 0!==c&&(a.result=c)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&(!a.button||"click"!==a.type))for(;i!=this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(e=[],f=0;h>f;f++)d=b[f],c=d.selector+" ",void 0===e[c]&&(e[c]=d.needsContext?m(c,this).index(i)>=0:m.find(c,this,null,[i]).length),e[c]&&e.push(d);e.length&&g.push({elem:i,handlers:e})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},fix:function(a){if(a[m.expando])return a;var b,c,d,e=a.type,f=a,g=this.fixHooks[e];g||(this.fixHooks[e]=g=Z.test(e)?this.mouseHooks:Y.test(e)?this.keyHooks:{}),d=g.props?this.props.concat(g.props):this.props,a=new m.Event(f),b=d.length;while(b--)c=d[b],a[c]=f[c];return a.target||(a.target=f.srcElement||y),3===a.target.nodeType&&(a.target=a.target.parentNode),a.metaKey=!!a.metaKey,g.filter?g.filter(a,f):a},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,d,e,f=b.button,g=b.fromElement;return null==a.pageX&&null!=b.clientX&&(d=a.target.ownerDocument||y,e=d.documentElement,c=d.body,a.pageX=b.clientX+(e&&e.scrollLeft||c&&c.scrollLeft||0)-(e&&e.clientLeft||c&&c.clientLeft||0),a.pageY=b.clientY+(e&&e.scrollTop||c&&c.scrollTop||0)-(e&&e.clientTop||c&&c.clientTop||0)),!a.relatedTarget&&g&&(a.relatedTarget=g===a.target?b.toElement:g),a.which||void 0===f||(a.which=1&f?1:2&f?3:4&f?2:0),a}},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==ca()&&this.focus)try{return this.focus(),!1}catch(a){}},delegateType:"focusin"},blur:{trigger:function(){return this===ca()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return m.nodeName(this,"input")&&"checkbox"===this.type&&this.click?(this.click(),!1):void 0},_default:function(a){return m.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c,d){var e=m.extend(new m.Event,c,{type:a,isSimulated:!0,originalEvent:{}});d?m.event.trigger(e,null,b):m.event.dispatch.call(b,e),e.isDefaultPrevented()&&c.preventDefault()}},m.removeEvent=y.removeEventListener?function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c,!1)}:function(a,b,c){var d="on"+b;a.detachEvent&&(typeof a[d]===K&&(a[d]=null),a.detachEvent(d,c))},m.Event=function(a,b){return this instanceof m.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?aa:ba):this.type=a,b&&m.extend(this,b),this.timeStamp=a&&a.timeStamp||m.now(),void(this[m.expando]=!0)):new m.Event(a,b)},m.Event.prototype={isDefaultPrevented:ba,isPropagationStopped:ba,isImmediatePropagationStopped:ba,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=aa,a&&(a.preventDefault?a.preventDefault():a.returnValue=!1)},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=aa,a&&(a.stopPropagation&&a.stopPropagation(),a.cancelBubble=!0)},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=aa,a&&a.stopImmediatePropagation&&a.stopImmediatePropagation(),this.stopPropagation()}},m.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){m.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!m.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),k.submitBubbles||(m.event.special.submit={setup:function(){return m.nodeName(this,"form")?!1:void m.event.add(this,"click._submit keypress._submit",function(a){var b=a.target,c=m.nodeName(b,"input")||m.nodeName(b,"button")?b.form:void 0;c&&!m._data(c,"submitBubbles")&&(m.event.add(c,"submit._submit",function(a){a._submit_bubble=!0}),m._data(c,"submitBubbles",!0))})},postDispatch:function(a){a._submit_bubble&&(delete a._submit_bubble,this.parentNode&&!a.isTrigger&&m.event.simulate("submit",this.parentNode,a,!0))},teardown:function(){return m.nodeName(this,"form")?!1:void m.event.remove(this,"._submit")}}),k.changeBubbles||(m.event.special.change={setup:function(){return X.test(this.nodeName)?(("checkbox"===this.type||"radio"===this.type)&&(m.event.add(this,"propertychange._change",function(a){"checked"===a.originalEvent.propertyName&&(this._just_changed=!0)}),m.event.add(this,"click._change",function(a){this._just_changed&&!a.isTrigger&&(this._just_changed=!1),m.event.simulate("change",this,a,!0)})),!1):void m.event.add(this,"beforeactivate._change",function(a){var b=a.target;X.test(b.nodeName)&&!m._data(b,"changeBubbles")&&(m.event.add(b,"change._change",function(a){!this.parentNode||a.isSimulated||a.isTrigger||m.event.simulate("change",this.parentNode,a,!0)}),m._data(b,"changeBubbles",!0))})},handle:function(a){var b=a.target;return this!==b||a.isSimulated||a.isTrigger||"radio"!==b.type&&"checkbox"!==b.type?a.handleObj.handler.apply(this,arguments):void 0},teardown:function(){return m.event.remove(this,"._change"),!X.test(this.nodeName)}}),k.focusinBubbles||m.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){m.event.simulate(b,a.target,m.event.fix(a),!0)};m.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=m._data(d,b);e||d.addEventListener(a,c,!0),m._data(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=m._data(d,b)-1;e?m._data(d,b,e):(d.removeEventListener(a,c,!0),m._removeData(d,b))}}}),m.fn.extend({on:function(a,b,c,d,e){var f,g;if("object"==typeof a){"string"!=typeof b&&(c=c||b,b=void 0);for(f in a)this.on(f,b,c,a[f],e);return this}if(null==c&&null==d?(d=b,c=b=void 0):null==d&&("string"==typeof b?(d=c,c=void 0):(d=c,c=b,b=void 0)),d===!1)d=ba;else if(!d)return this;return 1===e&&(g=d,d=function(a){return m().off(a),g.apply(this,arguments)},d.guid=g.guid||(g.guid=m.guid++)),this.each(function(){m.event.add(this,a,d,c,b)})},one:function(a,b,c,d){return this.on(a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,m(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||"function"==typeof b)&&(c=b,b=void 0),c===!1&&(c=ba),this.each(function(){m.event.remove(this,a,c,b)})},trigger:function(a,b){return this.each(function(){m.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?m.event.trigger(a,b,c,!0):void 0}});function da(a){var b=ea.split("|"),c=a.createDocumentFragment();if(c.createElement)while(b.length)c.createElement(b.pop());return c}var ea="abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",fa=/ jQuery\d+="(?:null|\d+)"/g,ga=new RegExp("<(?:"+ea+")[\\s/>]","i"),ha=/^\s+/,ia=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,ja=/<([\w:]+)/,ka=/<tbody/i,la=/<|&#?\w+;/,ma=/<(?:script|style|link)/i,na=/checked\s*(?:[^=]|=\s*.checked.)/i,oa=/^$|\/(?:java|ecma)script/i,pa=/^true\/(.*)/,qa=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,ra={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],area:[1,"<map>","</map>"],param:[1,"<object>","</object>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:k.htmlSerialize?[0,"",""]:[1,"X<div>","</div>"]},sa=da(y),ta=sa.appendChild(y.createElement("div"));ra.optgroup=ra.option,ra.tbody=ra.tfoot=ra.colgroup=ra.caption=ra.thead,ra.th=ra.td;function ua(a,b){var c,d,e=0,f=typeof a.getElementsByTagName!==K?a.getElementsByTagName(b||"*"):typeof a.querySelectorAll!==K?a.querySelectorAll(b||"*"):void 0;if(!f)for(f=[],c=a.childNodes||a;null!=(d=c[e]);e++)!b||m.nodeName(d,b)?f.push(d):m.merge(f,ua(d,b));return void 0===b||b&&m.nodeName(a,b)?m.merge([a],f):f}function va(a){W.test(a.type)&&(a.defaultChecked=a.checked)}function wa(a,b){return m.nodeName(a,"table")&&m.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function xa(a){return a.type=(null!==m.find.attr(a,"type"))+"/"+a.type,a}function ya(a){var b=pa.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function za(a,b){for(var c,d=0;null!=(c=a[d]);d++)m._data(c,"globalEval",!b||m._data(b[d],"globalEval"))}function Aa(a,b){if(1===b.nodeType&&m.hasData(a)){var c,d,e,f=m._data(a),g=m._data(b,f),h=f.events;if(h){delete g.handle,g.events={};for(c in h)for(d=0,e=h[c].length;e>d;d++)m.event.add(b,c,h[c][d])}g.data&&(g.data=m.extend({},g.data))}}function Ba(a,b){var c,d,e;if(1===b.nodeType){if(c=b.nodeName.toLowerCase(),!k.noCloneEvent&&b[m.expando]){e=m._data(b);for(d in e.events)m.removeEvent(b,d,e.handle);b.removeAttribute(m.expando)}"script"===c&&b.text!==a.text?(xa(b).text=a.text,ya(b)):"object"===c?(b.parentNode&&(b.outerHTML=a.outerHTML),k.html5Clone&&a.innerHTML&&!m.trim(b.innerHTML)&&(b.innerHTML=a.innerHTML)):"input"===c&&W.test(a.type)?(b.defaultChecked=b.checked=a.checked,b.value!==a.value&&(b.value=a.value)):"option"===c?b.defaultSelected=b.selected=a.defaultSelected:("input"===c||"textarea"===c)&&(b.defaultValue=a.defaultValue)}}m.extend({clone:function(a,b,c){var d,e,f,g,h,i=m.contains(a.ownerDocument,a);if(k.html5Clone||m.isXMLDoc(a)||!ga.test("<"+a.nodeName+">")?f=a.cloneNode(!0):(ta.innerHTML=a.outerHTML,ta.removeChild(f=ta.firstChild)),!(k.noCloneEvent&&k.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||m.isXMLDoc(a)))for(d=ua(f),h=ua(a),g=0;null!=(e=h[g]);++g)d[g]&&Ba(e,d[g]);if(b)if(c)for(h=h||ua(a),d=d||ua(f),g=0;null!=(e=h[g]);g++)Aa(e,d[g]);else Aa(a,f);return d=ua(f,"script"),d.length>0&&za(d,!i&&ua(a,"script")),d=h=e=null,f},buildFragment:function(a,b,c,d){for(var e,f,g,h,i,j,l,n=a.length,o=da(b),p=[],q=0;n>q;q++)if(f=a[q],f||0===f)if("object"===m.type(f))m.merge(p,f.nodeType?[f]:f);else if(la.test(f)){h=h||o.appendChild(b.createElement("div")),i=(ja.exec(f)||["",""])[1].toLowerCase(),l=ra[i]||ra._default,h.innerHTML=l[1]+f.replace(ia,"<$1></$2>")+l[2],e=l[0];while(e--)h=h.lastChild;if(!k.leadingWhitespace&&ha.test(f)&&p.push(b.createTextNode(ha.exec(f)[0])),!k.tbody){f="table"!==i||ka.test(f)?"<table>"!==l[1]||ka.test(f)?0:h:h.firstChild,e=f&&f.childNodes.length;while(e--)m.nodeName(j=f.childNodes[e],"tbody")&&!j.childNodes.length&&f.removeChild(j)}m.merge(p,h.childNodes),h.textContent="";while(h.firstChild)h.removeChild(h.firstChild);h=o.lastChild}else p.push(b.createTextNode(f));h&&o.removeChild(h),k.appendChecked||m.grep(ua(p,"input"),va),q=0;while(f=p[q++])if((!d||-1===m.inArray(f,d))&&(g=m.contains(f.ownerDocument,f),h=ua(o.appendChild(f),"script"),g&&za(h),c)){e=0;while(f=h[e++])oa.test(f.type||"")&&c.push(f)}return h=null,o},cleanData:function(a,b){for(var d,e,f,g,h=0,i=m.expando,j=m.cache,l=k.deleteExpando,n=m.event.special;null!=(d=a[h]);h++)if((b||m.acceptData(d))&&(f=d[i],g=f&&j[f])){if(g.events)for(e in g.events)n[e]?m.event.remove(d,e):m.removeEvent(d,e,g.handle);j[f]&&(delete j[f],l?delete d[i]:typeof d.removeAttribute!==K?d.removeAttribute(i):d[i]=null,c.push(f))}}}),m.fn.extend({text:function(a){return V(this,function(a){return void 0===a?m.text(this):this.empty().append((this[0]&&this[0].ownerDocument||y).createTextNode(a))},null,a,arguments.length)},append:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=wa(this,a);b.appendChild(a)}})},prepend:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=wa(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},remove:function(a,b){for(var c,d=a?m.filter(a,this):this,e=0;null!=(c=d[e]);e++)b||1!==c.nodeType||m.cleanData(ua(c)),c.parentNode&&(b&&m.contains(c.ownerDocument,c)&&za(ua(c,"script")),c.parentNode.removeChild(c));return this},empty:function(){for(var a,b=0;null!=(a=this[b]);b++){1===a.nodeType&&m.cleanData(ua(a,!1));while(a.firstChild)a.removeChild(a.firstChild);a.options&&m.nodeName(a,"select")&&(a.options.length=0)}return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return m.clone(this,a,b)})},html:function(a){return V(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a)return 1===b.nodeType?b.innerHTML.replace(fa,""):void 0;if(!("string"!=typeof a||ma.test(a)||!k.htmlSerialize&&ga.test(a)||!k.leadingWhitespace&&ha.test(a)||ra[(ja.exec(a)||["",""])[1].toLowerCase()])){a=a.replace(ia,"<$1></$2>");try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(m.cleanData(ua(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=arguments[0];return this.domManip(arguments,function(b){a=this.parentNode,m.cleanData(ua(this)),a&&a.replaceChild(b,this)}),a&&(a.length||a.nodeType)?this:this.remove()},detach:function(a){return this.remove(a,!0)},domManip:function(a,b){a=e.apply([],a);var c,d,f,g,h,i,j=0,l=this.length,n=this,o=l-1,p=a[0],q=m.isFunction(p);if(q||l>1&&"string"==typeof p&&!k.checkClone&&na.test(p))return this.each(function(c){var d=n.eq(c);q&&(a[0]=p.call(this,c,d.html())),d.domManip(a,b)});if(l&&(i=m.buildFragment(a,this[0].ownerDocument,!1,this),c=i.firstChild,1===i.childNodes.length&&(i=c),c)){for(g=m.map(ua(i,"script"),xa),f=g.length;l>j;j++)d=i,j!==o&&(d=m.clone(d,!0,!0),f&&m.merge(g,ua(d,"script"))),b.call(this[j],d,j);if(f)for(h=g[g.length-1].ownerDocument,m.map(g,ya),j=0;f>j;j++)d=g[j],oa.test(d.type||"")&&!m._data(d,"globalEval")&&m.contains(h,d)&&(d.src?m._evalUrl&&m._evalUrl(d.src):m.globalEval((d.text||d.textContent||d.innerHTML||"").replace(qa,"")));i=c=null}return this}}),m.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){m.fn[a]=function(a){for(var c,d=0,e=[],g=m(a),h=g.length-1;h>=d;d++)c=d===h?this:this.clone(!0),m(g[d])[b](c),f.apply(e,c.get());return this.pushStack(e)}});var Ca,Da={};function Ea(b,c){var d,e=m(c.createElement(b)).appendTo(c.body),f=a.getDefaultComputedStyle&&(d=a.getDefaultComputedStyle(e[0]))?d.display:m.css(e[0],"display");return e.detach(),f}function Fa(a){var b=y,c=Da[a];return c||(c=Ea(a,b),"none"!==c&&c||(Ca=(Ca||m("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=(Ca[0].contentWindow||Ca[0].contentDocument).document,b.write(),b.close(),c=Ea(a,b),Ca.detach()),Da[a]=c),c}!function(){var a;k.shrinkWrapBlocks=function(){if(null!=a)return a;a=!1;var b,c,d;return c=y.getElementsByTagName("body")[0],c&&c.style?(b=y.createElement("div"),d=y.createElement("div"),d.style.cssText="position:absolute;border:0;width:0;height:0;top:0;left:-9999px",c.appendChild(d).appendChild(b),typeof b.style.zoom!==K&&(b.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1",b.appendChild(y.createElement("div")).style.width="5px",a=3!==b.offsetWidth),c.removeChild(d),a):void 0}}();var Ga=/^margin/,Ha=new RegExp("^("+S+")(?!px)[a-z%]+$","i"),Ia,Ja,Ka=/^(top|right|bottom|left)$/;a.getComputedStyle?(Ia=function(b){return b.ownerDocument.defaultView.opener?b.ownerDocument.defaultView.getComputedStyle(b,null):a.getComputedStyle(b,null)},Ja=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Ia(a),g=c?c.getPropertyValue(b)||c[b]:void 0,c&&(""!==g||m.contains(a.ownerDocument,a)||(g=m.style(a,b)),Ha.test(g)&&Ga.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0===g?g:g+""}):y.documentElement.currentStyle&&(Ia=function(a){return a.currentStyle},Ja=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Ia(a),g=c?c[b]:void 0,null==g&&h&&h[b]&&(g=h[b]),Ha.test(g)&&!Ka.test(b)&&(d=h.left,e=a.runtimeStyle,f=e&&e.left,f&&(e.left=a.currentStyle.left),h.left="fontSize"===b?"1em":g,g=h.pixelLeft+"px",h.left=d,f&&(e.left=f)),void 0===g?g:g+""||"auto"});function La(a,b){return{get:function(){var c=a();if(null!=c)return c?void delete this.get:(this.get=b).apply(this,arguments)}}}!function(){var b,c,d,e,f,g,h;if(b=y.createElement("div"),b.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",d=b.getElementsByTagName("a")[0],c=d&&d.style){c.cssText="float:left;opacity:.5",k.opacity="0.5"===c.opacity,k.cssFloat=!!c.cssFloat,b.style.backgroundClip="content-box",b.cloneNode(!0).style.backgroundClip="",k.clearCloneStyle="content-box"===b.style.backgroundClip,k.boxSizing=""===c.boxSizing||""===c.MozBoxSizing||""===c.WebkitBoxSizing,m.extend(k,{reliableHiddenOffsets:function(){return null==g&&i(),g},boxSizingReliable:function(){return null==f&&i(),f},pixelPosition:function(){return null==e&&i(),e},reliableMarginRight:function(){return null==h&&i(),h}});function i(){var b,c,d,i;c=y.getElementsByTagName("body")[0],c&&c.style&&(b=y.createElement("div"),d=y.createElement("div"),d.style.cssText="position:absolute;border:0;width:0;height:0;top:0;left:-9999px",c.appendChild(d).appendChild(b),b.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute",e=f=!1,h=!0,a.getComputedStyle&&(e="1%"!==(a.getComputedStyle(b,null)||{}).top,f="4px"===(a.getComputedStyle(b,null)||{width:"4px"}).width,i=b.appendChild(y.createElement("div")),i.style.cssText=b.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",i.style.marginRight=i.style.width="0",b.style.width="1px",h=!parseFloat((a.getComputedStyle(i,null)||{}).marginRight),b.removeChild(i)),b.innerHTML="<table><tr><td></td><td>t</td></tr></table>",i=b.getElementsByTagName("td"),i[0].style.cssText="margin:0;border:0;padding:0;display:none",g=0===i[0].offsetHeight,g&&(i[0].style.display="",i[1].style.display="none",g=0===i[0].offsetHeight),c.removeChild(d))}}}(),m.swap=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};var Ma=/alpha\([^)]*\)/i,Na=/opacity\s*=\s*([^)]*)/,Oa=/^(none|table(?!-c[ea]).+)/,Pa=new RegExp("^("+S+")(.*)$","i"),Qa=new RegExp("^([+-])=("+S+")","i"),Ra={position:"absolute",visibility:"hidden",display:"block"},Sa={letterSpacing:"0",fontWeight:"400"},Ta=["Webkit","O","Moz","ms"];function Ua(a,b){if(b in a)return b;var c=b.charAt(0).toUpperCase()+b.slice(1),d=b,e=Ta.length;while(e--)if(b=Ta[e]+c,b in a)return b;return d}function Va(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=m._data(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&U(d)&&(f[g]=m._data(d,"olddisplay",Fa(d.nodeName)))):(e=U(d),(c&&"none"!==c||!e)&&m._data(d,"olddisplay",e?c:m.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}function Wa(a,b,c){var d=Pa.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||"px"):b}function Xa(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=m.css(a,c+T[f],!0,e)),d?("content"===c&&(g-=m.css(a,"padding"+T[f],!0,e)),"margin"!==c&&(g-=m.css(a,"border"+T[f]+"Width",!0,e))):(g+=m.css(a,"padding"+T[f],!0,e),"padding"!==c&&(g+=m.css(a,"border"+T[f]+"Width",!0,e)));return g}function Ya(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=Ia(a),g=k.boxSizing&&"border-box"===m.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=Ja(a,b,f),(0>e||null==e)&&(e=a.style[b]),Ha.test(e))return e;d=g&&(k.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Xa(a,b,c||(g?"border":"content"),d,f)+"px"}m.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Ja(a,"opacity");return""===c?"1":c}}}},cssNumber:{columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":k.cssFloat?"cssFloat":"styleFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=m.camelCase(b),i=a.style;if(b=m.cssProps[h]||(m.cssProps[h]=Ua(i,h)),g=m.cssHooks[b]||m.cssHooks[h],void 0===c)return g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b];if(f=typeof c,"string"===f&&(e=Qa.exec(c))&&(c=(e[1]+1)*e[2]+parseFloat(m.css(a,b)),f="number"),null!=c&&c===c&&("number"!==f||m.cssNumber[h]||(c+="px"),k.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),!(g&&"set"in g&&void 0===(c=g.set(a,c,d)))))try{i[b]=c}catch(j){}}},css:function(a,b,c,d){var e,f,g,h=m.camelCase(b);return b=m.cssProps[h]||(m.cssProps[h]=Ua(a.style,h)),g=m.cssHooks[b]||m.cssHooks[h],g&&"get"in g&&(f=g.get(a,!0,c)),void 0===f&&(f=Ja(a,b,d)),"normal"===f&&b in Sa&&(f=Sa[b]),""===c||c?(e=parseFloat(f),c===!0||m.isNumeric(e)?e||0:f):f}}),m.each(["height","width"],function(a,b){m.cssHooks[b]={get:function(a,c,d){return c?Oa.test(m.css(a,"display"))&&0===a.offsetWidth?m.swap(a,Ra,function(){return Ya(a,b,d)}):Ya(a,b,d):void 0},set:function(a,c,d){var e=d&&Ia(a);return Wa(a,c,d?Xa(a,b,d,k.boxSizing&&"border-box"===m.css(a,"boxSizing",!1,e),e):0)}}}),k.opacity||(m.cssHooks.opacity={get:function(a,b){return Na.test((b&&a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?.01*parseFloat(RegExp.$1)+"":b?"1":""},set:function(a,b){var c=a.style,d=a.currentStyle,e=m.isNumeric(b)?"alpha(opacity="+100*b+")":"",f=d&&d.filter||c.filter||"";c.zoom=1,(b>=1||""===b)&&""===m.trim(f.replace(Ma,""))&&c.removeAttribute&&(c.removeAttribute("filter"),""===b||d&&!d.filter)||(c.filter=Ma.test(f)?f.replace(Ma,e):f+" "+e)}}),m.cssHooks.marginRight=La(k.reliableMarginRight,function(a,b){return b?m.swap(a,{display:"inline-block"},Ja,[a,"marginRight"]):void 0}),m.each({margin:"",padding:"",border:"Width"},function(a,b){m.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+T[d]+b]=f[d]||f[d-2]||f[0];return e}},Ga.test(a)||(m.cssHooks[a+b].set=Wa)}),m.fn.extend({css:function(a,b){return V(this,function(a,b,c){var d,e,f={},g=0;if(m.isArray(b)){for(d=Ia(a),e=b.length;e>g;g++)f[b[g]]=m.css(a,b[g],!1,d);return f}return void 0!==c?m.style(a,b,c):m.css(a,b)},a,b,arguments.length>1)},show:function(){return Va(this,!0)},hide:function(){return Va(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){U(this)?m(this).show():m(this).hide()})}});function Za(a,b,c,d,e){
return new Za.prototype.init(a,b,c,d,e)}m.Tween=Za,Za.prototype={constructor:Za,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||"swing",this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(m.cssNumber[c]?"":"px")},cur:function(){var a=Za.propHooks[this.prop];return a&&a.get?a.get(this):Za.propHooks._default.get(this)},run:function(a){var b,c=Za.propHooks[this.prop];return this.options.duration?this.pos=b=m.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Za.propHooks._default.set(this),this}},Za.prototype.init.prototype=Za.prototype,Za.propHooks={_default:{get:function(a){var b;return null==a.elem[a.prop]||a.elem.style&&null!=a.elem.style[a.prop]?(b=m.css(a.elem,a.prop,""),b&&"auto"!==b?b:0):a.elem[a.prop]},set:function(a){m.fx.step[a.prop]?m.fx.step[a.prop](a):a.elem.style&&(null!=a.elem.style[m.cssProps[a.prop]]||m.cssHooks[a.prop])?m.style(a.elem,a.prop,a.now+a.unit):a.elem[a.prop]=a.now}}},Za.propHooks.scrollTop=Za.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},m.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2}},m.fx=Za.prototype.init,m.fx.step={};var $a,_a,ab=/^(?:toggle|show|hide)$/,bb=new RegExp("^(?:([+-])=|)("+S+")([a-z%]*)$","i"),cb=/queueHooks$/,db=[ib],eb={"*":[function(a,b){var c=this.createTween(a,b),d=c.cur(),e=bb.exec(b),f=e&&e[3]||(m.cssNumber[a]?"":"px"),g=(m.cssNumber[a]||"px"!==f&&+d)&&bb.exec(m.css(c.elem,a)),h=1,i=20;if(g&&g[3]!==f){f=f||g[3],e=e||[],g=+d||1;do h=h||".5",g/=h,m.style(c.elem,a,g+f);while(h!==(h=c.cur()/d)&&1!==h&&--i)}return e&&(g=c.start=+g||+d||0,c.unit=f,c.end=e[1]?g+(e[1]+1)*e[2]:+e[2]),c}]};function fb(){return setTimeout(function(){$a=void 0}),$a=m.now()}function gb(a,b){var c,d={height:a},e=0;for(b=b?1:0;4>e;e+=2-b)c=T[e],d["margin"+c]=d["padding"+c]=a;return b&&(d.opacity=d.width=a),d}function hb(a,b,c){for(var d,e=(eb[b]||[]).concat(eb["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function ib(a,b,c){var d,e,f,g,h,i,j,l,n=this,o={},p=a.style,q=a.nodeType&&U(a),r=m._data(a,"fxshow");c.queue||(h=m._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,n.always(function(){n.always(function(){h.unqueued--,m.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[p.overflow,p.overflowX,p.overflowY],j=m.css(a,"display"),l="none"===j?m._data(a,"olddisplay")||Fa(a.nodeName):j,"inline"===l&&"none"===m.css(a,"float")&&(k.inlineBlockNeedsLayout&&"inline"!==Fa(a.nodeName)?p.zoom=1:p.display="inline-block")),c.overflow&&(p.overflow="hidden",k.shrinkWrapBlocks()||n.always(function(){p.overflow=c.overflow[0],p.overflowX=c.overflow[1],p.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],ab.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(q?"hide":"show")){if("show"!==e||!r||void 0===r[d])continue;q=!0}o[d]=r&&r[d]||m.style(a,d)}else j=void 0;if(m.isEmptyObject(o))"inline"===("none"===j?Fa(a.nodeName):j)&&(p.display=j);else{r?"hidden"in r&&(q=r.hidden):r=m._data(a,"fxshow",{}),f&&(r.hidden=!q),q?m(a).show():n.done(function(){m(a).hide()}),n.done(function(){var b;m._removeData(a,"fxshow");for(b in o)m.style(a,b,o[b])});for(d in o)g=hb(q?r[d]:0,d,n),d in r||(r[d]=g.start,q&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function jb(a,b){var c,d,e,f,g;for(c in a)if(d=m.camelCase(c),e=b[d],f=a[c],m.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=m.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function kb(a,b,c){var d,e,f=0,g=db.length,h=m.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=$a||fb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:m.extend({},b),opts:m.extend(!0,{specialEasing:{}},c),originalProperties:b,originalOptions:c,startTime:$a||fb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=m.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?h.resolveWith(a,[j,b]):h.rejectWith(a,[j,b]),this}}),k=j.props;for(jb(k,j.opts.specialEasing);g>f;f++)if(d=db[f].call(j,a,k,j.opts))return d;return m.map(k,hb,j),m.isFunction(j.opts.start)&&j.opts.start.call(a,j),m.fx.timer(m.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}m.Animation=m.extend(kb,{tweener:function(a,b){m.isFunction(a)?(b=a,a=["*"]):a=a.split(" ");for(var c,d=0,e=a.length;e>d;d++)c=a[d],eb[c]=eb[c]||[],eb[c].unshift(b)},prefilter:function(a,b){b?db.unshift(a):db.push(a)}}),m.speed=function(a,b,c){var d=a&&"object"==typeof a?m.extend({},a):{complete:c||!c&&b||m.isFunction(a)&&a,duration:a,easing:c&&b||b&&!m.isFunction(b)&&b};return d.duration=m.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in m.fx.speeds?m.fx.speeds[d.duration]:m.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue="fx"),d.old=d.complete,d.complete=function(){m.isFunction(d.old)&&d.old.call(this),d.queue&&m.dequeue(this,d.queue)},d},m.fn.extend({fadeTo:function(a,b,c,d){return this.filter(U).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=m.isEmptyObject(a),f=m.speed(b,c,d),g=function(){var b=kb(this,m.extend({},a),f);(e||m._data(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=m.timers,g=m._data(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&cb.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&m.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=m._data(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=m.timers,g=d?d.length:0;for(c.finish=!0,m.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),m.each(["toggle","show","hide"],function(a,b){var c=m.fn[b];m.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(gb(b,!0),a,d,e)}}),m.each({slideDown:gb("show"),slideUp:gb("hide"),slideToggle:gb("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){m.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),m.timers=[],m.fx.tick=function(){var a,b=m.timers,c=0;for($a=m.now();c<b.length;c++)a=b[c],a()||b[c]!==a||b.splice(c--,1);b.length||m.fx.stop(),$a=void 0},m.fx.timer=function(a){m.timers.push(a),a()?m.fx.start():m.timers.pop()},m.fx.interval=13,m.fx.start=function(){_a||(_a=setInterval(m.fx.tick,m.fx.interval))},m.fx.stop=function(){clearInterval(_a),_a=null},m.fx.speeds={slow:600,fast:200,_default:400},m.fn.delay=function(a,b){return a=m.fx?m.fx.speeds[a]||a:a,b=b||"fx",this.queue(b,function(b,c){var d=setTimeout(b,a);c.stop=function(){clearTimeout(d)}})},function(){var a,b,c,d,e;b=y.createElement("div"),b.setAttribute("className","t"),b.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",d=b.getElementsByTagName("a")[0],c=y.createElement("select"),e=c.appendChild(y.createElement("option")),a=b.getElementsByTagName("input")[0],d.style.cssText="top:1px",k.getSetAttribute="t"!==b.className,k.style=/top/.test(d.getAttribute("style")),k.hrefNormalized="/a"===d.getAttribute("href"),k.checkOn=!!a.value,k.optSelected=e.selected,k.enctype=!!y.createElement("form").enctype,c.disabled=!0,k.optDisabled=!e.disabled,a=y.createElement("input"),a.setAttribute("value",""),k.input=""===a.getAttribute("value"),a.value="t",a.setAttribute("type","radio"),k.radioValue="t"===a.value}();var lb=/\r/g;m.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=m.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,m(this).val()):a,null==e?e="":"number"==typeof e?e+="":m.isArray(e)&&(e=m.map(e,function(a){return null==a?"":a+""})),b=m.valHooks[this.type]||m.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=m.valHooks[e.type]||m.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(lb,""):null==c?"":c)}}}),m.extend({valHooks:{option:{get:function(a){var b=m.find.attr(a,"value");return null!=b?b:m.trim(m.text(a))}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],!(!c.selected&&i!==e||(k.optDisabled?c.disabled:null!==c.getAttribute("disabled"))||c.parentNode.disabled&&m.nodeName(c.parentNode,"optgroup"))){if(b=m(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=m.makeArray(b),g=e.length;while(g--)if(d=e[g],m.inArray(m.valHooks.option.get(d),f)>=0)try{d.selected=c=!0}catch(h){d.scrollHeight}else d.selected=!1;return c||(a.selectedIndex=-1),e}}}}),m.each(["radio","checkbox"],function(){m.valHooks[this]={set:function(a,b){return m.isArray(b)?a.checked=m.inArray(m(a).val(),b)>=0:void 0}},k.checkOn||(m.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var mb,nb,ob=m.expr.attrHandle,pb=/^(?:checked|selected)$/i,qb=k.getSetAttribute,rb=k.input;m.fn.extend({attr:function(a,b){return V(this,m.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){m.removeAttr(this,a)})}}),m.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(a&&3!==f&&8!==f&&2!==f)return typeof a.getAttribute===K?m.prop(a,b,c):(1===f&&m.isXMLDoc(a)||(b=b.toLowerCase(),d=m.attrHooks[b]||(m.expr.match.bool.test(b)?nb:mb)),void 0===c?d&&"get"in d&&null!==(e=d.get(a,b))?e:(e=m.find.attr(a,b),null==e?void 0:e):null!==c?d&&"set"in d&&void 0!==(e=d.set(a,c,b))?e:(a.setAttribute(b,c+""),c):void m.removeAttr(a,b))},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(E);if(f&&1===a.nodeType)while(c=f[e++])d=m.propFix[c]||c,m.expr.match.bool.test(c)?rb&&qb||!pb.test(c)?a[d]=!1:a[m.camelCase("default-"+c)]=a[d]=!1:m.attr(a,c,""),a.removeAttribute(qb?c:d)},attrHooks:{type:{set:function(a,b){if(!k.radioValue&&"radio"===b&&m.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}}}),nb={set:function(a,b,c){return b===!1?m.removeAttr(a,c):rb&&qb||!pb.test(c)?a.setAttribute(!qb&&m.propFix[c]||c,c):a[m.camelCase("default-"+c)]=a[c]=!0,c}},m.each(m.expr.match.bool.source.match(/\w+/g),function(a,b){var c=ob[b]||m.find.attr;ob[b]=rb&&qb||!pb.test(b)?function(a,b,d){var e,f;return d||(f=ob[b],ob[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,ob[b]=f),e}:function(a,b,c){return c?void 0:a[m.camelCase("default-"+b)]?b.toLowerCase():null}}),rb&&qb||(m.attrHooks.value={set:function(a,b,c){return m.nodeName(a,"input")?void(a.defaultValue=b):mb&&mb.set(a,b,c)}}),qb||(mb={set:function(a,b,c){var d=a.getAttributeNode(c);return d||a.setAttributeNode(d=a.ownerDocument.createAttribute(c)),d.value=b+="","value"===c||b===a.getAttribute(c)?b:void 0}},ob.id=ob.name=ob.coords=function(a,b,c){var d;return c?void 0:(d=a.getAttributeNode(b))&&""!==d.value?d.value:null},m.valHooks.button={get:function(a,b){var c=a.getAttributeNode(b);return c&&c.specified?c.value:void 0},set:mb.set},m.attrHooks.contenteditable={set:function(a,b,c){mb.set(a,""===b?!1:b,c)}},m.each(["width","height"],function(a,b){m.attrHooks[b]={set:function(a,c){return""===c?(a.setAttribute(b,"auto"),c):void 0}}})),k.style||(m.attrHooks.style={get:function(a){return a.style.cssText||void 0},set:function(a,b){return a.style.cssText=b+""}});var sb=/^(?:input|select|textarea|button|object)$/i,tb=/^(?:a|area)$/i;m.fn.extend({prop:function(a,b){return V(this,m.prop,a,b,arguments.length>1)},removeProp:function(a){return a=m.propFix[a]||a,this.each(function(){try{this[a]=void 0,delete this[a]}catch(b){}})}}),m.extend({propFix:{"for":"htmlFor","class":"className"},prop:function(a,b,c){var d,e,f,g=a.nodeType;if(a&&3!==g&&8!==g&&2!==g)return f=1!==g||!m.isXMLDoc(a),f&&(b=m.propFix[b]||b,e=m.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=m.find.attr(a,"tabindex");return b?parseInt(b,10):sb.test(a.nodeName)||tb.test(a.nodeName)&&a.href?0:-1}}}}),k.hrefNormalized||m.each(["href","src"],function(a,b){m.propHooks[b]={get:function(a){return a.getAttribute(b,4)}}}),k.optSelected||(m.propHooks.selected={get:function(a){var b=a.parentNode;return b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex),null}}),m.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){m.propFix[this.toLowerCase()]=this}),k.enctype||(m.propFix.enctype="encoding");var ub=/[\t\r\n\f]/g;m.fn.extend({addClass:function(a){var b,c,d,e,f,g,h=0,i=this.length,j="string"==typeof a&&a;if(m.isFunction(a))return this.each(function(b){m(this).addClass(a.call(this,b,this.className))});if(j)for(b=(a||"").match(E)||[];i>h;h++)if(c=this[h],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ub," "):" ")){f=0;while(e=b[f++])d.indexOf(" "+e+" ")<0&&(d+=e+" ");g=m.trim(d),c.className!==g&&(c.className=g)}return this},removeClass:function(a){var b,c,d,e,f,g,h=0,i=this.length,j=0===arguments.length||"string"==typeof a&&a;if(m.isFunction(a))return this.each(function(b){m(this).removeClass(a.call(this,b,this.className))});if(j)for(b=(a||"").match(E)||[];i>h;h++)if(c=this[h],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ub," "):"")){f=0;while(e=b[f++])while(d.indexOf(" "+e+" ")>=0)d=d.replace(" "+e+" "," ");g=a?m.trim(d):"",c.className!==g&&(c.className=g)}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):this.each(m.isFunction(a)?function(c){m(this).toggleClass(a.call(this,c,this.className,b),b)}:function(){if("string"===c){var b,d=0,e=m(this),f=a.match(E)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(c===K||"boolean"===c)&&(this.className&&m._data(this,"__className__",this.className),this.className=this.className||a===!1?"":m._data(this,"__className__")||"")})},hasClass:function(a){for(var b=" "+a+" ",c=0,d=this.length;d>c;c++)if(1===this[c].nodeType&&(" "+this[c].className+" ").replace(ub," ").indexOf(b)>=0)return!0;return!1}}),m.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){m.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),m.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)},bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}});var vb=m.now(),wb=/\?/,xb=/(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;m.parseJSON=function(b){if(a.JSON&&a.JSON.parse)return a.JSON.parse(b+"");var c,d=null,e=m.trim(b+"");return e&&!m.trim(e.replace(xb,function(a,b,e,f){return c&&b&&(d=0),0===d?a:(c=e||b,d+=!f-!e,"")}))?Function("return "+e)():m.error("Invalid JSON: "+b)},m.parseXML=function(b){var c,d;if(!b||"string"!=typeof b)return null;try{a.DOMParser?(d=new DOMParser,c=d.parseFromString(b,"text/xml")):(c=new ActiveXObject("Microsoft.XMLDOM"),c.async="false",c.loadXML(b))}catch(e){c=void 0}return c&&c.documentElement&&!c.getElementsByTagName("parsererror").length||m.error("Invalid XML: "+b),c};var yb,zb,Ab=/#.*$/,Bb=/([?&])_=[^&]*/,Cb=/^(.*?):[ \t]*([^\r\n]*)\r?$/gm,Db=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Eb=/^(?:GET|HEAD)$/,Fb=/^\/\//,Gb=/^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,Hb={},Ib={},Jb="*/".concat("*");try{zb=location.href}catch(Kb){zb=y.createElement("a"),zb.href="",zb=zb.href}yb=Gb.exec(zb.toLowerCase())||[];function Lb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(E)||[];if(m.isFunction(c))while(d=f[e++])"+"===d.charAt(0)?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Mb(a,b,c,d){var e={},f=a===Ib;function g(h){var i;return e[h]=!0,m.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Nb(a,b){var c,d,e=m.ajaxSettings.flatOptions||{};for(d in b)void 0!==b[d]&&((e[d]?a:c||(c={}))[d]=b[d]);return c&&m.extend(!0,a,c),a}function Ob(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===e&&(e=a.mimeType||b.getResponseHeader("Content-Type"));if(e)for(g in h)if(h[g]&&h[g].test(e)){i.unshift(g);break}if(i[0]in c)f=i[0];else{for(g in c){if(!i[0]||a.converters[g+" "+i[0]]){f=g;break}d||(d=g)}f=f||d}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Pb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}m.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:zb,type:"GET",isLocal:Db.test(yb[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Jb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":m.parseJSON,"text xml":m.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Nb(Nb(a,m.ajaxSettings),b):Nb(m.ajaxSettings,a)},ajaxPrefilter:Lb(Hb),ajaxTransport:Lb(Ib),ajax:function(a,b){"object"==typeof a&&(b=a,a=void 0),b=b||{};var c,d,e,f,g,h,i,j,k=m.ajaxSetup({},b),l=k.context||k,n=k.context&&(l.nodeType||l.jquery)?m(l):m.event,o=m.Deferred(),p=m.Callbacks("once memory"),q=k.statusCode||{},r={},s={},t=0,u="canceled",v={readyState:0,getResponseHeader:function(a){var b;if(2===t){if(!j){j={};while(b=Cb.exec(f))j[b[1].toLowerCase()]=b[2]}b=j[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===t?f:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return t||(a=s[c]=s[c]||a,r[a]=b),this},overrideMimeType:function(a){return t||(k.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>t)for(b in a)q[b]=[q[b],a[b]];else v.always(a[v.status]);return this},abort:function(a){var b=a||u;return i&&i.abort(b),x(0,b),this}};if(o.promise(v).complete=p.add,v.success=v.done,v.error=v.fail,k.url=((a||k.url||zb)+"").replace(Ab,"").replace(Fb,yb[1]+"//"),k.type=b.method||b.type||k.method||k.type,k.dataTypes=m.trim(k.dataType||"*").toLowerCase().match(E)||[""],null==k.crossDomain&&(c=Gb.exec(k.url.toLowerCase()),k.crossDomain=!(!c||c[1]===yb[1]&&c[2]===yb[2]&&(c[3]||("http:"===c[1]?"80":"443"))===(yb[3]||("http:"===yb[1]?"80":"443")))),k.data&&k.processData&&"string"!=typeof k.data&&(k.data=m.param(k.data,k.traditional)),Mb(Hb,k,b,v),2===t)return v;h=m.event&&k.global,h&&0===m.active++&&m.event.trigger("ajaxStart"),k.type=k.type.toUpperCase(),k.hasContent=!Eb.test(k.type),e=k.url,k.hasContent||(k.data&&(e=k.url+=(wb.test(e)?"&":"?")+k.data,delete k.data),k.cache===!1&&(k.url=Bb.test(e)?e.replace(Bb,"$1_="+vb++):e+(wb.test(e)?"&":"?")+"_="+vb++)),k.ifModified&&(m.lastModified[e]&&v.setRequestHeader("If-Modified-Since",m.lastModified[e]),m.etag[e]&&v.setRequestHeader("If-None-Match",m.etag[e])),(k.data&&k.hasContent&&k.contentType!==!1||b.contentType)&&v.setRequestHeader("Content-Type",k.contentType),v.setRequestHeader("Accept",k.dataTypes[0]&&k.accepts[k.dataTypes[0]]?k.accepts[k.dataTypes[0]]+("*"!==k.dataTypes[0]?", "+Jb+"; q=0.01":""):k.accepts["*"]);for(d in k.headers)v.setRequestHeader(d,k.headers[d]);if(k.beforeSend&&(k.beforeSend.call(l,v,k)===!1||2===t))return v.abort();u="abort";for(d in{success:1,error:1,complete:1})v[d](k[d]);if(i=Mb(Ib,k,b,v)){v.readyState=1,h&&n.trigger("ajaxSend",[v,k]),k.async&&k.timeout>0&&(g=setTimeout(function(){v.abort("timeout")},k.timeout));try{t=1,i.send(r,x)}catch(w){if(!(2>t))throw w;x(-1,w)}}else x(-1,"No Transport");function x(a,b,c,d){var j,r,s,u,w,x=b;2!==t&&(t=2,g&&clearTimeout(g),i=void 0,f=d||"",v.readyState=a>0?4:0,j=a>=200&&300>a||304===a,c&&(u=Ob(k,v,c)),u=Pb(k,u,v,j),j?(k.ifModified&&(w=v.getResponseHeader("Last-Modified"),w&&(m.lastModified[e]=w),w=v.getResponseHeader("etag"),w&&(m.etag[e]=w)),204===a||"HEAD"===k.type?x="nocontent":304===a?x="notmodified":(x=u.state,r=u.data,s=u.error,j=!s)):(s=x,(a||!x)&&(x="error",0>a&&(a=0))),v.status=a,v.statusText=(b||x)+"",j?o.resolveWith(l,[r,x,v]):o.rejectWith(l,[v,x,s]),v.statusCode(q),q=void 0,h&&n.trigger(j?"ajaxSuccess":"ajaxError",[v,k,j?r:s]),p.fireWith(l,[v,x]),h&&(n.trigger("ajaxComplete",[v,k]),--m.active||m.event.trigger("ajaxStop")))}return v},getJSON:function(a,b,c){return m.get(a,b,c,"json")},getScript:function(a,b){return m.get(a,void 0,b,"script")}}),m.each(["get","post"],function(a,b){m[b]=function(a,c,d,e){return m.isFunction(c)&&(e=e||d,d=c,c=void 0),m.ajax({url:a,type:b,dataType:e,data:c,success:d})}}),m._evalUrl=function(a){return m.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},m.fn.extend({wrapAll:function(a){if(m.isFunction(a))return this.each(function(b){m(this).wrapAll(a.call(this,b))});if(this[0]){var b=m(a,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstChild&&1===a.firstChild.nodeType)a=a.firstChild;return a}).append(this)}return this},wrapInner:function(a){return this.each(m.isFunction(a)?function(b){m(this).wrapInner(a.call(this,b))}:function(){var b=m(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=m.isFunction(a);return this.each(function(c){m(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){m.nodeName(this,"body")||m(this).replaceWith(this.childNodes)}).end()}}),m.expr.filters.hidden=function(a){return a.offsetWidth<=0&&a.offsetHeight<=0||!k.reliableHiddenOffsets()&&"none"===(a.style&&a.style.display||m.css(a,"display"))},m.expr.filters.visible=function(a){return!m.expr.filters.hidden(a)};var Qb=/%20/g,Rb=/\[\]$/,Sb=/\r?\n/g,Tb=/^(?:submit|button|image|reset|file)$/i,Ub=/^(?:input|select|textarea|keygen)/i;function Vb(a,b,c,d){var e;if(m.isArray(b))m.each(b,function(b,e){c||Rb.test(a)?d(a,e):Vb(a+"["+("object"==typeof e?b:"")+"]",e,c,d)});else if(c||"object"!==m.type(b))d(a,b);else for(e in b)Vb(a+"["+e+"]",b[e],c,d)}m.param=function(a,b){var c,d=[],e=function(a,b){b=m.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=m.ajaxSettings&&m.ajaxSettings.traditional),m.isArray(a)||a.jquery&&!m.isPlainObject(a))m.each(a,function(){e(this.name,this.value)});else for(c in a)Vb(c,a[c],b,e);return d.join("&").replace(Qb,"+")},m.fn.extend({serialize:function(){return m.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=m.prop(this,"elements");return a?m.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!m(this).is(":disabled")&&Ub.test(this.nodeName)&&!Tb.test(a)&&(this.checked||!W.test(a))}).map(function(a,b){var c=m(this).val();return null==c?null:m.isArray(c)?m.map(c,function(a){return{name:b.name,value:a.replace(Sb,"\r\n")}}):{name:b.name,value:c.replace(Sb,"\r\n")}}).get()}}),m.ajaxSettings.xhr=void 0!==a.ActiveXObject?function(){return!this.isLocal&&/^(get|post|head|put|delete|options)$/i.test(this.type)&&Zb()||$b()}:Zb;var Wb=0,Xb={},Yb=m.ajaxSettings.xhr();a.attachEvent&&a.attachEvent("onunload",function(){for(var a in Xb)Xb[a](void 0,!0)}),k.cors=!!Yb&&"withCredentials"in Yb,Yb=k.ajax=!!Yb,Yb&&m.ajaxTransport(function(a){if(!a.crossDomain||k.cors){var b;return{send:function(c,d){var e,f=a.xhr(),g=++Wb;if(f.open(a.type,a.url,a.async,a.username,a.password),a.xhrFields)for(e in a.xhrFields)f[e]=a.xhrFields[e];a.mimeType&&f.overrideMimeType&&f.overrideMimeType(a.mimeType),a.crossDomain||c["X-Requested-With"]||(c["X-Requested-With"]="XMLHttpRequest");for(e in c)void 0!==c[e]&&f.setRequestHeader(e,c[e]+"");f.send(a.hasContent&&a.data||null),b=function(c,e){var h,i,j;if(b&&(e||4===f.readyState))if(delete Xb[g],b=void 0,f.onreadystatechange=m.noop,e)4!==f.readyState&&f.abort();else{j={},h=f.status,"string"==typeof f.responseText&&(j.text=f.responseText);try{i=f.statusText}catch(k){i=""}h||!a.isLocal||a.crossDomain?1223===h&&(h=204):h=j.text?200:404}j&&d(h,i,j,f.getAllResponseHeaders())},a.async?4===f.readyState?setTimeout(b):f.onreadystatechange=Xb[g]=b:b()},abort:function(){b&&b(void 0,!0)}}}});function Zb(){try{return new a.XMLHttpRequest}catch(b){}}function $b(){try{return new a.ActiveXObject("Microsoft.XMLHTTP")}catch(b){}}m.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(a){return m.globalEval(a),a}}}),m.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET",a.global=!1)}),m.ajaxTransport("script",function(a){if(a.crossDomain){var b,c=y.head||m("head")[0]||y.documentElement;return{send:function(d,e){b=y.createElement("script"),b.async=!0,a.scriptCharset&&(b.charset=a.scriptCharset),b.src=a.url,b.onload=b.onreadystatechange=function(a,c){(c||!b.readyState||/loaded|complete/.test(b.readyState))&&(b.onload=b.onreadystatechange=null,b.parentNode&&b.parentNode.removeChild(b),b=null,c||e(200,"success"))},c.insertBefore(b,c.firstChild)},abort:function(){b&&b.onload(void 0,!0)}}}});var _b=[],ac=/(=)\?(?=&|$)|\?\?/;m.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=_b.pop()||m.expando+"_"+vb++;return this[a]=!0,a}}),m.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(ac.test(b.url)?"url":"string"==typeof b.data&&!(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&ac.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=m.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(ac,"$1"+e):b.jsonp!==!1&&(b.url+=(wb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||m.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,_b.push(e)),g&&m.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),m.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||y;var d=u.exec(a),e=!c&&[];return d?[b.createElement(d[1])]:(d=m.buildFragment([a],b,e),e&&e.length&&m(e).remove(),m.merge([],d.childNodes))};var bc=m.fn.load;m.fn.load=function(a,b,c){if("string"!=typeof a&&bc)return bc.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>=0&&(d=m.trim(a.slice(h,a.length)),a=a.slice(0,h)),m.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(f="POST"),g.length>0&&m.ajax({url:a,type:f,dataType:"html",data:b}).done(function(a){e=arguments,g.html(d?m("<div>").append(m.parseHTML(a)).find(d):a)}).complete(c&&function(a,b){g.each(c,e||[a.responseText,b,a])}),this},m.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){m.fn[b]=function(a){return this.on(b,a)}}),m.expr.filters.animated=function(a){return m.grep(m.timers,function(b){return a===b.elem}).length};var cc=a.document.documentElement;function dc(a){return m.isWindow(a)?a:9===a.nodeType?a.defaultView||a.parentWindow:!1}m.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=m.css(a,"position"),l=m(a),n={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=m.css(a,"top"),i=m.css(a,"left"),j=("absolute"===k||"fixed"===k)&&m.inArray("auto",[f,i])>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),m.isFunction(b)&&(b=b.call(a,c,h)),null!=b.top&&(n.top=b.top-h.top+g),null!=b.left&&(n.left=b.left-h.left+e),"using"in b?b.using.call(a,n):l.css(n)}},m.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){m.offset.setOffset(this,a,b)});var b,c,d={top:0,left:0},e=this[0],f=e&&e.ownerDocument;if(f)return b=f.documentElement,m.contains(b,e)?(typeof e.getBoundingClientRect!==K&&(d=e.getBoundingClientRect()),c=dc(f),{top:d.top+(c.pageYOffset||b.scrollTop)-(b.clientTop||0),left:d.left+(c.pageXOffset||b.scrollLeft)-(b.clientLeft||0)}):d},position:function(){if(this[0]){var a,b,c={top:0,left:0},d=this[0];return"fixed"===m.css(d,"position")?b=d.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),m.nodeName(a[0],"html")||(c=a.offset()),c.top+=m.css(a[0],"borderTopWidth",!0),c.left+=m.css(a[0],"borderLeftWidth",!0)),{top:b.top-c.top-m.css(d,"marginTop",!0),left:b.left-c.left-m.css(d,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent||cc;while(a&&!m.nodeName(a,"html")&&"static"===m.css(a,"position"))a=a.offsetParent;return a||cc})}}),m.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c=/Y/.test(b);m.fn[a]=function(d){return V(this,function(a,d,e){var f=dc(a);return void 0===e?f?b in f?f[b]:f.document.documentElement[d]:a[d]:void(f?f.scrollTo(c?m(f).scrollLeft():e,c?e:m(f).scrollTop()):a[d]=e)},a,d,arguments.length,null)}}),m.each(["top","left"],function(a,b){m.cssHooks[b]=La(k.pixelPosition,function(a,c){return c?(c=Ja(a,b),Ha.test(c)?m(a).position()[b]+"px":c):void 0})}),m.each({Height:"height",Width:"width"},function(a,b){m.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){m.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return V(this,function(b,c,d){var e;return m.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?m.css(b,c,g):m.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),m.fn.size=function(){return this.length},m.fn.andSelf=m.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return m});var ec=a.jQuery,fc=a.$;return m.noConflict=function(b){return a.$===m&&(a.$=fc),b&&a.jQuery===m&&(a.jQuery=ec),m},typeof b===K&&(a.jQuery=a.$=m),m});
//# sourceMappingURL=jquery.min.map

/*!
 * slick.min.js Inline
 */

!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button"></button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button"></button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"-1"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex","-1");e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",-1).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

/*!
 * Isotope PACKAGED v3.0.6
 *
 * Licensed GPLv3 for open source use
 * or Isotope Commercial License for commercial use
 *
 * https://isotope.metafizzy.co
 * Copyright 2010-2018 Metafizzy
 */

!function(t,e){"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("jquery")):t.jQueryBridget=e(t,t.jQuery)}(window,function(t,e){"use strict";function i(i,s,a){function u(t,e,o){var n,s="$()."+i+'("'+e+'")';return t.each(function(t,u){var h=a.data(u,i);if(!h)return void r(i+" not initialized. Cannot call methods, i.e. "+s);var d=h[e];if(!d||"_"==e.charAt(0))return void r(s+" is not a valid method");var l=d.apply(h,o);n=void 0===n?l:n}),void 0!==n?n:t}function h(t,e){t.each(function(t,o){var n=a.data(o,i);n?(n.option(e),n._init()):(n=new s(o,e),a.data(o,i,n))})}a=a||e||t.jQuery,a&&(s.prototype.option||(s.prototype.option=function(t){a.isPlainObject(t)&&(this.options=a.extend(!0,this.options,t))}),a.fn[i]=function(t){if("string"==typeof t){var e=n.call(arguments,1);return u(this,t,e)}return h(this,t),this},o(a))}function o(t){!t||t&&t.bridget||(t.bridget=i)}var n=Array.prototype.slice,s=t.console,r="undefined"==typeof s?function(){}:function(t){s.error(t)};return o(e||t.jQuery),i}),function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},o=i[t]=i[t]||[];return o.indexOf(e)==-1&&o.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},o=i[t]=i[t]||{};return o[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var o=i.indexOf(e);return o!=-1&&i.splice(o,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){i=i.slice(0),e=e||[];for(var o=this._onceEvents&&this._onceEvents[t],n=0;n<i.length;n++){var s=i[n],r=o&&o[s];r&&(this.off(t,s),delete o[s]),s.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t}),function(t,e){"function"==typeof define&&define.amd?define("get-size/get-size",e):"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,function(){"use strict";function t(t){var e=parseFloat(t),i=t.indexOf("%")==-1&&!isNaN(e);return i&&e}function e(){}function i(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0;e<h;e++){var i=u[e];t[i]=0}return t}function o(t){var e=getComputedStyle(t);return e||a("Style returned "+e+". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),e}function n(){if(!d){d=!0;var e=document.createElement("div");e.style.width="200px",e.style.padding="1px 2px 3px 4px",e.style.borderStyle="solid",e.style.borderWidth="1px 2px 3px 4px",e.style.boxSizing="border-box";var i=document.body||document.documentElement;i.appendChild(e);var n=o(e);r=200==Math.round(t(n.width)),s.isBoxSizeOuter=r,i.removeChild(e)}}function s(e){if(n(),"string"==typeof e&&(e=document.querySelector(e)),e&&"object"==typeof e&&e.nodeType){var s=o(e);if("none"==s.display)return i();var a={};a.width=e.offsetWidth,a.height=e.offsetHeight;for(var d=a.isBorderBox="border-box"==s.boxSizing,l=0;l<h;l++){var f=u[l],c=s[f],m=parseFloat(c);a[f]=isNaN(m)?0:m}var p=a.paddingLeft+a.paddingRight,y=a.paddingTop+a.paddingBottom,g=a.marginLeft+a.marginRight,v=a.marginTop+a.marginBottom,_=a.borderLeftWidth+a.borderRightWidth,z=a.borderTopWidth+a.borderBottomWidth,I=d&&r,x=t(s.width);x!==!1&&(a.width=x+(I?0:p+_));var S=t(s.height);return S!==!1&&(a.height=S+(I?0:y+z)),a.innerWidth=a.width-(p+_),a.innerHeight=a.height-(y+z),a.outerWidth=a.width+g,a.outerHeight=a.height+v,a}}var r,a="undefined"==typeof console?e:function(t){console.error(t)},u=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],h=u.length,d=!1;return s}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,function(){"use strict";var t=function(){var t=window.Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var o=e[i],n=o+"MatchesSelector";if(t[n])return n}}();return function(e,i){return e[t](i)}}),function(t,e){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("desandro-matches-selector")):t.fizzyUIUtils=e(t,t.matchesSelector)}(window,function(t,e){var i={};i.extend=function(t,e){for(var i in e)t[i]=e[i];return t},i.modulo=function(t,e){return(t%e+e)%e};var o=Array.prototype.slice;i.makeArray=function(t){if(Array.isArray(t))return t;if(null===t||void 0===t)return[];var e="object"==typeof t&&"number"==typeof t.length;return e?o.call(t):[t]},i.removeFrom=function(t,e){var i=t.indexOf(e);i!=-1&&t.splice(i,1)},i.getParent=function(t,i){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,e(t,i))return t},i.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.filterFindElements=function(t,o){t=i.makeArray(t);var n=[];return t.forEach(function(t){if(t instanceof HTMLElement){if(!o)return void n.push(t);e(t,o)&&n.push(t);for(var i=t.querySelectorAll(o),s=0;s<i.length;s++)n.push(i[s])}}),n},i.debounceMethod=function(t,e,i){i=i||100;var o=t.prototype[e],n=e+"Timeout";t.prototype[e]=function(){var t=this[n];clearTimeout(t);var e=arguments,s=this;this[n]=setTimeout(function(){o.apply(s,e),delete s[n]},i)}},i.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},i.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var n=t.console;return i.htmlInit=function(e,o){i.docReady(function(){var s=i.toDashed(o),r="data-"+s,a=document.querySelectorAll("["+r+"]"),u=document.querySelectorAll(".js-"+s),h=i.makeArray(a).concat(i.makeArray(u)),d=r+"-options",l=t.jQuery;h.forEach(function(t){var i,s=t.getAttribute(r)||t.getAttribute(d);try{i=s&&JSON.parse(s)}catch(a){return void(n&&n.error("Error parsing "+r+" on "+t.className+": "+a))}var u=new e(t,i);l&&l.data(t,o,u)})})},i}),function(t,e){"function"==typeof define&&define.amd?define("outlayer/item",["ev-emitter/ev-emitter","get-size/get-size"],e):"object"==typeof module&&module.exports?module.exports=e(require("ev-emitter"),require("get-size")):(t.Outlayer={},t.Outlayer.Item=e(t.EvEmitter,t.getSize))}(window,function(t,e){"use strict";function i(t){for(var e in t)return!1;return e=null,!0}function o(t,e){t&&(this.element=t,this.layout=e,this.position={x:0,y:0},this._create())}function n(t){return t.replace(/([A-Z])/g,function(t){return"-"+t.toLowerCase()})}var s=document.documentElement.style,r="string"==typeof s.transition?"transition":"WebkitTransition",a="string"==typeof s.transform?"transform":"WebkitTransform",u={WebkitTransition:"webkitTransitionEnd",transition:"transitionend"}[r],h={transform:a,transition:r,transitionDuration:r+"Duration",transitionProperty:r+"Property",transitionDelay:r+"Delay"},d=o.prototype=Object.create(t.prototype);d.constructor=o,d._create=function(){this._transn={ingProperties:{},clean:{},onEnd:{}},this.css({position:"absolute"})},d.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},d.getSize=function(){this.size=e(this.element)},d.css=function(t){var e=this.element.style;for(var i in t){var o=h[i]||i;e[o]=t[i]}},d.getPosition=function(){var t=getComputedStyle(this.element),e=this.layout._getOption("originLeft"),i=this.layout._getOption("originTop"),o=t[e?"left":"right"],n=t[i?"top":"bottom"],s=parseFloat(o),r=parseFloat(n),a=this.layout.size;o.indexOf("%")!=-1&&(s=s/100*a.width),n.indexOf("%")!=-1&&(r=r/100*a.height),s=isNaN(s)?0:s,r=isNaN(r)?0:r,s-=e?a.paddingLeft:a.paddingRight,r-=i?a.paddingTop:a.paddingBottom,this.position.x=s,this.position.y=r},d.layoutPosition=function(){var t=this.layout.size,e={},i=this.layout._getOption("originLeft"),o=this.layout._getOption("originTop"),n=i?"paddingLeft":"paddingRight",s=i?"left":"right",r=i?"right":"left",a=this.position.x+t[n];e[s]=this.getXValue(a),e[r]="";var u=o?"paddingTop":"paddingBottom",h=o?"top":"bottom",d=o?"bottom":"top",l=this.position.y+t[u];e[h]=this.getYValue(l),e[d]="",this.css(e),this.emitEvent("layout",[this])},d.getXValue=function(t){var e=this.layout._getOption("horizontal");return this.layout.options.percentPosition&&!e?t/this.layout.size.width*100+"%":t+"px"},d.getYValue=function(t){var e=this.layout._getOption("horizontal");return this.layout.options.percentPosition&&e?t/this.layout.size.height*100+"%":t+"px"},d._transitionTo=function(t,e){this.getPosition();var i=this.position.x,o=this.position.y,n=t==this.position.x&&e==this.position.y;if(this.setPosition(t,e),n&&!this.isTransitioning)return void this.layoutPosition();var s=t-i,r=e-o,a={};a.transform=this.getTranslate(s,r),this.transition({to:a,onTransitionEnd:{transform:this.layoutPosition},isCleaning:!0})},d.getTranslate=function(t,e){var i=this.layout._getOption("originLeft"),o=this.layout._getOption("originTop");return t=i?t:-t,e=o?e:-e,"translate3d("+t+"px, "+e+"px, 0)"},d.goTo=function(t,e){this.setPosition(t,e),this.layoutPosition()},d.moveTo=d._transitionTo,d.setPosition=function(t,e){this.position.x=parseFloat(t),this.position.y=parseFloat(e)},d._nonTransition=function(t){this.css(t.to),t.isCleaning&&this._removeStyles(t.to);for(var e in t.onTransitionEnd)t.onTransitionEnd[e].call(this)},d.transition=function(t){if(!parseFloat(this.layout.options.transitionDuration))return void this._nonTransition(t);var e=this._transn;for(var i in t.onTransitionEnd)e.onEnd[i]=t.onTransitionEnd[i];for(i in t.to)e.ingProperties[i]=!0,t.isCleaning&&(e.clean[i]=!0);if(t.from){this.css(t.from);var o=this.element.offsetHeight;o=null}this.enableTransition(t.to),this.css(t.to),this.isTransitioning=!0};var l="opacity,"+n(a);d.enableTransition=function(){if(!this.isTransitioning){var t=this.layout.options.transitionDuration;t="number"==typeof t?t+"ms":t,this.css({transitionProperty:l,transitionDuration:t,transitionDelay:this.staggerDelay||0}),this.element.addEventListener(u,this,!1)}},d.onwebkitTransitionEnd=function(t){this.ontransitionend(t)},d.onotransitionend=function(t){this.ontransitionend(t)};var f={"-webkit-transform":"transform"};d.ontransitionend=function(t){if(t.target===this.element){var e=this._transn,o=f[t.propertyName]||t.propertyName;if(delete e.ingProperties[o],i(e.ingProperties)&&this.disableTransition(),o in e.clean&&(this.element.style[t.propertyName]="",delete e.clean[o]),o in e.onEnd){var n=e.onEnd[o];n.call(this),delete e.onEnd[o]}this.emitEvent("transitionEnd",[this])}},d.disableTransition=function(){this.removeTransitionStyles(),this.element.removeEventListener(u,this,!1),this.isTransitioning=!1},d._removeStyles=function(t){var e={};for(var i in t)e[i]="";this.css(e)};var c={transitionProperty:"",transitionDuration:"",transitionDelay:""};return d.removeTransitionStyles=function(){this.css(c)},d.stagger=function(t){t=isNaN(t)?0:t,this.staggerDelay=t+"ms"},d.removeElem=function(){this.element.parentNode.removeChild(this.element),this.css({display:""}),this.emitEvent("remove",[this])},d.remove=function(){return r&&parseFloat(this.layout.options.transitionDuration)?(this.once("transitionEnd",function(){this.removeElem()}),void this.hide()):void this.removeElem()},d.reveal=function(){delete this.isHidden,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("visibleStyle");e[i]=this.onRevealTransitionEnd,this.transition({from:t.hiddenStyle,to:t.visibleStyle,isCleaning:!0,onTransitionEnd:e})},d.onRevealTransitionEnd=function(){this.isHidden||this.emitEvent("reveal")},d.getHideRevealTransitionEndProperty=function(t){var e=this.layout.options[t];if(e.opacity)return"opacity";for(var i in e)return i},d.hide=function(){this.isHidden=!0,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("hiddenStyle");e[i]=this.onHideTransitionEnd,this.transition({from:t.visibleStyle,to:t.hiddenStyle,isCleaning:!0,onTransitionEnd:e})},d.onHideTransitionEnd=function(){this.isHidden&&(this.css({display:"none"}),this.emitEvent("hide"))},d.destroy=function(){this.css({position:"",left:"",right:"",top:"",bottom:"",transition:"",transform:""})},o}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("outlayer/outlayer",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./item"],function(i,o,n,s){return e(t,i,o,n,s)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./item")):t.Outlayer=e(t,t.EvEmitter,t.getSize,t.fizzyUIUtils,t.Outlayer.Item)}(window,function(t,e,i,o,n){"use strict";function s(t,e){var i=o.getQueryElement(t);if(!i)return void(u&&u.error("Bad element for "+this.constructor.namespace+": "+(i||t)));this.element=i,h&&(this.$element=h(this.element)),this.options=o.extend({},this.constructor.defaults),this.option(e);var n=++l;this.element.outlayerGUID=n,f[n]=this,this._create();var s=this._getOption("initLayout");s&&this.layout()}function r(t){function e(){t.apply(this,arguments)}return e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e}function a(t){if("number"==typeof t)return t;var e=t.match(/(^\d*\.?\d*)(\w*)/),i=e&&e[1],o=e&&e[2];if(!i.length)return 0;i=parseFloat(i);var n=m[o]||1;return i*n}var u=t.console,h=t.jQuery,d=function(){},l=0,f={};s.namespace="outlayer",s.Item=n,s.defaults={containerStyle:{position:"relative"},initLayout:!0,originLeft:!0,originTop:!0,resize:!0,resizeContainer:!0,transitionDuration:"0.4s",hiddenStyle:{opacity:0,transform:"scale(0.001)"},visibleStyle:{opacity:1,transform:"scale(1)"}};var c=s.prototype;o.extend(c,e.prototype),c.option=function(t){o.extend(this.options,t)},c._getOption=function(t){var e=this.constructor.compatOptions[t];return e&&void 0!==this.options[e]?this.options[e]:this.options[t]},s.compatOptions={initLayout:"isInitLayout",horizontal:"isHorizontal",layoutInstant:"isLayoutInstant",originLeft:"isOriginLeft",originTop:"isOriginTop",resize:"isResizeBound",resizeContainer:"isResizingContainer"},c._create=function(){this.reloadItems(),this.stamps=[],this.stamp(this.options.stamp),o.extend(this.element.style,this.options.containerStyle);var t=this._getOption("resize");t&&this.bindResize()},c.reloadItems=function(){this.items=this._itemize(this.element.children)},c._itemize=function(t){for(var e=this._filterFindItemElements(t),i=this.constructor.Item,o=[],n=0;n<e.length;n++){var s=e[n],r=new i(s,this);o.push(r)}return o},c._filterFindItemElements=function(t){return o.filterFindElements(t,this.options.itemSelector)},c.getItemElements=function(){return this.items.map(function(t){return t.element})},c.layout=function(){this._resetLayout(),this._manageStamps();var t=this._getOption("layoutInstant"),e=void 0!==t?t:!this._isLayoutInited;this.layoutItems(this.items,e),this._isLayoutInited=!0},c._init=c.layout,c._resetLayout=function(){this.getSize()},c.getSize=function(){this.size=i(this.element)},c._getMeasurement=function(t,e){var o,n=this.options[t];n?("string"==typeof n?o=this.element.querySelector(n):n instanceof HTMLElement&&(o=n),this[t]=o?i(o)[e]:n):this[t]=0},c.layoutItems=function(t,e){t=this._getItemsForLayout(t),this._layoutItems(t,e),this._postLayout()},c._getItemsForLayout=function(t){return t.filter(function(t){return!t.isIgnored})},c._layoutItems=function(t,e){if(this._emitCompleteOnItems("layout",t),t&&t.length){var i=[];t.forEach(function(t){var o=this._getItemLayoutPosition(t);o.item=t,o.isInstant=e||t.isLayoutInstant,i.push(o)},this),this._processLayoutQueue(i)}},c._getItemLayoutPosition=function(){return{x:0,y:0}},c._processLayoutQueue=function(t){this.updateStagger(),t.forEach(function(t,e){this._positionItem(t.item,t.x,t.y,t.isInstant,e)},this)},c.updateStagger=function(){var t=this.options.stagger;return null===t||void 0===t?void(this.stagger=0):(this.stagger=a(t),this.stagger)},c._positionItem=function(t,e,i,o,n){o?t.goTo(e,i):(t.stagger(n*this.stagger),t.moveTo(e,i))},c._postLayout=function(){this.resizeContainer()},c.resizeContainer=function(){var t=this._getOption("resizeContainer");if(t){var e=this._getContainerSize();e&&(this._setContainerMeasure(e.width,!0),this._setContainerMeasure(e.height,!1))}},c._getContainerSize=d,c._setContainerMeasure=function(t,e){if(void 0!==t){var i=this.size;i.isBorderBox&&(t+=e?i.paddingLeft+i.paddingRight+i.borderLeftWidth+i.borderRightWidth:i.paddingBottom+i.paddingTop+i.borderTopWidth+i.borderBottomWidth),t=Math.max(t,0),this.element.style[e?"width":"height"]=t+"px"}},c._emitCompleteOnItems=function(t,e){function i(){n.dispatchEvent(t+"Complete",null,[e])}function o(){r++,r==s&&i()}var n=this,s=e.length;if(!e||!s)return void i();var r=0;e.forEach(function(e){e.once(t,o)})},c.dispatchEvent=function(t,e,i){var o=e?[e].concat(i):i;if(this.emitEvent(t,o),h)if(this.$element=this.$element||h(this.element),e){var n=h.Event(e);n.type=t,this.$element.trigger(n,i)}else this.$element.trigger(t,i)},c.ignore=function(t){var e=this.getItem(t);e&&(e.isIgnored=!0)},c.unignore=function(t){var e=this.getItem(t);e&&delete e.isIgnored},c.stamp=function(t){t=this._find(t),t&&(this.stamps=this.stamps.concat(t),t.forEach(this.ignore,this))},c.unstamp=function(t){t=this._find(t),t&&t.forEach(function(t){o.removeFrom(this.stamps,t),this.unignore(t)},this)},c._find=function(t){if(t)return"string"==typeof t&&(t=this.element.querySelectorAll(t)),t=o.makeArray(t)},c._manageStamps=function(){this.stamps&&this.stamps.length&&(this._getBoundingRect(),this.stamps.forEach(this._manageStamp,this))},c._getBoundingRect=function(){var t=this.element.getBoundingClientRect(),e=this.size;this._boundingRect={left:t.left+e.paddingLeft+e.borderLeftWidth,top:t.top+e.paddingTop+e.borderTopWidth,right:t.right-(e.paddingRight+e.borderRightWidth),bottom:t.bottom-(e.paddingBottom+e.borderBottomWidth)}},c._manageStamp=d,c._getElementOffset=function(t){var e=t.getBoundingClientRect(),o=this._boundingRect,n=i(t),s={left:e.left-o.left-n.marginLeft,top:e.top-o.top-n.marginTop,right:o.right-e.right-n.marginRight,bottom:o.bottom-e.bottom-n.marginBottom};return s},c.handleEvent=o.handleEvent,c.bindResize=function(){t.addEventListener("resize",this),this.isResizeBound=!0},c.unbindResize=function(){t.removeEventListener("resize",this),this.isResizeBound=!1},c.onresize=function(){this.resize()},o.debounceMethod(s,"onresize",100),c.resize=function(){this.isResizeBound&&this.needsResizeLayout()&&this.layout()},c.needsResizeLayout=function(){var t=i(this.element),e=this.size&&t;return e&&t.innerWidth!==this.size.innerWidth},c.addItems=function(t){var e=this._itemize(t);return e.length&&(this.items=this.items.concat(e)),e},c.appended=function(t){var e=this.addItems(t);e.length&&(this.layoutItems(e,!0),this.reveal(e))},c.prepended=function(t){var e=this._itemize(t);if(e.length){var i=this.items.slice(0);this.items=e.concat(i),this._resetLayout(),this._manageStamps(),this.layoutItems(e,!0),this.reveal(e),this.layoutItems(i)}},c.reveal=function(t){if(this._emitCompleteOnItems("reveal",t),t&&t.length){var e=this.updateStagger();t.forEach(function(t,i){t.stagger(i*e),t.reveal()})}},c.hide=function(t){if(this._emitCompleteOnItems("hide",t),t&&t.length){var e=this.updateStagger();t.forEach(function(t,i){t.stagger(i*e),t.hide()})}},c.revealItemElements=function(t){var e=this.getItems(t);this.reveal(e)},c.hideItemElements=function(t){var e=this.getItems(t);this.hide(e)},c.getItem=function(t){for(var e=0;e<this.items.length;e++){var i=this.items[e];if(i.element==t)return i}},c.getItems=function(t){t=o.makeArray(t);var e=[];return t.forEach(function(t){var i=this.getItem(t);i&&e.push(i)},this),e},c.remove=function(t){var e=this.getItems(t);this._emitCompleteOnItems("remove",e),e&&e.length&&e.forEach(function(t){t.remove(),o.removeFrom(this.items,t)},this)},c.destroy=function(){var t=this.element.style;t.height="",t.position="",t.width="",this.items.forEach(function(t){t.destroy()}),this.unbindResize();var e=this.element.outlayerGUID;delete f[e],delete this.element.outlayerGUID,h&&h.removeData(this.element,this.constructor.namespace)},s.data=function(t){t=o.getQueryElement(t);var e=t&&t.outlayerGUID;return e&&f[e]},s.create=function(t,e){var i=r(s);return i.defaults=o.extend({},s.defaults),o.extend(i.defaults,e),i.compatOptions=o.extend({},s.compatOptions),i.namespace=t,i.data=s.data,i.Item=r(n),o.htmlInit(i,t),h&&h.bridget&&h.bridget(t,i),i};var m={ms:1,s:1e3};return s.Item=n,s}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/item",["outlayer/outlayer"],e):"object"==typeof module&&module.exports?module.exports=e(require("outlayer")):(t.Isotope=t.Isotope||{},t.Isotope.Item=e(t.Outlayer))}(window,function(t){"use strict";function e(){t.Item.apply(this,arguments)}var i=e.prototype=Object.create(t.Item.prototype),o=i._create;i._create=function(){this.id=this.layout.itemGUID++,o.call(this),this.sortData={}},i.updateSortData=function(){if(!this.isIgnored){this.sortData.id=this.id,this.sortData["original-order"]=this.id,this.sortData.random=Math.random();var t=this.layout.options.getSortData,e=this.layout._sorters;for(var i in t){var o=e[i];this.sortData[i]=o(this.element,this)}}};var n=i.destroy;return i.destroy=function(){n.apply(this,arguments),this.css({display:""})},e}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-mode",["get-size/get-size","outlayer/outlayer"],e):"object"==typeof module&&module.exports?module.exports=e(require("get-size"),require("outlayer")):(t.Isotope=t.Isotope||{},t.Isotope.LayoutMode=e(t.getSize,t.Outlayer))}(window,function(t,e){"use strict";function i(t){this.isotope=t,t&&(this.options=t.options[this.namespace],this.element=t.element,this.items=t.filteredItems,this.size=t.size)}var o=i.prototype,n=["_resetLayout","_getItemLayoutPosition","_manageStamp","_getContainerSize","_getElementOffset","needsResizeLayout","_getOption"];return n.forEach(function(t){o[t]=function(){return e.prototype[t].apply(this.isotope,arguments)}}),o.needsVerticalResizeLayout=function(){var e=t(this.isotope.element),i=this.isotope.size&&e;return i&&e.innerHeight!=this.isotope.size.innerHeight},o._getMeasurement=function(){this.isotope._getMeasurement.apply(this,arguments)},o.getColumnWidth=function(){this.getSegmentSize("column","Width")},o.getRowHeight=function(){this.getSegmentSize("row","Height")},o.getSegmentSize=function(t,e){var i=t+e,o="outer"+e;if(this._getMeasurement(i,o),!this[i]){var n=this.getFirstItemSize();this[i]=n&&n[o]||this.isotope.size["inner"+e]}},o.getFirstItemSize=function(){var e=this.isotope.filteredItems[0];return e&&e.element&&t(e.element)},o.layout=function(){this.isotope.layout.apply(this.isotope,arguments)},o.getSize=function(){this.isotope.getSize(),this.size=this.isotope.size},i.modes={},i.create=function(t,e){function n(){i.apply(this,arguments)}return n.prototype=Object.create(o),n.prototype.constructor=n,e&&(n.options=e),n.prototype.namespace=t,i.modes[t]=n,n},i}),function(t,e){"function"==typeof define&&define.amd?define("masonry-layout/masonry",["outlayer/outlayer","get-size/get-size"],e):"object"==typeof module&&module.exports?module.exports=e(require("outlayer"),require("get-size")):t.Masonry=e(t.Outlayer,t.getSize)}(window,function(t,e){var i=t.create("masonry");i.compatOptions.fitWidth="isFitWidth";var o=i.prototype;return o._resetLayout=function(){this.getSize(),this._getMeasurement("columnWidth","outerWidth"),this._getMeasurement("gutter","outerWidth"),this.measureColumns(),this.colYs=[];for(var t=0;t<this.cols;t++)this.colYs.push(0);this.maxY=0,this.horizontalColIndex=0},o.measureColumns=function(){if(this.getContainerWidth(),!this.columnWidth){var t=this.items[0],i=t&&t.element;this.columnWidth=i&&e(i).outerWidth||this.containerWidth}var o=this.columnWidth+=this.gutter,n=this.containerWidth+this.gutter,s=n/o,r=o-n%o,a=r&&r<1?"round":"floor";s=Math[a](s),this.cols=Math.max(s,1)},o.getContainerWidth=function(){var t=this._getOption("fitWidth"),i=t?this.element.parentNode:this.element,o=e(i);this.containerWidth=o&&o.innerWidth},o._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth%this.columnWidth,i=e&&e<1?"round":"ceil",o=Math[i](t.size.outerWidth/this.columnWidth);o=Math.min(o,this.cols);for(var n=this.options.horizontalOrder?"_getHorizontalColPosition":"_getTopColPosition",s=this[n](o,t),r={x:this.columnWidth*s.col,y:s.y},a=s.y+t.size.outerHeight,u=o+s.col,h=s.col;h<u;h++)this.colYs[h]=a;return r},o._getTopColPosition=function(t){var e=this._getTopColGroup(t),i=Math.min.apply(Math,e);return{col:e.indexOf(i),y:i}},o._getTopColGroup=function(t){if(t<2)return this.colYs;for(var e=[],i=this.cols+1-t,o=0;o<i;o++)e[o]=this._getColGroupY(o,t);return e},o._getColGroupY=function(t,e){if(e<2)return this.colYs[t];var i=this.colYs.slice(t,t+e);return Math.max.apply(Math,i)},o._getHorizontalColPosition=function(t,e){var i=this.horizontalColIndex%this.cols,o=t>1&&i+t>this.cols;i=o?0:i;var n=e.size.outerWidth&&e.size.outerHeight;return this.horizontalColIndex=n?i+t:this.horizontalColIndex,{col:i,y:this._getColGroupY(i,t)}},o._manageStamp=function(t){var i=e(t),o=this._getElementOffset(t),n=this._getOption("originLeft"),s=n?o.left:o.right,r=s+i.outerWidth,a=Math.floor(s/this.columnWidth);a=Math.max(0,a);var u=Math.floor(r/this.columnWidth);u-=r%this.columnWidth?0:1,u=Math.min(this.cols-1,u);for(var h=this._getOption("originTop"),d=(h?o.top:o.bottom)+i.outerHeight,l=a;l<=u;l++)this.colYs[l]=Math.max(d,this.colYs[l])},o._getContainerSize=function(){this.maxY=Math.max.apply(Math,this.colYs);var t={height:this.maxY};return this._getOption("fitWidth")&&(t.width=this._getContainerFitWidth()),t},o._getContainerFitWidth=function(){for(var t=0,e=this.cols;--e&&0===this.colYs[e];)t++;return(this.cols-t)*this.columnWidth-this.gutter},o.needsResizeLayout=function(){var t=this.containerWidth;return this.getContainerWidth(),t!=this.containerWidth},i}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-modes/masonry",["../layout-mode","masonry-layout/masonry"],e):"object"==typeof module&&module.exports?module.exports=e(require("../layout-mode"),require("masonry-layout")):e(t.Isotope.LayoutMode,t.Masonry)}(window,function(t,e){"use strict";var i=t.create("masonry"),o=i.prototype,n={_getElementOffset:!0,layout:!0,_getMeasurement:!0};for(var s in e.prototype)n[s]||(o[s]=e.prototype[s]);var r=o.measureColumns;o.measureColumns=function(){this.items=this.isotope.filteredItems,r.call(this)};var a=o._getOption;return o._getOption=function(t){return"fitWidth"==t?void 0!==this.options.isFitWidth?this.options.isFitWidth:this.options.fitWidth:a.apply(this.isotope,arguments)},i}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-modes/fit-rows",["../layout-mode"],e):"object"==typeof exports?module.exports=e(require("../layout-mode")):e(t.Isotope.LayoutMode)}(window,function(t){"use strict";var e=t.create("fitRows"),i=e.prototype;return i._resetLayout=function(){this.x=0,this.y=0,this.maxY=0,this._getMeasurement("gutter","outerWidth")},i._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth+this.gutter,i=this.isotope.size.innerWidth+this.gutter;0!==this.x&&e+this.x>i&&(this.x=0,this.y=this.maxY);var o={x:this.x,y:this.y};return this.maxY=Math.max(this.maxY,this.y+t.size.outerHeight),this.x+=e,o},i._getContainerSize=function(){return{height:this.maxY}},e}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-modes/vertical",["../layout-mode"],e):"object"==typeof module&&module.exports?module.exports=e(require("../layout-mode")):e(t.Isotope.LayoutMode)}(window,function(t){"use strict";var e=t.create("vertical",{horizontalAlignment:0}),i=e.prototype;return i._resetLayout=function(){this.y=0},i._getItemLayoutPosition=function(t){t.getSize();var e=(this.isotope.size.innerWidth-t.size.outerWidth)*this.options.horizontalAlignment,i=this.y;return this.y+=t.size.outerHeight,{x:e,y:i}},i._getContainerSize=function(){return{height:this.y}},e}),function(t,e){"function"==typeof define&&define.amd?define(["outlayer/outlayer","get-size/get-size","desandro-matches-selector/matches-selector","fizzy-ui-utils/utils","isotope-layout/js/item","isotope-layout/js/layout-mode","isotope-layout/js/layout-modes/masonry","isotope-layout/js/layout-modes/fit-rows","isotope-layout/js/layout-modes/vertical"],function(i,o,n,s,r,a){return e(t,i,o,n,s,r,a)}):"object"==typeof module&&module.exports?module.exports=e(t,require("outlayer"),require("get-size"),require("desandro-matches-selector"),require("fizzy-ui-utils"),require("isotope-layout/js/item"),require("isotope-layout/js/layout-mode"),require("isotope-layout/js/layout-modes/masonry"),require("isotope-layout/js/layout-modes/fit-rows"),require("isotope-layout/js/layout-modes/vertical")):t.Isotope=e(t,t.Outlayer,t.getSize,t.matchesSelector,t.fizzyUIUtils,t.Isotope.Item,t.Isotope.LayoutMode)}(window,function(t,e,i,o,n,s,r){function a(t,e){return function(i,o){for(var n=0;n<t.length;n++){var s=t[n],r=i.sortData[s],a=o.sortData[s];if(r>a||r<a){var u=void 0!==e[s]?e[s]:e,h=u?1:-1;return(r>a?1:-1)*h}}return 0}}var u=t.jQuery,h=String.prototype.trim?function(t){return t.trim()}:function(t){return t.replace(/^\s+|\s+$/g,"")},d=e.create("isotope",{layoutMode:"masonry",isJQueryFiltering:!0,sortAscending:!0});d.Item=s,d.LayoutMode=r;var l=d.prototype;l._create=function(){this.itemGUID=0,this._sorters={},this._getSorters(),e.prototype._create.call(this),this.modes={},this.filteredItems=this.items,this.sortHistory=["original-order"];for(var t in r.modes)this._initLayoutMode(t)},l.reloadItems=function(){this.itemGUID=0,e.prototype.reloadItems.call(this)},l._itemize=function(){for(var t=e.prototype._itemize.apply(this,arguments),i=0;i<t.length;i++){var o=t[i];o.id=this.itemGUID++}return this._updateItemsSortData(t),t},l._initLayoutMode=function(t){var e=r.modes[t],i=this.options[t]||{};this.options[t]=e.options?n.extend(e.options,i):i,this.modes[t]=new e(this)},l.layout=function(){return!this._isLayoutInited&&this._getOption("initLayout")?void this.arrange():void this._layout()},l._layout=function(){var t=this._getIsInstant();this._resetLayout(),this._manageStamps(),this.layoutItems(this.filteredItems,t),this._isLayoutInited=!0},l.arrange=function(t){this.option(t),this._getIsInstant();var e=this._filter(this.items);this.filteredItems=e.matches,this._bindArrangeComplete(),this._isInstant?this._noTransition(this._hideReveal,[e]):this._hideReveal(e),this._sort(),this._layout()},l._init=l.arrange,l._hideReveal=function(t){this.reveal(t.needReveal),this.hide(t.needHide)},l._getIsInstant=function(){var t=this._getOption("layoutInstant"),e=void 0!==t?t:!this._isLayoutInited;return this._isInstant=e,e},l._bindArrangeComplete=function(){function t(){e&&i&&o&&n.dispatchEvent("arrangeComplete",null,[n.filteredItems])}var e,i,o,n=this;this.once("layoutComplete",function(){e=!0,t()}),this.once("hideComplete",function(){i=!0,t()}),this.once("revealComplete",function(){o=!0,t()})},l._filter=function(t){var e=this.options.filter;e=e||"*";for(var i=[],o=[],n=[],s=this._getFilterTest(e),r=0;r<t.length;r++){var a=t[r];if(!a.isIgnored){var u=s(a);u&&i.push(a),u&&a.isHidden?o.push(a):u||a.isHidden||n.push(a)}}return{matches:i,needReveal:o,needHide:n}},l._getFilterTest=function(t){return u&&this.options.isJQueryFiltering?function(e){return u(e.element).is(t);
}:"function"==typeof t?function(e){return t(e.element)}:function(e){return o(e.element,t)}},l.updateSortData=function(t){var e;t?(t=n.makeArray(t),e=this.getItems(t)):e=this.items,this._getSorters(),this._updateItemsSortData(e)},l._getSorters=function(){var t=this.options.getSortData;for(var e in t){var i=t[e];this._sorters[e]=f(i)}},l._updateItemsSortData=function(t){for(var e=t&&t.length,i=0;e&&i<e;i++){var o=t[i];o.updateSortData()}};var f=function(){function t(t){if("string"!=typeof t)return t;var i=h(t).split(" "),o=i[0],n=o.match(/^\[(.+)\]$/),s=n&&n[1],r=e(s,o),a=d.sortDataParsers[i[1]];return t=a?function(t){return t&&a(r(t))}:function(t){return t&&r(t)}}function e(t,e){return t?function(e){return e.getAttribute(t)}:function(t){var i=t.querySelector(e);return i&&i.textContent}}return t}();d.sortDataParsers={parseInt:function(t){return parseInt(t,10)},parseFloat:function(t){return parseFloat(t)}},l._sort=function(){if(this.options.sortBy){var t=n.makeArray(this.options.sortBy);this._getIsSameSortBy(t)||(this.sortHistory=t.concat(this.sortHistory));var e=a(this.sortHistory,this.options.sortAscending);this.filteredItems.sort(e)}},l._getIsSameSortBy=function(t){for(var e=0;e<t.length;e++)if(t[e]!=this.sortHistory[e])return!1;return!0},l._mode=function(){var t=this.options.layoutMode,e=this.modes[t];if(!e)throw new Error("No layout mode: "+t);return e.options=this.options[t],e},l._resetLayout=function(){e.prototype._resetLayout.call(this),this._mode()._resetLayout()},l._getItemLayoutPosition=function(t){return this._mode()._getItemLayoutPosition(t)},l._manageStamp=function(t){this._mode()._manageStamp(t)},l._getContainerSize=function(){return this._mode()._getContainerSize()},l.needsResizeLayout=function(){return this._mode().needsResizeLayout()},l.appended=function(t){var e=this.addItems(t);if(e.length){var i=this._filterRevealAdded(e);this.filteredItems=this.filteredItems.concat(i)}},l.prepended=function(t){var e=this._itemize(t);if(e.length){this._resetLayout(),this._manageStamps();var i=this._filterRevealAdded(e);this.layoutItems(this.filteredItems),this.filteredItems=i.concat(this.filteredItems),this.items=e.concat(this.items)}},l._filterRevealAdded=function(t){var e=this._filter(t);return this.hide(e.needHide),this.reveal(e.matches),this.layoutItems(e.matches,!0),e.matches},l.insert=function(t){var e=this.addItems(t);if(e.length){var i,o,n=e.length;for(i=0;i<n;i++)o=e[i],this.element.appendChild(o.element);var s=this._filter(e).matches;for(i=0;i<n;i++)e[i].isLayoutInstant=!0;for(this.arrange(),i=0;i<n;i++)delete e[i].isLayoutInstant;this.reveal(s)}};var c=l.remove;return l.remove=function(t){t=n.makeArray(t);var e=this.getItems(t);c.call(this,t);for(var i=e&&e.length,o=0;i&&o<i;o++){var s=e[o];n.removeFrom(this.filteredItems,s)}},l.shuffle=function(){for(var t=0;t<this.items.length;t++){var e=this.items[t];e.sortData.random=Math.random()}this.options.sortBy="random",this._sort(),this._layout()},l._noTransition=function(t,e){var i=this.options.transitionDuration;this.options.transitionDuration=0;var o=t.apply(this,e);return this.options.transitionDuration=i,o},l.getFilteredItemElements=function(){return this.filteredItems.map(function(t){return t.element})},d});

/* jquery.youtube-background v1.0.3 | Nikola Stamatovic <@stamat> | MIT */

      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/player_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      const YOUTUBE_DIMENSION_RETIO = 1.7777777778;
      const MAX_VIDEO_HEIGHT = 600;

      (function ($) {

          $.fn.youtube_background = function (params) {
              var YOUTUBE = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
              var $this = $(this);

              var defaults = {
                  'pause': false,
                  'mobile': false,
                  'load-background': true,
      //            'autoplay' : (ENV == 'LOCAL') ? false : true,
                  'autoplay' : true,
                  'full-height': false,
                  'display-controls': false
              }

              if (!params) {
                  params = defaults;
              } else {
                  for (var k in defaults) {
                      //load in defaults
                      if (!params.hasOwnProperty(k)) {
                          params[k] = defaults[k];
                      }
                  }
              }

              function onVideoPlayerReady(event) {

                  var $thisIFrame = $(event.target.getIframe());
                  var iframeHeight = $thisIFrame.outerHeight();
                  var iframeTopOffset = $thisIFrame.offset().top;
                  var headerHeight = $('.header').outerHeight();
                  var toolbarHeight = $('.tooltip.widget-root').outerHeight();
                  var combinedHeight = headerHeight + toolbarHeight;
                  var startingPoint = iframeTopOffset - (window.outerHeight/2);
                  var endingPoint = startingPoint + window.outerHeight;

                function autoplayListener() {
                  if ((window.scrollY + combinedHeight) >= startingPoint && (window.scrollY + combinedHeight) <= endingPoint && event.target.playerInfo.playerState != 1) {
                    event.target.playVideo();
                    $(window).unbind('scroll', autoplayListener);
                  }
                }

                $(window).on('scroll', autoplayListener);

                  if(params['autoplay']) {

                    if ((window.scrollY + combinedHeight) >= startingPoint && (window.scrollY + combinedHeight) <= endingPoint && event.target.playerInfo.playerState != 1) {
                      event.target.playVideo();
                    }
                  }

      //            $(event.target.f).css({
                  $thisIFrame.css({
                      "top": "50%",
                      "left": "50%",
                      "transform": "translateX(-50%) translateY(-50%)",
                      "position": "absolute"
                  });

                  var $root = $thisIFrame.parent();

                  function onResize() {

                      setTimeout(function(){

      //                    var res = 1.77777778;

                          /* not adjusting video size
                          var h = $root.outerHeight() + 100; // since showinfo is deprecated and ignored after September 25, 2018. we add +100
                          var w = $root.outerWidth() + 100;
                          var res = 1.77777778;

                          if (res > w / h) {
                              $root.find('iframe').width(h * res).height(h);
                          } else {
                              $root.find('iframe').width(w).height(w / res);
                          }
                          */

                         //console.log($root);
                         //console.log("onResize: "+$root.outerWidth());

                          var w = $root.outerWidth();
                          var videoHeight = (w / YOUTUBE_DIMENSION_RETIO);
                          var divHeight = (!params['full-height'] && videoHeight > MAX_VIDEO_HEIGHT) ? MAX_VIDEO_HEIGHT : videoHeight;

                         //Commenting this because we need to fixed height even top and botton content is cutting, is fine
                          $root.parents("section.section-video div.slick-list.draggable").first().css("height", divHeight);

                          // For video player tag
                          $root.parent(".video-placeholder").css("height", videoHeight);

                          $root.find('iframe').height(videoHeight + 4); // + 2 to hide border
                          $root.find('iframe').width("101%"); // + 1% to hide border
                      }, 500); // Wait to adjust div width
                  }

                  $(window).on('resize', onResize);
                  $(window).on('orientationchange', onResize);
                  onResize();
              }

              function onVideoStateChange(event) {
                  //loop
                  if (event.data === 0) {
                      event.target.playVideo();
                  }
              }

              function build() {
                  if (!window.hasOwnProperty('__ytbg_index')) {
                      window.__ytbg_index = {};
                  }

                  //element loop
                  for (var i = 0; i < $this.length; i++) {
                      var $elem = $($this[i]);

                      if ($elem.parent().hasClass('youtube-background')) {
                          continue;
                      }

                      for (var k in params) {
                          var data = $elem.data('ytbg-' + k);
                          //console.log(k);
                          if (data !== undefined && data !== null) {
                              params[k] = data;

                          }
                      }

                      $elem.wrap('<div class="youtube-background" />');
                      var $root = $elem.parent();

                      var ytid = $elem.data('youtube');

                      if (!ytid) {
                          continue;
                      }

                      var pts = ytid.match(YOUTUBE);
                      if (pts && pts.length) {
                          ytid = pts[1];
                          YOUTUBE.lastIndex = 0; //regex needs a reset in for loops, I always forget this
                      } else {
                          continue;
                      }

                      $root.css({
                          "height": "100%",
                          "width": "100%",
                          "z-index": "0",
                          "position": "absolute",
                          "overflow": "hidden",
                          "top": 0, // added by @insad
                          "left": 0,
                          "bottom": 0,
                          "right": 0,
                          "pointer-events": "none" // avoid right mouse click popup menu
                      });

                      if (params['load-background']) {
                          $root.css({
                              'background-image': 'url(https://img.youtube.com/vi/' + ytid + '/maxresdefault.jpg)',
                              'background-size': 'cover',
                              'background-repeat': 'no-repeat',
                              'background-position': 'center'
                          });
                      }

                      if (params['display-controls']) {
                          $root.css({
                              "pointer-events": "initial"
                          });
                      }

                      $root.parent().css({
                          "position": "relative"
                      });

                      var is_mobile = false;
                      (function (a) {
                          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
                              is_mobile = true;
                      })(navigator.userAgent || navigator.vendor || window.opera);

                      if (is_mobile && !params.mobile) {
      //                    continue;

                          // Allow start and stop button work
                          $root.css({
                              'pointer-events': 'initial',    
                              'z-index': '5'
                          });
                      }

                      if (params.pause) {
                          var $btn = $('<button class="play-toggle"><i class="fa fa-pause-circle"></i></button>');
                          $btn.on('click', function () {
                              var $this = $(this);
                              var player = $this.parent().find('.youtube-background').data('yt-player');

                              if ($this.hasClass('paused')) {
                                  $this.removeClass('paused');
                                  $this.find('i').addClass('fa-pause-circle').removeClass('fa-play-circle');
                                  if (player) {
                                      player.playVideo();
                                  }
                              } else {
                                  $this.addClass('paused');
                                  $this.find('i').removeClass('fa-pause-circle').addClass('fa-play-circle');
                                  if (player) {
                                      player.pauseVideo();
                                  }
                              }
                          });
                          $root.parent().append($btn);
                      }

                      function getRandomIntInclusive(min, max) {
                          min = Math.ceil(min);
                          max = Math.floor(max);
                          return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
                      }

                      var uid = ytid + '-' + getRandomIntInclusive(0, 999);
                      while (window.__ytbg_index.hasOwnProperty(uid)) {
                          uid = ytid + '-' + getRandomIntInclusive(0, 999);
                      }

                      window.__ytbg_index[uid] = {
                          elem: $elem[0],
                          ytid: ytid
                      };
                  }
              }
              build();

              window.onYouTubeIframeAPIReady = function () {
                  //element loop
                  for (var k in window.__ytbg_index) {
                      var entry = window.__ytbg_index[k];
                      var $root = $(entry.elem).parent();
                      var w = $root.outerWidth();
                      var h = (w / YOUTUBE_DIMENSION_RETIO);
                      var width = w + 2; // + 2 to hide border
                      var videoHeight = h + 2; // + 2 to hide border
                      var divHeight = (!params['full-height'] && videoHeight > MAX_VIDEO_HEIGHT) ? MAX_VIDEO_HEIGHT : videoHeight;

                      // Commenting this because we need to fixed height even top and botton content is cutting, is fine
                      $root.parents("section.section-video div.slick-list.draggable").first().css("height", divHeight);

                      // For video player tag
                      $root.parent(".video-placeholder").css("height", divHeight);

                      var isDisplayControl = params['display-controls'] ? true : false;
                      var isAutoPlay = params['autoplay'] ? true : false;
                      var isMute = params['mute'] ? true : false;

                      ytp = new YT.Player(entry.elem, {
                          height: videoHeight,
                          width: width,
                          videoId: entry.ytid,
                          playerVars: {
                              'controls': isDisplayControl,
                              'autoplay': 0,
                              'mute': isMute,
                              'origin': window.location.origin,
                              'loop': 1,
                              'rel': 0,
                              'ecver': 2,
                              'showinfo': isDisplayControl,
                              'modestbranding': 1
                          },
                          events: {
                              'onReady': onVideoPlayerReady,
                              'onStateChange': onVideoStateChange
                          }
                      });

                      $root.data('yt-player', ytp);
                      delete window.__ytbg_index[k];
                  }
              };

              if (window.hasOwnProperty('YT') && window.YT.loaded) {
                  window.onYouTubeIframeAPIReady();
              }

              return $this;
          };
      })(jQuery);


function newSliders($elem, power_reviews_mod) {

    if ($elem === undefined || $elem === null) {
        $elem = $('.new-slider').not('.template');
    } else {
        $elem = $($elem).not('.template');
    }

    $elem.each(function () {
        var $this = $(this);

        if (!$this.hasClass('initialized')) {
            var slides = parseInt($this.data('slides'), 10);
            var slides_mobile = parseInt($this.data('slides-mobile'), 10);

            if (!slides || isNaN(slides)) {
                slides = 0;
            }

            if (!slides_mobile || isNaN(slides_mobile)) {
                slides_mobile = 0;
            }

            var $slider = $this.find('.slider');

            var $slider_controls = $this.find('.slider-controls');
            var $slider_dots = $this.find('.slider-dots');

            function init() {

                //console.log($slider);
                function onChange(slick, curr) {
                var $root = $(slick.$slider).closest('.new-slider');
                var $dot = $root.find('.slider-dots .dummy-dot');
                var percent = $dot.data('percent');
                percent = curr * percent;
                $dot.css('left', percent + '%');
                                    }

                function initDummy(slick) {
                var count = $(slick.$dots).find('li').length;
                var $root = $(slick.$slider).closest('.new-slider');

                if (count) {
                var percent = 100 / count;
                var $dot = $root.find('.slider-dots .dummy-dot');
                $dot.data('percent', percent);
                $dot.css('width', percent + '%');

                $root.find('.slider-dots').fadeIn({
                duration: 250,
                  easing: 'easeInOutQuint'
                                            });
                                        } else {
                                          $root.find('.slider-dots').fadeOut({
                                            duration: 250,
                                            easing: 'easeInOutQuint'
                                          });
                                        }

                                        onChange(slick, slick.currentSlide);
                                    }

                                    $slider.on('init', function (event, slick) {
                  initDummy(slick);
                });

                $slider.on('breakpoint', function (event, slick) {
                  initDummy(slick);
                });

                $slider.on('beforeChange', function (event, slick, curr, next) {
                  onChange(slick, next);
                });

                $slider.not('.slick-initialized').slick({
                  infinite: false,
                  slidesToShow: slides,
                  slidesToScroll: 1,
                  swipeToSlide: true,
                  dots: true,
                  arrows: true,
                  appendArrows: $slider_controls,
                  appendDots: $slider_dots,
                  responsive: [{
                    breakpoint: 960,
                    settings: {
                      slidesToShow: slides_mobile,
                      slidesToScroll: 1
                    }
                  }]
                });

                $this.addClass('initialized');
            }

            var $products = $slider.find('.item.product');
			
            init();
        }
    });
}

/*
function newSliders($elem, power_reviews_mod) {
    if ($elem === undefined || $elem === null) {
        $elem = $('.new-slider').not('.template');
    } else {
        $elem = $($elem).not('.template');
    }

    $elem.each(function () {
        var $this = $(this);
        if (!$this.hasClass('initialized')) {
            var slides = parseInt($this.data('slides'), 10);
            var slides_mobile = parseInt($this.data('slides-mobile'), 10);

            if (!slides || isNaN(slides)) {
                slides = 0;
            }

            if (!slides_mobile || isNaN(slides_mobile)) {
                slides_mobile = 0;
            }

            var $slider = $this.find('.slider');

            var $dots = $('<div class="custom-dots"><div class="dots-inner"></div></div>');
            var $slider_controls = $this.find('.slider-controls');
            var $dots_slider = $dots.find('.dots-inner');
            $slider.after($dots);
            $slider.children().each(function () {
                $dots_slider.append('<div class="dot"></div>');
            });

            function init() {
                $slider.imagesLoaded(function () {
                    //console.log($slider);
                    $slider.not('.slick-initialized').slick({
                        infinite: false,
                        slidesToShow: slides,
                        slidesToScroll: 1,
                        swipeToSlide: true,
                        dots: false,
                        arrows: true,
                        asNavFor: $dots_slider,
                        appendArrows: $slider_controls,
                        responsive: [{
                                breakpoint: 960,
                                settings: {
                                    slidesToShow: slides_mobile,
                                    slidesToScroll: 1
                                }
                            }]
                    });

                    $dots_slider.not('.slick-initialized').slick({
                        infinite: false,
                        slidesToShow: slides,
                        slidesToScroll: 1,
                        swipeToSlide: true,
                        dots: false,
                        arrows: false,
                        asNavFor: $slider,
                        focusOnSelect: true,
                        responsive: [{
                                breakpoint: 960,
                                settings: {
                                    slidesToShow: slides_mobile,
                                    slidesToScroll: 1
                                }
                            }]
                    });

                    $this.addClass('initialized');
                });
            }

            var $products = $slider.find('.item.product');

            if ($products.length) {
                initPowerReviewsCollection($products, function () {
                    init();
                }, power_reviews_mod);
            } else {
                init();
            }
        }
    });
} */

function specialSliders() {
    $('.special-slider').not('.template').each(function () {
        var $this = $(this);
        var slides = parseInt($this.data('slides'), 10);
        var slides_mobile = parseInt($this.data('slides-mobile'), 10);

        if (!slides || isNaN(slides)) {
            slides = 3;
        }

        if (!slides_mobile || isNaN(slides_mobile)) {
            slides_mobile = 1;
        }

        if (!$this.hasClass('initialized')) {
            var $slider = $this.find('.slider');

            $slider.slick({
              infinite: false,
              slidesToShow: slides,
              slidesToScroll: 1,
              swipeToSlide: true,
              dots: false,
              arrows: false,
              responsive: [{
                breakpoint: 960,
                settings: {
                  slidesToShow: slides_mobile,
                  slidesToScroll: 1,
                  infinite: true,
                  centerMode: true
                }
              }]
            });
            $this.addClass('initialized');
        }
    });
}

function ctaSliders($elem) {
    if ($elem === undefined || $elem === null) {
        $elem = $('.cta-carousel').not('.template');
    } else {
        $elem = $($elem).not('.template');
    }

    $elem.each(function () {
        var $this = $(this);
        var slides = parseInt($this.data('slides'), 10);
        var slides_mobile = parseInt($this.data('slides-mobile'), 10);

        if (!slides || isNaN(slides)) {
            slides = 1;
        }

        if (!slides_mobile || isNaN(slides_mobile)) {
            slides_mobile = 1;
        }

        if (!$this.hasClass('initialized')) {
            
            var isVideoSection = $(this).hasClass("section-video");
            var $slider = $this.find('.slider');

            $slider.on('init', function () {
              loadme($this.find('.slider'));
            });
            $slider.slick({
              autoplay: true,
              autoplaySpeed: 5000,
              pauseOnFocus: false,
              centerMode: (isMobileScreen() || isVideoSection) ? false : true,
              centerPadding: "60px",
              infinite: true,
              slidesToShow: slides,
              slidesToScroll: 1,
              swipeToSlide: true,
              dots: true,
              arrows: true,
              adaptiveHeight: true,
              //                    adaptiveHeight: !$this.hasClass("section-video"), // Changed by Lalmani
              responsive: [{
                breakpoint: 960,
                settings: {
                  slidesToShow: slides_mobile,
                  slidesToScroll: 1,
                  infinite: true,
                  arrows: false
                }
              }]
            });
            $this.addClass('initialized');
            setShopNowFocus();

            console.log("main $slider initialized");
            $slider.on('init', function(event, slick, currentSlide, nextSlide) {
              console.log("init");
            });

            $slider.on('afterChange', function(event, slick, currentSlide, nextSlide) {
              console.log("afterChange 12345");

              //                    console.log($(slick.$slides[currentSlide]).find("div.button-wrap a"));

              // focus on shop now button
              //                    $(slick.$slides[currentSlide]).find("div.button-wrap a").focus();

              setShopNowFocus();
            });
        }
    });
}

// Begin main.js

function isIOS() {
	//https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
	return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}    

if (isIOS()) { 
	//https://stackoverflow.com/a/57527009/1909864
	var el = document.querySelector('head meta[name=viewport]');

  	if (el !== null) {
    	var content = el.getAttribute('content');
		var re = /maximum\-scale=[0-9\.]+/g;

		if (re.test(content)) {
			content = content.replace(re, 'maximum-scale=1');
		} else {
			content = [content, 'maximum-scale=1'].join(', ')
		}

    	el.setAttribute('content', content);
  	}
}  
/*! outline.js v1.2.0 - https://github.com/lindsayevans/outline.js/ */
(function(d){

	var style_element = d.createElement('STYLE'),
	    dom_events = 'addEventListener' in d,
	    add_event_listener = function(type, callback){
			// Basic cross-browser event handling
			if(dom_events){
				d.addEventListener(type, callback);
			}else{
				d.attachEvent('on' + type, callback);
			}
		},
	    set_css = function(css_text) {
			// Handle setting of <style> element contents in IE8
			!!style_element.styleSheet ? style_element.styleSheet.cssText = css_text : style_element.innerHTML = css_text;
		}
	;

	d.getElementsByTagName('HEAD')[0].appendChild(style_element);

	// Using mousedown instead of mouseover, so that previously focused elements don't lose focus ring on mouse move
	add_event_listener('mousedown', function(){
		set_css(':focus{outline:0}::-moz-focus-inner{border:0;}');
	});

	add_event_listener('keydown', function(){
		set_css('');
	});

})(document);

if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

function slug(s) {
	s = s.trim().toLowerCase();
	s = s.replace(/[\/\\]/ig, '-');
	s = s.replace(/[^a-z0-9\s_-]/ig, '');
	return s.replace(/[\s\uFEFF\xA0]+/ig, '-');
}

if (!Array.prototype.min) {
    Array.prototype.min = function() {
        var min = null;

        for (var i = 0; i < this.length; i++) {
            if (min === null) {
                min = this[i];
                continue;
            }

            if (this[i] < min) {
                min = this[i];
            }
        }

        return min;
    };
}

if (!Array.prototype.max) {
    Array.prototype.max = function() {
        var max = null;

        for (var i = 0; i < this.length; i++) {
            if (max === null) {
                max = this[i];
                continue;
            }

            if (this[i] > max) {
                max = this[i];
            }
        }

        return max;
    };
}

function getHash() {
    var hash = window.location.hash;
    if (hash) {
        var hash_value = hash.replace('#', '');
        if (hash_value === '') {
            return null;
        }

        return hash_value;
    }
    return null;
}

function setCookie(cname, cvalue, exdays) {
     var d = new Date();
     d.setTime(d.getTime() + (exdays*24*60*60*1000));
     var expires = "expires="+ d.toUTCString();
     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
 }

 function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
 }

 function eraseCookie(name) {
    setCookie(name, "", null , null , null, 1);
 }

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function decorateWithZeros(v, z) {
    var zeros = '';
    var zorig = z;

    var vz = v+'';
    var joint = '.';

    if (vz.indexOf('.') > -1) {
        var pts = vz.split('.');

        if (pts[1]) {
            z = z - pts[1].length;
        }
        joint = '';

        if (pts[1].length > zorig) {
            pts[1] = pts[1].substr(0, zorig);
            v = pts[0] + '.' + pts[1];
        }
    }

    for (var i = 0; i < z; i++) {
        zeros += '0';
    }

    if (zeros.length) {
        v = v+joint+zeros;
    }

    return v;
}

/*! iNoBounce - v0.1.6
* https://github.com/lazd/iNoBounce/
* Copyright (c) 2013 Larry Davis <lazdnet@gmail.com>; Licensed BSD */
(function(global) {
	// Stores the Y position where the touch started
	var startY = 0;

	// Store enabled status
	var enabled = false;

	var supportsPassiveOption = false;
	try {
		var opts = Object.defineProperty({}, 'passive', {
			get: function() {
				supportsPassiveOption = true;
			}
		});
		window.addEventListener('test', null, opts);
	} catch (e) {}

	var handleTouchmove = function(evt) {
		// Get the element that was scrolled upon
		var el = evt.target;

		// Allow zooming
		var zoom = window.innerWidth / window.document.documentElement.clientWidth;
		if (evt.touches.length > 1 || zoom !== 1) {
			return;
		}

		// Check all parent elements for scrollability
		while (el !== document.body && el !== document) {
			// Get some style properties
			var style = window.getComputedStyle(el);

			if (!style) {
				// If we've encountered an element we can't compute the style for, get out
				break;
			}

			// Ignore range input element
			if (el.nodeName === 'INPUT' && el.getAttribute('type') === 'range') {
				return;
			}

			var scrolling = style.getPropertyValue('-webkit-overflow-scrolling');
			var overflowY = style.getPropertyValue('overflow-y');
			var height = parseInt(style.getPropertyValue('height'), 10);

			// Determine if the element should scroll
			var isScrollable = scrolling === 'touch' && (overflowY === 'auto' || overflowY === 'scroll');
			var canScroll = el.scrollHeight > el.offsetHeight;

			if (isScrollable && canScroll) {
				// Get the current Y position of the touch
				var curY = evt.touches ? evt.touches[0].screenY : evt.screenY;

				// Determine if the user is trying to scroll past the top or bottom
				// In this case, the window will bounce, so we have to prevent scrolling completely
				var isAtTop = (startY <= curY && el.scrollTop === 0);
				var isAtBottom = (startY >= curY && el.scrollHeight - el.scrollTop === height);

				// Stop a bounce bug when at the bottom or top of the scrollable element
				if (isAtTop || isAtBottom) {
					evt.preventDefault();
				}

				// No need to continue up the DOM, we've done our job
				return;
			}

			// Test the next parent
			el = el.parentNode;
		}

		// Stop the bouncing -- no parents are scrollable
		evt.preventDefault();
	};

	var handleTouchstart = function(evt) {
		// Store the first Y position of the touch
		startY = evt.touches ? evt.touches[0].screenY : evt.screenY;
	};

	var enable = function() {
		// Listen to a couple key touch events
		window.addEventListener('touchstart', handleTouchstart, supportsPassiveOption ? { passive : false } : false);
		window.addEventListener('touchmove', handleTouchmove, supportsPassiveOption ? { passive : false } : false);
		enabled = true;
	};

	var disable = function() {
		// Stop listening
		window.removeEventListener('touchstart', handleTouchstart, false);
		window.removeEventListener('touchmove', handleTouchmove, false);
		enabled = false;
	};

	var isEnabled = function() {
		return enabled;
	};

	// Enable by default if the browser supports -webkit-overflow-scrolling
	// Test this by setting the property with JavaScript on an element that exists in the DOM
	// Then, see if the property is reflected in the computed style
	var testDiv = document.createElement('div');
	document.documentElement.appendChild(testDiv);
	testDiv.style.WebkitOverflowScrolling = 'touch';
	var scrollSupport = 'getComputedStyle' in window && window.getComputedStyle(testDiv)['-webkit-overflow-scrolling'] === 'touch';
	document.documentElement.removeChild(testDiv);

	if (scrollSupport) {
		enable();
	}

	// A module to support enabling/disabling iNoBounce
	var iNoBounce = {
		enable: enable,
		disable: disable,
		isEnabled: isEnabled
	};

	if (typeof module !== 'undefined' && module.exports) {
		// Node.js Support
		module.exports = iNoBounce;
	}
	if (typeof global.define === 'function') {
		// AMD Support
		(function(define) {
			define('iNoBounce', [], function() { return iNoBounce; });
		}(global.define));
	}
	else {
		// Browser support
		global.iNoBounce = iNoBounce;
	}
}(this));

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 *
 * Open source under the BSD License.
 *
 * Copyright 2008 George McGinley Smith
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 * GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
$.easing.jswing = $.easing.swing;

$.extend($.easing,
{
    def: 'easeOutQuad',
    easeOutQuad: function (x, t, b, c, d) {
        return -c *(t/=d)*(t-2) + b;
    },
    easeInQuint: function (x, t, b, c, d) {
        return c*(t/=d)*t*t*t*t + b;
    },
    easeOutQuint: function (x, t, b, c, d) {
        return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    easeInOutQuint: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) {
			return c/2*t*t*t*t*t + b;
		}
        return c/2*((t-=2)*t*t*t*t + 2) + b;
    }
});

function imageLoader(src, callback, once) {
    function load(src, callback) {
        var img = new Image();
        if (callback) {
            img.addEventListener('load', callback, false);
        }
        img.src = src;
    }

    var onced = false;

    if ($.isArray(src)) {
        for (var i = 0; i < src.length; i++) {
            var fn = onced && once ? null : callback;
            load(src[i], fn);
            nced = true;
        }
        return;
    }

    load(src, callback);
  }

function imageLoadFade(elem) {
    var $elem = $(elem);
    var src = $elem.data('full');

    if (src === undefined || src === null || src.trim() === '') {
        $elem.addClass('loaded');
        return;
    }

    imageLoader(src, function(e) {
		if (!$elem.is('img') ) {
                $elem.css({'background-image': 'url('+src+')'});
        } else {
			$elem.attr('src', src);
		}
        $elem.addClass('loaded');
    });
}

(function($) {
	$.fn.pineput = function() {
		var $this = $(this);
		for (var i = 0; i < $this.length; i++) {
			var $input_fields = $($this[i]).find('.input-field input:not([type="submit"]):not([type="checkbox"]), .input-field textarea, .input-field select');

			// TODO: custom selector for input fields property

	        $input_fields.on('focus', function(e){
	            var $field = $(this).closest('.input-field');
	            $field.addClass('focus');
	        }).on('blur', function(e){
	            var $this = $(this);
	            var $field = $this.closest('.input-field');
	            $field.removeClass('focus');

	            var val = $this.val().trim();

	            if (val === '') {
	                $field.removeClass('active');
	            } else {
	                $field.addClass('active');
	            }
	        }).on('change', function(e){
	            var $this = $(this);
	            var $field = $this.closest('.input-field');
	            var val = $this.val();

	            if (!val || val.trim() === '') {
	                $field.removeClass('active');
	            } else {
	                $field.addClass('active');
	            }
	        });

	       	for (var j = 0; j < $input_fields.length; j++) {
	           	var $input_field = $($input_fields[j]);

	           	var $field = $input_field.closest('.input-field');
				var val = $input_field.val();

			  	if (!val || val.trim() === '') {
	               	$field.removeClass('active');
	           	} else {
	               	$field.addClass('active');
	           	}
	       	}

	       	$($this[i]).find('textarea').closest('.input-field').addClass('textarea');

			var $checkbox_field = $(this[i]).find('.input-field input[type="checkbox"]');

			$checkbox_field.closest('.input-field').addClass('checkbox');
			$checkbox_field.on('change', function(){
				if ($(this).is(":checked")) {
					$(this).addClass('checked');
					$(this).closest('.input-field').addClass('checked');
				} else {
					$(this).removeClass('checked');
					$(this).closest('.input-field').removeClass('checked');
				}
			});
		}
    }
})(jQuery);

function loadme($elem, callback) {
    var $images_to_load = [];

    if ($elem !== undefined && $elem !== null && $elem.length) {
        $images_to_load = $elem.find('.loadme').not('.loaded');
    } else {
        $images_to_load = $('.loadme').not('.loaded');
    }

    for (var i = 0; i < $images_to_load.length; i++) {
        var $img = $images_to_load[i];
        imageLoadFade($img);
    }

    if (callback) {
        callback($images_to_load);
    }
}

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 * Modified by Stamat <stamatmail@gmail.com>
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.

  var boilerwise = {
    // All pages
    init: function() {
		iNoBounce.disable();
		$('form').pineput();
      
		if ( $.isFunction($('body').modally) ) {
      		$('body').modally('video-modal', {video: true, max_width: 1440});
          console.log('123');
        }
      
      
        $('[data-youtube]').each(function(){
          if($(this).hasClass("product-video-slide")) {
            $(this).youtube_background({'load-background': false, 'display-controls' : true});
          } else {
            $(this).youtube_background({'load-background': false, 'mute': true});
          }
        });

		if ($('#announcement').length) {
			var cookie_hook = $('#announcement').data('cookie-hook');
			var cookie_duration = parseInt($('#announcement').data('cookie-duration'), 10);

			if (!cookie_hook || cookie_hook.trim() === '') {
				cookie_hook = 'announcement';
			}

			if (isNaN(cookie_duration) || cookie_duration === 0) {
				cookie_duration = 1;
			}

			if (getCookie(cookie_hook) === '') {
				$('#announcement').modally('announcement', {max_width: 1104});
				if ($('#announcement').hasClass('black')) {
					$('.modally-wrap.announcement').addClass('black');

					$('#announcement .button').on('click', function() {
						setCookie(cookie_hook, 'true', cookie_duration);
					})
				}
				window._modally_storage['announcement']['open']();
                                
				$(document).on('modally:closed:announcement', function(e, self) {

					//console.log('modally:closed:announcement', arguments);
					setCookie(cookie_hook, 'true', cookie_duration);
				});
                                
                                handleAnnouncementFocus();
			}
		}

		addPaddingShifters('header#main .controls, .pane, main, footer.blur, .banner, header#main .header .content, .zEWidget-launcher');

        function unique(array) {
            return $.grep(array, function(el, index) {
                return index === $.inArray(el, array);
            });
        }

        loadme();

		$('a.scrollme, a[target="_scroll"]').on('click', function(e) {
			e.preventDefault();
			var href = $(this).attr('href');

			$('html, body').animate({
				scrollTop: $(href).offset().top - 100
			}, 500, 'easeInOutQuint');
		});

		function hoverme($elem, main_hover_elem, callback) {
            var $items_to_hover = [];

            if ($elem !== undefined && $elem !== null && $elem.length) {
                $items_to_hover = $elem.not('.hoverme-init');
            } else {
                $items_to_hover = $('.hoverme').not('.hoverme-init');
            }

			if (!main_hover_elem) {
				main_hover_elem = '.image';
			}

            for (var i = 0; i < $items_to_hover.length; i++) {
                var $item = $($items_to_hover[i]);
                $item.addClass('hoverme-init');

				$item.find('a').on('mouseenter', function(e){
                    if (window.innerWidth >= 960) {
						var $root = $(this).closest('.hoverme');
						$root.addClass('hovered');

						if ($(this).not(main_hover_elem)) {
							$root.find(main_hover_elem).not('.no-hover').addClass('hover');

							if (callback) {
								callback($(this), 'mouseenter', e);
							}
						}
                    }
                }).on('mouseleave', function(e){
                    if (window.innerWidth >= 960) {
						var $root = $(this).closest('.hoverme');
						$root.removeClass('hovered');

						if ($(this).not(main_hover_elem)) {
							$root.find(main_hover_elem).not('.no-hover').removeClass('hover');

							if (callback) {
								callback($(this), 'mouseenter', e);
							}
						}
                    }
                });
            }
        }

		function disableScroll() {
			iNoBounce.enable();
			_disableScroll();

			if (window.scroll_width !== undefined && window.scroll_width) {
				$('header#main nav .root-nav.desktop li .sub-nav').css({
					"width": 'calc(100% + ' + scroll_width + 'px)'
				});
			}
		}

		function enableScroll() {
			_enableScroll();
			iNoBounce.disable();
		}

		

		var controller = new ScrollMagic.Controller();
		var scene_top = new ScrollMagic.Scene({triggerElement: "#header-trigger", triggerHook: 0})
			.setClassToggle("body", "below-banner")
			.addTo(controller);

        
		//init auto sliders
        newSliders();
        specialSliders();
        ctaSliders();

		
        var $body = $('body');
		var $section_pdp = $('section.pdp');

        var $pdp_image_stash = $('#image-stash');

		var $section_pdp_side = $('section.pdp .product-images.side');
		var $section_pdp_main = $('section.pdp .product-images.main');
		var $section_pdp_details = $('section.pdp .product-details .table');

		var onresize_mobile = {};
		var onresize_desktop = {};
		var onresize = {};

		function onResize() {
			for (var k in onresize) {
				onresize[k]();
			}

			if (window.innerWidth >= 960) {
				for (var k in onresize_desktop) {
					onresize_desktop[k]();
				}
			} else {
				for (var k in onresize_mobile) {
					onresize_mobile[k]();
				}
			}
		}

        executeShortcodes($('#description'), fn, function(shortcode_map, fn_map) {
            //console.log('Yo! You said I should call you back...');
        });

		onresize_desktop.menu = function(){
			if ($body.hasClass('menu-open')) {
				$body.removeClass('menu-open');
				$menu_pane.removeClass('active');

				if (!$body.hasClass('search-open') && !$body.hasClass('cart-open')) {
					$hamburger.removeClass('active');
					$underlay.stop(true).fadeOut({
                        duration: 250,
                        easing: 'easeInOutQuint'
                    });
					enableScroll();
				}
			}
		};

        onresize_mobile.menu = function(){
            if ($body.hasClass('desktop-menu-open')) {
                $('#menu-underlay').trigger('click');
            }
        };

		function bindBackButton(back_item, $back) {
			if ($back === undefined) {
				$back = $('.landing-back-button');
			}

			if ($back !== undefined && $back.length) {
				var custom_label = $back.data('custom-label');


				if (!custom_label) {
					$back.html(back_item.title);
				}

				var title_prefix = $back.data('title-prefix');
				if (!title_prefix) {
					title_prefix = 'Back to';
				}

                $back.attr('title', title_prefix + ' ' + back_item.title);

				if ($back.is('a')) {
					$back.attr('href', back_item.href);
				} else {
					$back.on('click', goBack);
				}

			}
		}

		if ($('section.p404').length) {
			var back_item = backLog();
			bindBackButton(back_item);
		}

		if ($section_pdp.length) {
			var back_item = backLog();

            if (back_item && back_item.type !== 'product') {
                bindBackButton(back_item);
            } else {
                var $back = $('.landing-back-button');
                $back.remove();
            }

			$('body').addClass('pdp-page');

            var $small_slides = $pdp_image_stash.find('div.slide.small').detach();
            var $big_slides = $pdp_image_stash.find('div.slide.big').detach();
            var swatch_map = {};
			var $variants = $('.variants.only-one');
			var $to_cart = $('.to-cart');
			var $color_swatches = $('.color-swatches.only-one');


            //map all the colors and filter only if the color is mapped
            $small_slides.each(function() {
                var color = $(this).data('color');

                if (color && !swatch_map.hasOwnProperty(color)) {
                    swatch_map[color] = $(this).find('.image').data('full');

					//assign images to variants
					$color_swatches.find('[data-hook="'+color+'"]').data('image', swatch_map[color]);
                }
            });

			var $active_variant = $color_swatches.first().find('.active');
			var active_variant_image = '';

			if ($active_variant.length) {
				active_variant_image = $active_variant.data('image');
			} else {
				if ($small_slides.length) {
					active_variant_image = $small_slides.first().find('.image').data('full');
				}
			}

			//add color image to cart button
			$to_cart.each(function() {
				$(this).data('image', active_variant_image);
				$(this).attr('data-image', active_variant_image);
            });

			/* var scene_product_tooltip = new ScrollMagic.Scene({triggerElement: "#tooltip-trigger", triggerHook: 0})
				.setClassToggle("body", "tooltip-activated")
				.addTo(controller); */

			onresize_desktop.pdpCarousel = function() {
				if ($section_pdp.length) {
					setTimeout(function(){
						$section_pdp_side.height($section_pdp_main.height());
						$section_pdp_details.css({'min-height': $section_pdp_main.height()});
					}, 100);
				}
			}

            var current_variant = $section_pdp.data('current_variant');
            var variants_size = parseInt($section_pdp.data('variants_size'), 10);
            var $section_pdp_main_slides = $section_pdp_main.find('.slides');
            var $section_pdp_side_slides = $section_pdp_side.find('.slides');

            $section_pdp_main_slides.css('opacity', 0);
            $section_pdp_side_slides.css('opacity', 0);


            $section_pdp_main_slides.append($big_slides);
            $section_pdp_main_slides.on('init', function() {
              onresize_desktop.pdpCarousel();
              $section_pdp_side_slides.css('opacity', 1);

              console.log("$section_pdp_main_slides init");
            });

            $section_pdp_main_slides.slick({
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              swipeToSlide: true,
              dots: false,
              arrows: false,
              asNavFor: $section_pdp_side_slides,
              responsive: [{
                breakpoint: 960,
                settings: {
                  centerMode: true,
                  variableWidth: true,
                  infinite: false
                }
              }]
            });

            $section_pdp_side_slides.on('init', function() {
              onresize_desktop.pdpCarousel();
              $section_pdp_side_slides.css('opacity', 1);
            });

            $section_pdp_side_slides.append($small_slides);
            $section_pdp_side_slides.slick({
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              swipeToSlide: true,
              dots: false,
              vertical: true,
              arrows: true,
              asNavFor: $section_pdp_main_slides,
              focusOnSelect: true,
              responsive: [{
                breakpoint: 960,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  variableWidth: true,
                  vertical: false,
                  centerMode: true,
                  infinite: false
                }
              }]
            });
                        
                        $section_pdp_main_slides.on('afterChange', function (event, slick, currentSlide) {
                            
//                            console.log("Main afterChange: " + currentSlide);
                            
                            $(slick.$slides).each(function(index) {
                                /* for video tag
                                var $video = $(this).find("video");
                                if($video.length) { // Check if this slide having video
                                    if(index == currentSlide) { // Check if this is selected slide
                                        $video.get(0).currentTime = 0;
                                        $video.get(0).play();
                                    } else {
                                        $video.get(0).pause();
                                    }
                                } 
                                */
                               
                                /* For youtube video */
                                var $video = $(this).find(".youtube-background");
                                if($video.length) { // Check if this slide having video
                                    
                                    var player = $video.data('yt-player');
                                    if(!player) {
                                        return true;
                                    }
                                    
                                    if(index == currentSlide) { // Check if this is selected slide
//                                        if(player.isMuted()) {
//                                            player.unMute()
//                                        }
                                        
                                        player.seekTo(0);
                                        player.playVideo();
                                        
                                        $video.data("is-playing", "YES");
                                    } else {
                                        if($video.data('is-playing') == 'YES') {
                                            player.pauseVideo();
                                            $video.data("is-playing", "NO");
                                        }
                                    }
                                }
                            });
                        });

			/* PhotoSwipe */
			var initPhotoSwipeFromDOM = function(gallerySelector) {
			    // parse slide data (url, title, size ...) from DOM elements
			    // (children of gallerySelector)
			    var parseThumbnailElements = function(selector) {
			        var thumbElements = $(selector),
			            numNodes = thumbElements.length,
			            items = [],
			            figureEl,
			            linkEl,
			            size,
			            item;

			        for(var i = 0; i < numNodes; i++) {

			            figureEl = thumbElements[i]; // <figure> element

			            // include only element nodes
			            if(figureEl.nodeType !== 1) {
			                continue;
			            }

			            $linkEl = $(figureEl).find('a'); // <a> element

			            size = $linkEl.attr('data-size').split('x');

			            // create slide object
			            item = {
			                src: $linkEl.attr('href'),
			                w: parseInt(size[0], 10),
			                h: parseInt(size[1], 10),
							title: $linkEl.attr('title'),
							msrc: $linkEl.parent().attr('data-full'),
							el: figureEl
			            };

			            items.push(item);
			        }

			        return items;
			    };

			    // triggers when user clicks on thumbnail
			    var onThumbnailsClick = function(e) {
			        e.preventDefault();

			        // find index of clicked item by looping through all child nodes
			        // alternatively, you may define index via data- attribute
			        var clickedGallery = $(this).data('gall'),
			            index = $(this).data('gall-id');


			        if (index !== undefined && index !== null) {
			            openPhotoSwipe( index, clickedGallery );
			        }
			    };

			    var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
			        var pswpElement = document.querySelectorAll('.pswp')[0],
			            gallery,
			            options,
			            items;

			        items = parseThumbnailElements('.slide.big.'+galleryElement);

			        // define options (if needed)
			        options = {

			            // define gallery index (for URL)
			            galleryUID: galleryElement,

			            getThumbBoundsFn: function(index) {
			                // See Options -> getThumbBoundsFn section of documentation for more info
			                var thumbnail = $(items[index].el).find('.image')[0], // find thumbnail
			                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
			                    rect = thumbnail.getBoundingClientRect();

			                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
			            }

			        };

			        // PhotoSwipe opened from URL
			        if(fromURL) {
			            if(options.galleryPIDs) {
			                // parse real index when custom PIDs are used
			                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
			                for(var j = 0; j < items.length; j++) {
			                    if(items[j].pid == index) {
			                        options.index = j;
			                        break;
			                    }
			                }
			            } else {
			                // in URL indexes start from 1
			                options.index = parseInt(index, 10) - 1;
			            }
			        } else {
			            options.index = parseInt(index, 10);
			        }

			        // exit if index not found
			        if( isNaN(options.index) ) {
			            return;
			        }

			        if(disableAnimation) {
			            options.showAnimationDuration = 0;
			        }

			        // Pass data to PhotoSwipe and initialize it
			        gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
					gallery.listen('afterChange', function() {
						var slide = $(gallery.currItem.el).find('a').data('gall-id');
						if (slide !== undefined && slide !== null) {
							if ($section_pdp_main_slides && $section_pdp_main_slides.length) {
								$section_pdp_main_slides.slick('slickGoTo', slide);
							}
						}
					});
			        gallery.init();
			    };

			    // loop through all gallery elements and bind events
			    var galleryElements = document.querySelectorAll( gallerySelector );

			    for(var i = 0, l = galleryElements.length; i < l; i++) {
					var $trigger = $(galleryElements[i]).find('a');
					$trigger.data('gall-id', i);
					$trigger.off('click');
					$trigger.on('click', onThumbnailsClick);
			    }
			};

            setTimeout(function () {
                var $image_sliders = $([$section_pdp_main_slides[0], $section_pdp_side_slides[0]]);

                if (!isNaN(variants_size) && variants_size > 1) {
                    if (swatch_map.hasOwnProperty(current_variant)) {
                        $image_sliders.slick('slickFilter', '.color-'+current_variant+', .external-video');

                        $image_sliders.each(function(index, slide){
                            var s_id = 0;
                            $(".slick-slide:not(.slick-cloned)", slide).each(function(s_index, s_slide) {
                                $(this).attr("data-slick-index", s_id);
                                s_id++;
                                if (index === 0) {
                                    if ($(this).hasClass("slick-current")) {
                                        active_index = s_id;
                                    }
                                }
                                if (index === 1) {
                                    if (s_id === active_index) {
                                        $(this).addClass("slick-current");
                                    } else {
                                        $(this).removeClass("slick-current");
                                    }
                                }
                            })
                        });
                        $image_sliders.slick('slickGoTo', 0 ,true);
                    }
                }
                initPhotoSwipeFromDOM('.slide.big.color-'+current_variant);
                $image_sliders.css('opacity', 1);
            }, 500);

            $variants.on('variant-changed', function (e, hook) {
                $(this).find('.active').removeClass('active');
                var $selected = $(this).find('[data-hook="' + hook + '"]');
                $selected.addClass('active');

                //change button properties
                var price = parseInt($selected.data('price'), 10) / 100;
                var price_compare = parseInt($selected.data('compare-price'), 10) / 100;
                var price_money = $selected.data('price-money');

                var title = $selected.data('title');
                var variant_id = $selected.data('value');
                var available = $selected.data('available');
                var inventory_quantity = $selected.data('inventory-quantity');
                var inventory_policy = $selected.data('inventory-policy');
                var on_sale = price_compare > price;

                price = price_money.replace(/[0-9\.]+/, decorateWithZeros(price, 2));
                price_compare = price_money.replace(/[0-9\.]+/, decorateWithZeros(price_compare, 2));

                var $to_cart = $selected.closest('.widget-root').find('.to-cart');

                var $label = $to_cart.find('.label');
                $label.empty();
              
              	var emailCaptureForm = $('#email-capture');
              	var zaiusId = emailCaptureForm.data('list');

                if (available === false || available === 'false') {
                  	if (zaiusId !== '') {
                    	$('#email-capture').removeClass('hide');
                  		$to_cart.addClass('hide');
                  	}
                    $label.text($to_cart.data('sold-label'));
                    $to_cart.addClass('disabled');
                    $to_cart.addClass('grey');
                    $to_cart.removeClass('green');
                } else {
                  if (inventory_quantity > 0) {
                    if (inventory_policy == "continue") {
                        $label.text($to_cart.data('pre-order-label'));
                    } else {
                        $label.text($to_cart.data('to-cart-label'));
                    }
                    $label.append('<span class="price" />');

                    var $price = $label.find('.price');
                    $price.append('<span class="value" />');
                    $price.find('.value').text(price);

                    if (on_sale) {
                        $price.prepend('<span class="compare" />');
                        $price.find('.compare').text(price_compare);
                    }
                    $to_cart.removeClass('disabled');
                  }
                  
//                   else {
//                     $label.text($to_cart.data('coming-soon-label'));
//                     $to_cart.addClass('disabled');
//                   }
                  if (zaiusId !== '') {
                    $('#email-capture').addClass('hide');
                    $to_cart.removeClass('hide');
                  }
                  $to_cart.removeClass('grey');
                  $to_cart.addClass('green');
                }

                $to_cart.data('title', title);
                $to_cart.data('image', $selected.data('image'));
                $to_cart.data('price', $selected.data('price'));
                $to_cart.data('price', $selected.data('price-compare'));
                $to_cart.data('value', variant_id);
                $to_cart.data('sku', $selected.data('sku'));
                $to_cart.data('available', available);
                $to_cart.data('inventory-quantity', inventory_quantity);
                $to_cart.data('inventory-policy', inventory_policy);

                //$to_cart.removeClass('disabled');

                //visible attributes for debuging
                $to_cart.attr('data-title', title);
                $to_cart.attr('data-image', $selected.data('image'));
                $to_cart.attr('data-price', $selected.data('price'));
                $to_cart.attr('data-price', $selected.data('price-compare'));
                $to_cart.attr('data-inventory-quantity', inventory_quantity);
                $to_cart.attr('data-inventory-policy', inventory_policy);
                $to_cart.attr('data-value', variant_id);
                $to_cart.attr('data-sku', $selected.data('sku'));
                $to_cart.attr('data-available', available);
            });

            $variants.find('.variant').on('click', function() {
                var hook = $(this).data('hook');
                var sku = $(this).data('sku');
				var title = $(this).data('title');
                $('section.pdp').find('.sku-landing').html(sku);
				$('section.pdp').find('.color-name-landing').html(title);

				if ($(this).hasClass('color')) {
					var $image_sliders = $([$section_pdp_main_slides[0], $section_pdp_side_slides[0]]);

	                if (swatch_map.hasOwnProperty(hook)) {
	                    $image_sliders.slick('slickUnfilter');
	                    $image_sliders.slick('slickFilter', '.color-'+hook+', .external-video');
	                    $image_sliders.each(function(index, slide){
	                        var s_id = 0;
	                        $(".slick-slide:not(.slick-cloned)", slide).each(function(s_index, s_slide) {
	                            $(this).attr("data-slick-index", s_id);
	                            s_id++;
	                            if (index === 0) {
	                                if ($(this).hasClass("slick-current")) {
	                                    active_index = s_id;
	                                }
	                            }
	                            if (index === 1) {
	                                if (s_id === active_index) {
	                                    $(this).addClass("slick-current");
	                                } else {
	                                    $(this).removeClass("slick-current");
	                                }
	                            }
	                        })
	                    });
	                    $image_sliders.slick('slickGoTo', 0, true);
	                    initPhotoSwipeFromDOM('.slide.big.color-'+hook);
	                }
				}

                $('.variants.only-one').trigger('variant-changed', hook);
    		});

            initPhotoSwipeFromDOM('.slide.big.color');
		}

		/*
			Add to Cart bind
		*/

		$('.tabbed .tab').on('click', function(){
            var $this = $(this);
            var target = $this.data('target');
            var $tabs = $this.closest('.tabs');
            var $tab_active = $tabs.find('.tab.active');
            $tab_active.removeClass('active');
            $this.addClass('active');

            var $root = $this.closest('.root');
			var $target = $root.find('.target-'+target);

            var height = $target.outerHeight(true);
            $root.find('.tab-content-wrap').outerHeight(height);

            $root.find('.tab-content.active').removeClass('active');
			$target.addClass('active');
        });

		$('.tabbed .tab.active').trigger('click');

		if ($('.tabbed').length) {
			onresize.tabbed = function() {
				$('.tabbed .tab.active').trigger('click');
			}
		}

		$('a[target="_tab"]').on('click', function(e){
			e.preventDefault();
			var href = $(this).attr('href');
			var target = $(this).data('target');
			var $dest = $(href);

			$('html, body').animate({
				scrollTop: $dest.offset().top - 150
			}, 500, 'easeInOutQuint');

			$dest.find('.tab[data-target="'+target+'"]').trigger('click');
		});


		/*
			COLLECTION FILTER
		*/

		var $collection_marquee = $('#collection-marquee');
		var $collection_filter_wrap = $('#collection-filter-wrap');
		var $collection_filter = $('#collection-filter');
		var $collection_filter_toggle = $('#collection-filter-toggle');
		var $collection_filter_spacer = $('#collection-filter-spacer');
        var $product_grid = $('#product-grid');
		var $products_grid_root = $('#products-grid-root');

		//Stamat's infiniteLoader
        //recursively load products within a collection
		function infiniteLoader(obj, iterate, callback) {
			if (!obj.$destination || !obj.$destination.length) {
				console.warn('infiniteLoader', 'invalid $destination property');
				return;
			}

			var $pagination = $(obj.start_pagination_hook ? obj.start_pagination_hook : '.pagination');
            var $next = $pagination.find(obj.next_hook ? obj.next_hook : '.next');
            if ($next.length === 0) {
                if (callback) {
                    callback(); //the end
                }
                return;
            }

            var url = $next.find('a').attr('href');

            if (url && !$pagination.hasClass('loading')) {
                $pagination.addClass('loading');
				if (obj.body_load) {
					$('body').addClass('loading');
				}

                $.get(url, function( data ) {
                    var $result = $(data);

                    var $items = $result.find(obj.item_hook ? obj.item_hook : '.ajax-item');

					obj.$destination.append($items);

					if (iterate) {
						iterate($items);
					}

					var $result_pagination = $result.find(obj.pagination_hook ? obj.pagination_hook : '.pagination');
					var $new_next = $result_pagination.find(obj.next_hook ? obj.next_hook : '.next');

					$pagination.removeClass('loading');

					if ($new_next.length) {
						$pagination.html($result_pagination.html());
						infiniteLoader(obj, iterate, callback);
					} else {
						if (callback) {
							callback(); //the end
						}
					}

					if (obj.body_load) {
						$('body').removeClass('loading');
					}
                });
            }
        }

        if ($product_grid.length) {

            $product_grid.isotope({
                  initLayout: false,
                  itemSelector: '.item.product',
                  layoutMode: 'fitRows',
                  percentPosition: true,
                  masonry: {
                    columnWidth: '.item.product'
                  },
                  getSortData: {
                    price: '[data-price] parseInt',
                    rating: function($elem) {
                        $elem = $($elem);
                        return parseFloat($elem.data('rating'));
                    }
                  }
            });

			if ($product_grid.find('.item.product').length) {
				$product_grid.isotope('layout');
			}

            $product_grid.isotope( 'on', 'arrangeComplete', function(items) {
                
                $("#product-grid a.item.last-sorted-item").removeClass("last-sorted-item");
                $("#product-grid a.item.first-sorted-item").removeClass("first-sorted-item");
                $("#product-grid a.item").removeAttr("data-tabindex-order");
                $("#product-grid a.item").data("tabindex-order", "");
                    
                var total_items_count = items.length;
                $(items).each(function(order_index){

                    if(order_index == 0) {
                        $(this.element).addClass('first-sorted-item'); 
                    }   

                    if(order_index == (total_items_count - 1)) {
                        $(this.element).addClass('last-sorted-item'); 
                    }

                    $(this.element).attr("data-tabindex-order", order_index); 
                    $(this.element).data("tabindex-order", order_index); // this is required for jquery cache to avoid issue
                });

                if(!handledCollectionFilterFocus) {
                    handleCollectionsFocus();
                    handledCollectionFilterFocus = true;
                }
                
				var $stat = $product_grid.parent().find('.stat');

				if (!$stat.hasClass('is-filtered')) {
					$stat.find('.filtered').stop(true).fadeOut({
	                    duration: 250,
	                    easing: 'easeInOutQuint'
	                });
					$stat.find('.count').html(items.length);
				} else {
					$stat.find('.filtered').stop(true).fadeIn({
	                    duration: 250,
	                    easing: 'easeInOutQuint'
	                });
					$stat.find('.current').html(items.length);
				}
            });

            infiniteLoader({
				$destination: $product_grid,
				start_pagination_hook: '#products-grid-root .pagination',
				pagination_hook: '#products-grid-root .pagination'
			}, function($items) {

				$product_grid.isotope('appended', $items);

				loadme($items);

              	$product_grid.isotope('layout');

				$product_grid.parent().find('.stat .value').html($product_grid.find('.ajax-item').length);

			}, function() {
	                var $filter = $('#collection-filter-wrap');
	                if ($filter.length) {
	                    buildFilter($filter, [], $product_grid, '.item.product');
	                }

					$filter.addClass('loaded');
					$('#products-grid-root').addClass('loaded');
					$('#collection-loader').fadeOut({
	                    duration: 250,
	                    easing: 'easeInOutQuint'
	                });
            });
        }

		function collectionFilterHeight(val) {
			if (val === undefined || val === null) {
				val = $collection_filter.find('.filter-inner').outerHeight();
			}
			$collection_filter.height(val);
		}

		function collectionFilterHeightDesktop(val) {
			if (val === undefined || val === null) {
				val = $collection_filter.find('.filter-inner').outerHeight();

				var alt_val = $products_grid_root.outerHeight();

				if (val < alt_val) {
					val = alt_val;
				}
			}
			$collection_filter.height(val);
			$collection_filter_spacer.height(val);
		}

		function collectionFilterOpen() {
			if (window.innerWidth >= 960) {
				$body.addClass('filter-open-desktop');
				setTimeout(function() {
					$product_grid.isotope('layout');
				}, 500);
				collectionFilterHeightDesktop();
			} else {
				$body.addClass('filter-open-mobile');

				if ($body.hasClass('filter-attached')) {
//                                    console.log("disableScroll() 1")
//					disableScroll(); // Commented this to fix scroll issue for filters list
				}
			}
            $product_grid.isotope('layout');
		}

		function collectionFilterClose() {
			if (window.innerWidth >= 960) {
				$body.removeClass('filter-open-desktop');
				setTimeout(function() {
					$product_grid.isotope('layout');
				}, 500);
				collectionFilterHeightDesktop(0);
			} else {
				$body.removeClass('filter-open-mobile');
				collectionFilterHeight(0);
			}
			enableScroll();
            $product_grid.isotope('layout');
		}


		if ($collection_filter_toggle.length) {
			$collection_filter_toggle.on('click', function(e){
				e.preventDefault();

				if (window.innerWidth >= 960) {
					if ($body.hasClass('filter-open-desktop')) {
						collectionFilterClose();
					} else {
						collectionFilterOpen();
					}
				} else {
					if ($body.hasClass('filter-open-mobile')) {
						collectionFilterClose();
                                                
                                                // Filter scroll issue fixes for iPhone by Lalmani
//                                                $("#collection-products").css("visibility", "visible");
//                                                
//                                                window.scrollTo(0, 0);
                                                $('html').css('overflow', 'auto');
					} else {
//                                                $("#collection-products").css("visibility", "hidden");
//                                                if ($body.hasClass('filter-attached')) {
//                                                    $body.removeClass('filter-attached');
//                                                    }

                                                setTimeout(function(){
                                                    collectionFilterOpen();
                                                }, 200); // due to 
                                                
                                                $('html').css('overflow', 'hidden');
					}
				}
			});

            $product_grid.isotope( 'on', 'arrangeComplete', function(items) {
                if ($body.hasClass('filter-open-desktop') && window.innerWidth >= 960) {
                    collectionFilterHeightDesktop();
                }
            });

			$collection_filter_wrap.find('.filter-close').on('click', function(e){
				e.preventDefault();

				$collection_filter_toggle.trigger('click');
			});

			onresize_desktop.collectionFilter = function() {
				if ($body.hasClass('filter-open-desktop')) {
					collectionFilterHeightDesktop();
				}

				if ($body.hasClass('filter-open-mobile')) {
					$body.removeClass('filter-open-mobile');
					enableScroll();
				}
			};

			var scene_filter_attached = new ScrollMagic.Scene({triggerElement: '#filter-attached-trigger', triggerHook: 0})
				.setClassToggle("body", "filter-attached").offset(-60)
				.addTo(controller);
		}

		$(window).scroll(function() {
			if (window.innerWidth < 960) {
				if ($body.hasClass('filter-open-mobile') && $body.hasClass('filter-attached')) {
//                                    console.log("disableScroll 2");
//                                    disableScroll();
				}
			}
		});
                
//                if(isMobileScreen()) {
//                    collectionFilterClose(); // close filter by default for mobile screen
//                }

		/*
			======================
				 QUICK SEARCH
			======================
		*/

            //load popular quicksearches
            if(ENV == "PRODUCTION" ) {
                $.ajax({url: 'https://oshinstudio.com/incipio/search.php', dataType: 'json'}).done(function(data) {
                    loadPopulerSearch(data);
                });
            } else { // load hard coded for local and staging
                var data = [{"terms":"iPhone","handle":"iphone"},{"terms":"Galaxy","handle":"galaxy"},{"terms":"iPhone 11","handle":"iphone-11"},{"terms":"title:Samsung","handle":"samsung"},{"terms":"title:iPhone 8","handle":"iphone-8"},{"terms":"title:Ipad","handle":"ipad"}];
                loadPopulerSearch(data);
            }
        
                function loadPopulerSearch(data) {
                    if (data && data.length) {
                        var $landing = $('#search-popular');
                        $landing.find('.pane-block-link').remove();

                        for (var i = 0; i < data.length; i++) {
                            var item = data[i];
                            $btn = $('<button class="pane-block-link" data-term="'+decodeURI(item.terms)+'">'+decodeURI(item.terms)+'</button>');
                            $btn.on('click', function() {
                                $('#search').val($(this).text()).trigger('keyup');
                            });
                            $landing.append($btn);
                    }
                }
            }

		//log popular quicksearch
		function logSearch(terms, dest_url) {
                    if(ENV !== "PRODUCTION") {
                        return;
                     }
                     
			if (!terms || terms.trim() === '' || terms.length < 3) {
				return;
			}

			if (!dest_url) {
				dest_url = 'https://oshinstudio.com/incipio/search.php';
			}

			url = dest_url + '?terms=' + encodeURI(terms) + '&handle=' + encodeURI(slug(terms));
			$.ajax({method: "POST", url: url});
		}

		var cache = {};
        var keytimer = null;

		function quickSearch(val, callback, cache_on, timeout) {
			if (timeout === undefined || timeout === null) {
				timeout = 500;
			}

			if (val.trim() === '' || val.length < 3) {
				if (callback) {
					callback(null, val);
//                                     openSearch();
				}
//                                alert(keycode);
//                                        if(keycode == 13){
//                                        openSearch();
//                                        }
//                                openSearch();
                            return;
            }

            if (keytimer) {
                clearTimeout(keytimer);
                keytimer = null;
            }

            keytimer = setTimeout(function(){
                if (cache_on && val in cache) {
					if (callback) {
						callback(cache[val], val);
					}
    				return;
    			}

            if (val != '') {
                $.ajax({
                    url: "/search",
                    data: {
                        q: ''+val+'',
                        type: "product",
                        view: "ajax",
                    },
                    beforeSend: function() {
                        $("#search-pane").addClass("loading");
                    },
                    //dataType: "json",
                    success: function( data ) {
                        
                        $("#search-pane").removeClass("loading");
                        
                        if (data && cache_on) {
                            cache[val] = data;
                        }

                        if (callback) {
                            callback(data, val);
                        }
                    }
                });
            }else{
                openSearch();
            }

                keytimer = null;
            }, timeout);
		}

		function buildResults(data, terms) {
			var $pane = $('#search-pane');
			var $landing = $pane.find('.items-landing');
			var $search_contents = $pane.find('.search-has-items');

			if (data) {
				$search_contents.hide();

				$landing.html(data);
				var $items = $landing.find('.pane-item');
				var $dest = $landing.find('.pane-items');

				$dest.isotope({
					  initLayout: false,
					  itemSelector: '.pane-item',
					  layoutMode: 'fitRows',
					  percentPosition: true,
					  masonry: {
						columnWidth: '.pane-item'
					  },
					  getSortData: {
						price: '[data-price] parseInt',
						rating: function($elem) {
							$elem = $($elem);
							return parseFloat($elem.data('rating'));
						}
					  }
				});

				$dest.isotope( 'on', 'arrangeComplete', function(items) {
					$landing.find('.stat .count').html(items.length);
				});


				infiniteLoader({
					$destination: $dest,
					body_load: true,
					start_pagination_hook: '#search-pane .pagination-wrap .pagination',
					pagination_hook: '.pagination-wrap .pagination'
				}, function($items) {
					if ($items.length) {
						$dest.isotope().isotope('appended', $items);

						$landing.find('.stat .count').html($dest.find('.ajax-item').length);

					}
				}, function() {
						$('#search-pane').removeClass('loading');
						$pane.find('.pane-empty').stop(true).fadeOut({
							duration: 250,
							easing: 'easeInOutQuint',
							complete: function() {
								$search_contents.stop(true).fadeIn({
									duration: 250,
									easing: 'easeInOutQuint',
									complete: function() {
										$dest.isotope('layout');
									}
								});
							}
						});

						//$dest.isotope('layout');
						/* var $filter = $('#search-filter-wrap');
						if ($filter.length) {
							buildFilter($filter, [], $dest, '.pane-item');
						} */
				});

				if ($items.length && terms) {
					logSearch(terms);
				}
			} else {
				$search_contents.stop(true).fadeOut({
					duration: 250,
					easing: 'easeInOutQuint',
					complete: function(){
						$landing.html('');
						$pane.find('.pane-empty').stop(true).fadeIn({
							duration: 250,
							easing: 'easeInOutQuint'
						});
					}
				});
			}
        }
        
        $('#search').on('keypress', function(e){          
            if (e.which === 13) {
	      return false;
	     }           
        });
        $('#search').on('keyup', function(e){
            var $this = $(this);
            var val = $this.val();
			val = val.trim();
                        
			if (e.which === 13) {
				return false;
			}

			if (val && val !== '' && val.length > 2) {
				$('#search-pane').addClass('loading');
			}

			quickSearch(val, function(data, val) {
				buildResults(data, val);
			});
        });

		$('#search').on('focus', function(){
			$(this).parent().addClass('focus');
		}).on('blur', function(){
			$(this).parent().removeClass('focus');
		});

		$search_filter_toggle = $('#search-filter-toggle');
		if ($search_filter_toggle.length) {
			$search_filter_toggle.on('click', function(e){
				e.preventDefault();
				$('#search-pane').toggleClass('filter-open');
			});
		}

		$('#search-filter-wrap .filter-close').on('click', function(e){
			e.preventDefault();
			$search_filter_toggle.trigger('click');
		});


		// Account
		$('#RecoverPasswordForm').submit(function(){
            setCookie('recovery', true, 1);
            return true;
        });

        if ($('#CustomerLoginForm').length) {
            if (getHash() != "recover" && getCookie('recovery') && getCookie('recovery') !== '') {
                $('#ResetSuccess').show();
            }
            eraseCookie('recovery');
        }
        

        /* // Now did this in login.liquid file without animation to display fast when forgot password page loads
		if ($('#login-form').length) {
            var hash = getHash();
            if (hash && hash === 'recover') {
				$('#CustomerLoginForm').fadeOut({
					duration: 250,
					easing: 'easeInOutQuint',
					complete: function() {
						$('#RecoverPasswordForm').fadeIn({
							duration: 250,
							easing: 'easeInOutQuint',
						});
					}
				});
            }
        }
        */

		if ($('#orders').length) {
			var hash = getHash();
            if (hash && hash === 'orders') {
				$('#profile').hide();
				$('#orders').show();

                            var $activeTab = $('#account-header').find('.active');
                            $activeTab.attr("aria-label", $activeTab.find("span.label").html());
                            $activeTab.removeClass('active');

                            $('#account-header .orders').addClass('active');
                            $('#account-header .orders').attr("aria-label", "Orders -- Active");
            }

			$('#account-header .orders').on('click', function(e) {
				e.preventDefault();
                                
				var $activeTab = $('#account-header').find('.active');
                                $activeTab.attr("aria-label", $activeTab.find("span.label").html());
                                $activeTab.removeClass('active');

                                $(this).addClass('active');
                                $(this).attr("aria-label", "Orders -- Active");
                                
				$('#profile').fadeOut({
					duration: 250,
					easing: 'easeInOutQuint',
					complete: function() {
						$('#orders').fadeIn({
							duration: 250,
							easing: 'easeInOutQuint',
						});
					}
				});
			});

			$('#account-header .profile').on('click', function(e) {
				e.preventDefault();
                                
				var $activeTab = $('#account-header').find('.active');
                                $activeTab.attr("aria-label", $activeTab.find("span.label").html());
                                $activeTab.removeClass('active');

                                $(this).addClass('active');
                                $(this).attr("aria-label", "Profile -- Active");
                    
				$('#orders').fadeOut({
					duration: 250,
					easing: 'easeInOutQuint',
					complete: function() {
						$('#profile').fadeIn({
							duration: 250,
							easing: 'easeInOutQuint',
						});
					}
				});
			});
		}

        $('#RecoverPassword').on('click', function(){
			$('#CustomerLoginForm').fadeOut({
				duration: 250,
				easing: 'easeInOutQuint',
				complete: function() {
					$('#RecoverPasswordForm').fadeIn({
						duration: 250,
						easing: 'easeInOutQuint',
					});
				}
			});
        });

        $('#HideRecoverPasswordLink').on('click', function(){
			$('#RecoverPasswordForm').fadeOut({
				duration: 250,
				easing: 'easeInOutQuint',
				complete: function() {
					$('#CustomerLoginForm').fadeIn({
						duration: 250,
						easing: 'easeInOutQuint',
					});
				}
			});
            window.location.hash = '';
        });

		var $order_summary = $('#order-summary');

		if ($order_summary.length) {
			var $product_images = $('.product-data .image-wrap');
			$product_images.each(function() {
				var variant = $(this).data('variant');

				if (variant) {
					variant = slug(variant);

					if (window.COLORS.hasOwnProperty(variant)) {
						var $colors = $('<span class="colors" />');
						var $color = $('<span class="color" />');

						$color.addClass('color-value-' + variant);
						$colors.append($color);
						$(this).parent().append($colors);
					}
				}
			});
		}

		$('.faq .faq-item .title').on('click', function() {
			var $this = $(this);
			if ($this.hasClass('active')) {
				$this.removeClass('active');
				$this.closest('.faq-item').find('.rest').stop(true).slideUp({
                    duration: 250,
                    easing: 'easeInOutQuint'
                });
			} else {
				$this.addClass('active');
				$this.closest('.faq-item').find('.rest').stop(true).slideDown({
                    duration: 250,
                    easing: 'easeInOutQuint'
                });
			}
		});

		/** END **/
        loadme();
        hoverme();
		$(window).on('resize', onResize);
		onResize();

    },
    finalize: function(a, b, c) {
      // JavaScript to be fired on all pages, after page specific JS after everything else was executed
    },
    // Home page
    'home': function() {
        // JavaScript to be fired on the home page
    },
    // About us page, note the change from about-us to about_us.
    'about_us': function() {
        // JavaScript to be fired on the about us page
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {};

  UTIL.namespace = boilerwise;

  // Parses arguments in body's attribute data-args that are passed to the functions
  // Arguments are coma sepparated like in array without the need to begin and end with []
  UTIL.argsParse = function(args) {
    if (!args || args.replace(/^\s\s*/, '').replace(/\s\s*$/, '') === '') {
      return [];
    }

    if (!args.match(/^\[/gmi)) {
      args = '[' + args;
    }

    if (!args.match(/$\]/gmi)) {
      args = args + ']';
    }

    args = '{ "arr": ' + args + '}';

    try {
      args = JSON.parse(args);
    } catch(e) {
      if (window.console && window.console.error) {
        console.error(e);
      }
      return [];
    }

    return args.arr;
  };

  UTIL.fire = function(func, args) {
    var namespace = UTIL.namespace;

    if (func !== '' &&
        namespace[func] &&
        typeof namespace[func] === 'function') {

      namespace[func].apply(null, args);
    }
  };

  UTIL.loadEvents= function() {
    var body = document.body;
    var args = UTIL.argsParse($(body).data('args'));

    // Fire common init JS
    UTIL.fire('init', args);

    // Fire page-specific init JS, and then finalize JS
    $.each(body.className.split(/\s+/), function(i, classnm) {
      //todo: get data args

      UTIL.fire(classnm.replace(/-/g, '_'), args);
    });

    // Fire common finalize JS
    UTIL.fire('finalize', args);
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

//Stamat's Shopify shortcode system
function parseSections($elem, one) {
    var map = {};
    var last_section = null;

    var children = $elem.children();
    var re = /\[([\/a-z0-9\-_\s]+)\]/gi;
    var shortcode_counter = 0;

    for (var i = 0; i < children.length; i++) {
        var $child = $(children[i]);

        var text = $child.text().toLowerCase().trim();

        var match = re.exec(text);
        re.lastIndex = 0; //regex needs a reset in for loops, I always forget this

        if (match && match.length > 1) {

            // detect closing tag, replace with /^\// regex
            if (match[1].indexOf('/') === 0 && last_section && last_section.indexOf(match[1].replace(/^\//, '')) > -1) {
                last_section = null;
                $child.remove();
                continue;
            }

            last_section = match[1] + ' sc' + shortcode_counter;
            var $self_locator = $('<div class="self-anchor shortcode-' + last_section.split(/\s+/)[0] + ' sc' + shortcode_counter + '" />');

            if (!map.hasOwnProperty(last_section)) {
                map[last_section] = [];
                shortcode_counter++;
            }

            $child.before($self_locator);
            map[last_section].push($self_locator);
            $child.remove();

            continue;
        }

        if (last_section) {
            map[last_section].push($child);
            $child.detach();
        }

        if (one && last_section !== one) {
            if (map.hasOwnProperty(one)) {
                return map[one];
            }
        }
    }

    if (one && map.hasOwnProperty(one)) {
        return map[one];
    }
    return map;
}

//TODO: what about subtag parses?
function parseAttributes(descriptor, attrs) {
    var res = {
        classes: [],
        css: {}
    };

    var fns = {};

    //option to add parsers from descriptor
    if (descriptor.hasOwnProperty('attribute_parsers')) {
        for (var k in descriptor.attribute_parsers) {
            fns[k] = descriptor.attribute_parsers[k];
        }
    }

    //some default parsers
    fns['header'] = function (pts, descriptor, attr) {
        var $header = null;
        if (descriptor.hasOwnProperty('header_selector') && descriptor.header_selector) {
            $header = $(descriptor.header_selector);
        }

        if ($header === null || !$header.length) {
            $header = $('header');
        }

        if ($header === null || !$header.length) {
            $header = $('body');
        }

        $header.addClass(pts.join('-'));
    }

    fns['placement'] = function (pts, descriptor, attr) {
        if (pts[0]) {
            if (pts[0] === 'content') {
                descriptor.anchor = 'self';
            } else {
                descriptor.anchor = '.shortcode-landing-' + pts[0];
            }
        }
    }

    fns['background'] = function (pts, descriptor, attr) {
        if (pts[0] && pts[0] === 'color' && pts[1]) {
            res.css['background-color'] = pts[1];
        } else {
            res.classes.push(attr);
        }
    }

    fns['color'] = function (pts, descriptor, attr) {
        if (pts[0]) {
            res.css['color'] = pts[0];
        } else {
            res.classes.push(attr);
        }
    }

    for (var i = 0; i < attrs.length; i++) {
        var attr = attrs[i].trim().toLowerCase();
        var pts = attr.split('-');
        if (pts[0] && fns.hasOwnProperty(pts[0])) {
            fns[pts.shift()](pts, descriptor, attr);
        }
    }

    return res;
}

function getTemplate(selector) {
    var $template = $('#templates').find(selector + '.template').clone();
    $template.removeClass('template');
    return $template;
}

function executeShortcodes($elem, fn_map, callback) {
    $($elem).css('visibility', 'hidden');
    var shortcode_map = parseSections($elem);
    
//    console.log("shortcode_map");
//    console.log(shortcode_map);

    for (var k in shortcode_map) {
        var attrs = k.split(/\s+/gi);

        var fn_name = attrs.shift();

        if (fn_map !== undefined && fn_map.hasOwnProperty(fn_name)) {
            fn_map[fn_name](fn_name, attrs, shortcode_map[k]);
        }
    }

    $($elem).css('visibility', 'visible');

    if (callback !== undefined) {
        callback(shortcode_map, fn_map);
    }
}

var example_descriptor = {
    template: 'section.carousel',
    anchor: '.carousel-landing', // or "self" if you use a closing tag for shortcode this will inject the shortcode
    item_template: '.slide.section-carousel',
    item_anchor: '.slides-landing',
    bind_fn: 'append', // jquery function html, text, append, before, prepend
    elements: {
        'img': {
            count: 'many',
            bind_fn: function () {
                // console.log('whoa');
            },
            extract_fn: 'attr', //what about the alt images?
            extract_attr: ['src', 'alt'], //if extract is attr you need to provide which attr, can be string or array
            anchor: '.image-landing',
            anchor_element: 'item'
        },
        'h1, h2, h3, h4': {
            count: 'many', // count = 'many' or num
            bind_fn: 'html', // jquery function html, text, append, before, prepend, or custom function
            extract_fn: 'html', // jquery function html, text, self, attr or custom function
            anchor: '.title-landing', // where on element should it land
            anchor_element: 'item', // item or template or anchor (to the selected element)
        },
        'rest': {
            extract_fn: 'self',
            bind_fn: 'append',
            anchor: '.rest-landing',
            anchor_element: 'item'
        }
    }
};

//if this isn't a God function I don't know what is... Wait, I know, it's a terrible nonrefactored code!
function shortcodeDataBinder(descriptor, val) {
    
//    console.log('descriptor.elements');
//    console.log(descriptor.elements);
        
    var $template = null;

    if (descriptor.hasOwnProperty('template')) {
        $template = getTemplate(descriptor.template);
    }

    var item_tags = [];
    var item_tag = null;
    var elements = {};
    var other_than_rest = {};
    var other_than_rest_count = 0;
    var first_element_key = null;
    var last_element_key = null;

    var cycle_counter = 0;
    var cycle_flag = true;

    function newCycle() {
        if (cycle_flag) {
            return;
        }
        cycle_flag = true;
        cycle_counter++;
    }

    function resetCycle() {
        cycle_flag = false;
    }

    //extract other than rest
    if (descriptor.hasOwnProperty('elements')) {
        for (var k in descriptor.elements) {
            if (k !== 'rest') {
                last_element_key = k;
                if (!elements.hasOwnProperty(k)) {
                    elements[k] = [];
                }

                if (first_element_key === null) {
                    first_element_key = k;
                }

                if (!other_than_rest.hasOwnProperty(k)) {
                    other_than_rest[k] = true;
                    other_than_rest_count++;
                }
            }
        }
    }
    //rest has to be always present, it is a default nondefined element
    elements.rest = [];

    function resultCollector() {
        var re = /^\{([a-z0-9\-_\s]+)\}$/gi; //repetitive arguments

        for (var i = 0; i < val.length; i++) {
            var $item = $(val[i]);

            if ($item.hasClass('self-anchor')) {
                // find yourself in this confusion
                if (descriptor.anchor === 'self') {
                    descriptor.anchor = $item;
                }
                continue;
            }

            //if the contents are empty
            if (!$item.is('img') && $item.html().trim() === '') {
                continue;
            }

            var green_flag = false;

            //testing for slide attributes
            if (descriptor.hasOwnProperty('item_template')) {
                var text = $item.text().toLowerCase().trim();
                var match = re.exec(text);

                if (match && match.length > 1) {
                    item_tag = match[1];

                    green_flag = true;
                    newCycle();

                    item_tags[cycle_counter] = item_tag;
                }
            }
            
//            console.log('other_than_rest');
//            console.log(other_than_rest);
			console.log('other_than_rest_count', other_than_rest_count);
            if (other_than_rest_count && !green_flag) {

                for (var k in other_than_rest) {

                    if (elements[k].length === descriptor.elements[k].count) { //if the count of elements reatches set count
                        continue;
                    }

                    //XXX: this is a temporary and very bad solution
                    if (k === 'img' && $item.find('li').length) {
                        continue;
                    }

                    var $inner = $item.find(k); //gotta cover all the possible cases of undefined generated html

                    if ($item.is(k) || $inner.length) {
                        if ($inner.length) {
                            $item = $inner.first();
                        }
                     


//                        console.log('$item');
//                        console.log($item);
                        
//                        console.log('elements[k]');
//                        console.log(elements[k]);
                        elements[k].push($item);
                      
                      
                        green_flag = true;
                        //use interupts only if it is a repeater element, otherwise store all
                        if (descriptor.hasOwnProperty('item_template')) {
                          if (descriptor.template == 'section.cta-carousel') {
                                             console.log('k', k);
                        console.log('last_element_key', last_element_key);
                      }
                            if (k === last_element_key) {
                              console.log('RESET 1 - k', k);
                              console.log('RESET 1 - last_element_key', last_element_key);
                                resetCycle();
                            } else {
//                               console.log('NEW 1', k, last_element_key);
                                newCycle();
                            }
                        }
                        break;
                    }
                }
            }

            if (!green_flag) {
                //collecting other elements
                if (descriptor.hasOwnProperty('item_template')) { //if it is a repeater
                  console.log('RESET 2',$item[0]);
                    resetCycle();

                    if (!elements.rest[cycle_counter]) {
                        elements.rest[cycle_counter] = [];
                    }
                    elements.rest[cycle_counter].push($item[0]);

                } else {
                    elements.rest.push($item[0]);
                }
            }
        }
    }
    resultCollector();

    function resultParser($item, $dest, props) {
        if (props.extract_fn === 'attr') {
            if (typeof props.extract_attr === 'string') {
                extract = $item[props.extract_fn](props.extract_attr);
            } else { // if it has multiple attributes to extract, like alt image -> for binding use custom function
                extract = [];
                for (var i = 0; i < props.extract_attr.length; i++) {
                    if (props.extract_attr[i] === 'html') {
                        extract.push($item.html());
                        continue;
                    }
                    var attr = props.extract_attr[i];
                    extract.push($item[props.extract_fn](attr));
                }
            }
        } else if (props.extract_fn === 'self') {
            extract = $item;
        } else {
            extract = $item[props.extract_fn]();
        }

        //TODO: should be extract_fn typeof function
        if (props.hasOwnProperty('parse')) {
            if (typeof props.parse === 'function') {
                extract = props.parse(extract);  //execute custom extract parsing function
            } else {
                if (window.hasOwnProperty(props.parse)) {
                    extract = window[props.parse](extract);
                }
            }
        }

        if (props.bind_fn === 'css'
                && props.hasOwnProperty('bind_property')
                && props.bind_property === 'background-image') {
            extract = 'url(' + extract + ')';
        } else if (typeof props.bind_fn === 'function') {
            props.bind_fn(extract, $dest, props, descriptor); //execute custom bind function
            return;
        }

        //do some auto binding
        switch (props.anchor_element) {
            case 'item':
                $target = $dest.find(props.anchor);
                if ($dest.is(props.anchor) && $target.length === 0) {
                    $target = $dest;
                }

                if (props.bind_fn === 'css' && props.hasOwnProperty('bind_property')) {
                    $target[props.bind_fn](props.bind_property, extract);
                } else {
                    $target[props.bind_fn](extract);
                }
                break;
            case 'template':
                $target = $dest.find(props.anchor);
                if ($dest.is(props.anchor) && $target.length === 0) {
                    $target = $dest;
                }

                if (props.bind_fn === 'css' && props.hasOwnProperty('bind_property')) {
                    $target[props.bind_fn](props.bind_property, extract);
                } else {
                    $target[props.bind_fn](extract);
                }
                break;
            default:
                $target = $(descriptor.anchor).find(props.anchor);
                if ($(descriptor.anchor).is(props.anchor) && $target.length === 0) {
                    $target = $(descriptor.anchor);
                }

                if (props.bind_fn === 'css' && props.hasOwnProperty('bind_property')) {
                    $target[props.bind_fn](props.bind_property, extract);
                } else {
                    $target[props.bind_fn](extract);
                }
        }
    }

    if (descriptor.hasOwnProperty('item_template')) {
        for (var i = 0; i < elements[first_element_key].length; i++) {
            var $item_template = getTemplate(descriptor.item_template);
          console.log('item_tags', item_tags);
            if (item_tags[i]) {
                $item_template.addClass(item_tags[i]);
            }

            for (var k in descriptor.elements) {
                var props = descriptor.elements[k];
                if (elements[k][i]) { //if the element exists, may be an uneven number
                    var $item = $(elements[k][i]);
                    resultParser($item, $item_template, props);
                }
            }

            var $dest = descriptor.hasOwnProperty('template') ? $template.find(descriptor.item_anchor) : $(descriptor.anchor);
          console.log('$dest', $dest);
          console.log('$dest[descriptor.bind_fn]', $dest[descriptor.bind_fn]);
          console.log('$dest[descriptor.bind_fn]($item_template)', $dest[descriptor.bind_fn]($item_template));
            $dest[descriptor.bind_fn]($item_template);
        }
    } else {
        if (descriptor.hasOwnProperty('elements')) {
            for (var k in descriptor.elements) {
                var props = descriptor.elements[k];

                if (elements.hasOwnProperty(k)) {
                    for (var i = 0; i < elements[k].length; i++) {
                        var $item = $(elements[k][i]);
                        var $dest = descriptor.hasOwnProperty('template') ? $template : $(descriptor.anchor);
                        resultParser($item, $dest, props);
                    }
                }
            }
        } else {
            var $dest = descriptor.hasOwnProperty('template') ? $template : $(descriptor.anchor);
            if (typeof descriptor.bind_fn === 'function') {
                descriptor.bind_fn(elements.rest, $dest);
            } else {
                $dest[descriptor.bind_fn](elements.rest);
            }
        }
    }

    if (descriptor.hasOwnProperty('template')) {
        $(descriptor.anchor)[descriptor.bind_fn]($template);
  		console.log('RETURN $template', $template);
        return $template;
    }
  	console.log('RETURN', $(descriptor.anchor));
    return $(descriptor.anchor);
}

var fn = {};
fn['cta-carousel'] = function (k, attrs, val) {
    var descriptor = {
        template: 'section.cta-carousel',
        anchor: '.shortcode-landing',
        item_template: '.marquee-slide',
        item_anchor: '.slides-landing',
        bind_fn: 'append',
        elements: {
            img: {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
                    var anchor = props.anchor;
                    var $target = $dest;
                    if (!$dest.is(anchor)) {
                        $target = $dest.find(anchor);
                    }
                  
                    $target.css('background-image', 'url(' + extract[0] + ')');

                    if (extract[1] && /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i.test(extract[1])) {
                        var $temp = $('<div class="ytp" data-youtube="' + extract[1] + '"></div>');
                        $target.prepend($temp);
                        $temp.youtube_background({'load-background': false});
                    }
                },
                extract_fn: 'attr',
                extract_attr: ['src', 'alt'],
                anchor: '.image-landing',
                anchor_element: 'item'
            },
            a: {
                count: 'many',
                anchor: '.link-landing',
                extract_fn: 'attr',
                extract_attr: ['href', 'title', 'html'],
                bind_fn: function (extract, $dest, props) {
                    $dest.find(props.anchor).append('<a href="' + extract[0] + '" title="' + extract[1] + '" class="button" role="button">' + extract[2] + '</a>');
                },
                anchor_element: 'item'
            },
            h1: {
                count: 'many',
                bind_fn: 'html',
                anchor: '.title-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            'h2,h3,h4,h5,h6': {
                count: 'many',
                bind_fn: 'html',
                anchor: '.supertitle-landing',
                extract_fn: 'html',
                anchor_element: 'item'
            },
            rest: {
                anchor: '.rest-landing',
                bind_fn: 'append',
                extract_fn: 'self',
                anchor_element: 'item'
            }
        }
    };

    var remaining_attrs = [];
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'placement') {
                if (pts[1]) {
                    if (pts[1] === 'content') {
                        descriptor.anchor = 'self';
                    } else {
                        descriptor.anchor = '.shortcode-landing-' + pts[1];
                    }
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));
  
    ctaSliders($template);
};

fn['image-links'] = function (k, attrs, val) {
    var descriptor = {
        template: 'section.image-links',
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        elements: {
            a: {
                count: 'many',
                anchor: '.link-landing',
                extract_fn: 'self',
                bind_fn: 'append',
                anchor_element: 'template'
            },
            'h1,h2,h3,h4,h5,h6': {
                count: 1,
                bind_fn: 'html',
                anchor: '.title-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            }
        }
    };

    var remaining_attrs = [];
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'placement') {
                if (pts[1]) {
                    if (pts[1] === 'content') {
                        descriptor.anchor = 'self';
                    } else {
                        descriptor.anchor = '.shortcode-landing-' + pts[1];
                    }
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));
};

fn['features'] = function (k, attrs, val) {
    var descriptor = {
        template: 'section.features',
        anchor: '.shortcode-landing',
        item_template: '.box.feature',
        item_anchor: '.boxes-landing',
        bind_fn: 'append',
        elements: {
            'img': {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
                    var $target = $dest.find(props.anchor);
                    if ($dest.is(props.anchor) && $target.length === 0) {
                        $target = $dest;
                    }

                    $target.append('<img src="' + extract[0] + '" alt="' + extract[1] + '" />');
                },
                extract_fn: 'attr',
                extract_attr: ['src', 'alt'],
                anchor: '.image-landing',
                anchor_element: 'item'
            },
            'h1, h2, h3, h4': {
                count: 'many',
                bind_fn: 'html',
                extract_fn: 'html',
                anchor: '.title-landing',
                anchor_element: 'item'
            },
            'rest': {
                extract_fn: 'self',
                bind_fn: 'append',
                anchor: '.rest-landing',
                anchor_element: 'item'
            }
        }
    };

    var remaining_attrs = [];
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'placement') {
                if (pts[1]) {
                    if (pts[1] === 'content') {
                        descriptor.anchor = 'self';
                    } else {
                        descriptor.anchor = '.shortcode-landing-' + pts[1];
                    }
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));
};

fn['info-blocks'] = function (k, attrs, val) {
    var descriptor = {
        template: 'section.boxes',
        anchor: '.shortcode-landing',
        item_template: '.box.infobox',
        item_anchor: '.items-landing',
        bind_fn: 'append',
        elements: {
            img: {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
                    $dest.find(props.anchor).css('background-image', 'url(' + extract[0] + ')');
                    $dest.find('img').attr('alt', extract[1]);
                },
                extract_fn: 'attr',
                extract_attr: ['src', 'alt'],
                anchor: '.image-landing',
                anchor_element: 'item'
            },
            h1: {
                count: 'many',
                bind_fn: 'html',
                extract_fn: 'html',
                anchor: '.title-landing',
                anchor_element: 'item'
            },
            h2: {
                count: 'many',
                bind_fn: 'html',
                extract_fn: 'html',
                anchor: '.supertitle-landing',
                anchor_element: 'item'
            },
            ul: {
                count: 'many',
                bind_fn: 'html',
                extract_fn: 'self',
                anchor: '.list-landing',
                anchor_element: 'item'
            },
            a: {
                count: 'many',
                anchor: '.link-landing',
                extract_fn: 'attr',
                extract_attr: ['href', 'title', 'html'],
                bind_fn: function (extract, $dest, props) {
                    $dest.find(props.anchor).append('<a href="' + extract[0] + '" title="' + extract[1] + '" class="button">' + extract[2] + '</a>');
                    $dest.find('.href-landing').attr('href', extract[0]);
                },
                anchor_element: 'item'
            },
            rest: {
                extract_fn: 'self',
                bind_fn: 'append',
                anchor: '.rest-landing',
                anchor_element: 'item'
            }
        }
    };

    var remaining_attrs = [];
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'placement') {
                if (pts[1]) {
                    if (pts[1] === 'content') {
                        descriptor.anchor = 'self';
                    } else {
                        descriptor.anchor = '.shortcode-landing-' + pts[1];
                    }
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));
};

fn['link-blocks'] = function (k, attrs, val) {
    var descriptor = {
        template: 'section.link-blocks',
        anchor: '.shortcode-landing',
        item_template: '.link-block',
        item_anchor: '.items-landing',
        bind_fn: 'append',
        elements: {
            img: {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
                    $dest.find(props.anchor).css('background-image', 'url(' + extract[0] + ')');
                    $dest.find('img').attr('alt', extract[1]);
                },
                extract_fn: 'attr',
                extract_attr: ['src', 'alt'],
                anchor: '.image-landing',
                anchor_element: 'item'
            },
            h1: {
                count: 'many',
                bind_fn: 'html',
                extract_fn: 'html',
                anchor: '.title-landing',
                anchor_element: 'item'
            },
            h2: {
                count: 'many',
                bind_fn: 'html',
                extract_fn: 'html',
                anchor: '.supertitle-landing',
                anchor_element: 'item'
            },
            a: {
                count: 'many',
                anchor: '.link-landing',
                extract_fn: 'attr',
                extract_attr: ['href', 'title', 'html'],
                bind_fn: function (extract, $dest, props) {
                    $dest.find(props.anchor).append('<a href="' + extract[0] + '" title="' + extract[1] + '" class="button small">' + extract[2] + '</a>');
                    $dest.find('.href-landing').attr('href', extract[0]);
                },
                anchor_element: 'item'
            },
            rest: {
                extract_fn: 'self',
                bind_fn: 'append',
                anchor: '.rest-landing',
                anchor_element: 'item'
            }
        }
    };

    var remaining_attrs = [];
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'placement') {
                if (pts[1]) {
                    if (pts[1] === 'content') {
                        descriptor.anchor = 'self';
                    } else {
                        descriptor.anchor = '.shortcode-landing-' + pts[1];
                    }
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.find(descriptor.item_template).addClass('hoverme');
    hoverme($template);
    $template.addClass(remaining_attrs.join(' '));
};

fn['standout'] = function (k, attrs, val) {
    var descriptor = {
        template: '.standout-content',
        anchor: 'self',
        bind_fn: 'append',
        elements: {
            'rest': {
                extract_fn: 'self',
                bind_fn: 'append',
                anchor: '.rest-landing',
                anchor_element: 'template'
            }
        }
    };

    var remaining_attrs = [];
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'placement') {
                if (pts[1]) {
                    if (pts[1] === 'content') {
                        descriptor.anchor = 'self';
                    } else {
                        descriptor.anchor = '.shortcode-landing-' + pts[1];
                    }
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));
};

fn['faq'] = function (k, attrs, val) {
    var descriptor = {
        template: 'section.faq',
        anchor: '.shortcode-landing',
        item_template: '.faq-item',
        item_anchor: '.faq-landing',
        bind_fn: 'append',
        elements: {
            'h1, h2, h3': {
                count: 'many',
                bind_fn: 'html',
                extract_fn: 'html',
                anchor: '.title-landing',
                anchor_element: 'item'
            },
            'rest': {
                extract_fn: 'self',
                bind_fn: 'append',
                anchor: '.rest-landing',
                anchor_element: 'item'
            }
        }
    };

    var remaining_attrs = [];
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'placement') {
                if (pts[1]) {
                    if (pts[1] === 'content') {
                        descriptor.anchor = 'self';
                    } else {
                        descriptor.anchor = '.shortcode-landing-' + pts[1];
                    }
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));
};

fn['excerpt'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.excerpt-landing',
        bind_fn: function (parts, $dest) {
            for (var i = 0; i < parts.length; i++) {
                $dest.append($(parts[i]).text());
            }
        }
    };

    shortcodeDataBinder(descriptor, val);
};

fn['short-specs'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.short-specs-landing',
        bind_fn: function (parts, $dest) {
            for (var i = 0; i < parts.length; i++) {
                $dest.append($(parts[i]).text());
            }
        }
    };

    shortcodeDataBinder(descriptor, val);
};

fn['spec-block'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.spec-block-landing',
        bind_fn: 'append',
        template: '.spec-block',
        elements: {
            rest: {
                anchor: '.rest-landing',
                bind_fn: 'append',
                extract_fn: 'self',
                anchor_element: 'template'
            }
        }
    };

    if (attrs.length) {
        switch (attrs[0].trim().toLowerCase()) {
            case 'dimensions':
                descriptor.template = descriptor.template + '.dimensions';
                break;
            case 'compatibility':
                descriptor.template = descriptor.template + '.compatibility';
                break;
            case 'weight':
                descriptor.template = descriptor.template + '.weight';
                break;
            case 'drop':
                descriptor.template = descriptor.template + '.drop';
                break;
            case 'material':
                descriptor.template = descriptor.template + '.material';
                break;
            default:
                descriptor.template = descriptor.template + '.custom';
                descriptor.elements = {};

                descriptor.elements.img = {
                    count: 1,
                    bind_fn: 'append',
                    extract_fn: 'self',
                    anchor: '.image-landing',
                    anchor_element: 'template'
                };

                descriptor.elements['h1, h2, h3, h4'] = {
                    count: 1,
                    bind_fn: 'html',
                    anchor: '.title-landing',
                    extract_fn: 'html',
                    anchor_element: 'template'
                };

                //rest-has to be last
                descriptor.elements.rest = {
                    anchor: '.rest-landing',
                    bind_fn: 'append',
                    extract_fn: 'self',
                    anchor_element: 'template'
                }
        }
    }

    shortcodeDataBinder(descriptor, val);
};

fn['detail'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.details-landing',
        bind_fn: 'append',
        template: '.detail',
        elements: {
            rest: {
                anchor: '.value-landing',
                bind_fn: 'html',
                extract_fn: 'html',
                anchor_element: 'template'
            }
        }
    };

    if (!$('.details-landing').hasClass('cleared')) {
        $('.details-landing').addClass('cleared').empty();
    }

    if (attrs.length) {
        switch (attrs[0].trim().toLowerCase()) {
            case 'secure':
                descriptor.template = descriptor.template + '.secure';
                break;
            case 'shipping':
                descriptor.template = descriptor.template + '.shipping';
                break;
            case 'warranty':
                descriptor.template = descriptor.template + '.warranty';
                break;
            default:
                descriptor.template = descriptor.template + '.warranty';
        }
    }

    shortcodeDataBinder(descriptor, val);
};

fn['title-text'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.title-text',
        elements: {
            h1: {
                count: 1,
                bind_fn: 'html',
                anchor: '.title-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            h2: {
                count: 1,
                bind_fn: 'html',
                anchor: '.subtitle-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            rest: {
                anchor: '.rest-landing',
                bind_fn: 'append',
                extract_fn: 'self',
                anchor_element: 'template'
            }
        }
    };

    var remaining_attrs = [];
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'placement') {
                if (pts[1]) {
                    if (pts[1] === 'content') {
                        descriptor.anchor = 'self';
                    } else {
                        descriptor.anchor = '.shortcode-landing-' + pts[1];
                    }
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));
};

fn['patents'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.patents-block',
        elements: {
            'h1, h2, h3, h4, h5, h6': {
                count: 1,
                bind_fn: 'html',
                anchor: '.title-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            rest: {
                anchor: '.patents-landing',
                bind_fn: 'append',
                extract_fn: 'self',
                anchor_element: 'template'
            }
        }
    };

    if ($('#flexible').length) {
        descriptor.anchor = 'self';
    }

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
};

fn['collection'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.category',
        elements: {
            "h1, h2, h3, h4": {
                count: 1,
                bind_fn: 'html',
                anchor: '.title-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            a: {
                count: 1,
                anchor: '.link-landing',
                extract_fn: 'attr',
                extract_attr: ['href', 'title'],
                bind_fn: function (extract, $dest, props) {
                    $dest.find(props.anchor).attr('href', extract[0]);
                    $dest.find(props.anchor).attr('title', extract[1]);

                    $.ajax(extract[0] + '?view=json').done(function (data) {
                        var products = null;

                        try {
                            products = JSON.parse(data);
                        } catch (me) {
                            // if you can
                        }
console.log('products', products);
                        if (products && products.length) {
                            if (window._collection_module_count === undefined) {
                                window._collection_module_count = 0;
                            } else {
                                window._collection_module_count++;
                            }

                            for (var i = 0; i < products.length; i++) {
                                var product = products[i];

                                if ($('#pdp').data('handle') === product.handle) {
                                    continue;
                                }

                                $template.addClass(product.tags.join(' '));

                                $template = getTemplate('.item.product');
                                $template.find('.title-landing').html(product.title);
                                $template.attr('href', product.url);
                                $template.attr('title', product.title);

                                for (var j = 0; j < product.colors.length; j++) {
                                    $template.find('.colors').append('<i class="color color-value-' + slug(product.colors[j].title) + '" />');
                                }

                                $template.find('.image .first').css('background-image', 'url(' + product.image + ')');
                                $template.find('img').attr('alt', product.image_alt);

                                if (product.hasOwnProperty('image_2')) {
                                  // Disabled second image untill we have image avaible
//                                     $template.find('.image .second').css('background-image', 'url(' + product.image_2 + ')');
//                                 } else {
                                    $template.find('.image .second').remove();
                                }

                                $template.find('.price .value').html(product.price);

                                if (product.hasOwnProperty('compare_at_price')) {
                                    $template.find('.price .compare').html(product.compare_at_price);
                                } else {
                                    $template.find('.price .compare').remove();
                                }

                                $template.data('id', product.id);
                                $template.find('.stars').append('<div id="pr-' + window._collection_module_count + '-' + product.id + '"></div>');

                                if (product.devices) {
                                    $template.find('.types').append('<span class="type model">' + product.devices.join(' & ') + '</span>');
                                }


                                $dest.find('.items-landing').append($template);
                            }
                          	
							newSliders($dest, window._collection_module_count + '-');

                        }
                    });
                },
                anchor_element: 'template'
            }
        }
    };

    var remaining_attrs = [];
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'placement') {
                if (pts[1]) {
                    if (pts[1] === 'content') {
                        descriptor.anchor = 'self';
                    } else {
                        descriptor.anchor = '.shortcode-landing-' + pts[1];
                    }
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));
};

fn['button'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: 'section.button-wrap',
        elements: {
            a: {
                count: 1,
                anchor: '.link-landing',
                extract_fn: 'attr',
                extract_attr: ['href', 'title', 'html'],
                bind_fn: function (extract, $dest, props) {
                    var $temp = $('<a class="button" />');
                    $temp.attr('href', extract[0]).attr('title', extract[1]).html(extract[2]);
                    $dest.find(props.anchor).append($temp);
                },
                anchor_element: 'anchor'
            }
        }
    };

    var remaining_attrs = [];
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'placement') {
                if (pts[1]) {
                    if (pts[1] === 'content') {
                        descriptor.anchor = 'self';
                    } else {
                        descriptor.anchor = '.shortcode-landing-' + pts[1];
                    }
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));
};

fn['blog-marquee'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.blog-marquee',
        elements: {
            p: {
                count: 1,
                bind_fn: 'html',
                extract_fn: 'html',
                anchor: '.punchline-landing',
                anchor_element: 'anchor'
            }
        }
    };

    var remaining_attrs = [];
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));
};

fn['collection-marquee'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.collection-marquee',
        elements: {
            img: {
                count: 1,
                bind_fn: function (extract, $dest) {
                    var anchor = props.anchor;
                    var $target = $dest;
                    if (!$dest.is(anchor)) {
                        $target = $dest.find(anchor);
                    }
                    $target.addClass('alt-background').css('background-image', 'url(' + extract[0] + ')');

                    if (extract[1] && /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i.test(extract[1])) {
                        var $temp = $('<div class="ytp" data-youtube="' + extract[1] + '"></div>');
                        $target.prepend($temp);
                        $temp.youtube_background({'load-background': false});
                    }
                },
                extract_fn: 'attr',
                extract_attr: ['src', 'alt'],
                anchor: '.background',
                anchor_element: 'anchor'
            },
            h1: {
                count: 1,
                anchor: '.title-landing',
                extract_fn: 'html',
                bind_fn: 'html',
                anchor_element: 'anchor'
            },
            'h2,h3,h4,h5,h6': {
                count: 1,
                anchor: '.supertitle-landing',
                extract_fn: 'html',
                bind_fn: 'html',
                anchor_element: 'anchor'
            },
            a: {
                count: 1,
                anchor: '.link-landing',
                extract_fn: 'attr',
                extract_attr: ['href', 'title', 'html'],
                bind_fn: function (extract, $dest, props) {
                    $dest.find(props.anchor).append('<a href="' + extract[0] + '" title="' + extract[1] + '" class="button">' + extract[2] + '</a>');
                },
                anchor_element: 'anchor'
            }
        }
    };

    var remaining_attrs = [];
    var bg_color = null;
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'background') {
                if (pts[1]) {
                    bg_color = '#' + pts[1];
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }

    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));

    if (bg_color) {
        $template.css('background-color', bg_color);
    }
};

fn['marquee'] = function (k, attrs, val) {
    var image_counter = 0;

    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: 'section.marquee',
        elements: {
            img: {
                count: 2,
                bind_fn: function (extract, $dest, props) {
                    var anchor = props.anchor[image_counter];
                    var $target = $dest;
                    if (!$dest.is(anchor)) {
                        $target = $dest.find(anchor);
                    }
                    $target.css('background-image', 'url(' + extract[0] + ')');

                    if (image_counter === 0) {
                        if (extract[1] && /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i.test(extract[1])) {
                            var $temp = $('<div class="ytp" data-youtube="' + extract[1] + '"></div>');
                            $target.prepend($temp);
                            $temp.youtube_background({'load-background': false});
                        }
                    }
                    image_counter++;
                },
                extract_fn: 'attr',
                extract_attr: ['src', 'alt'],
                anchor: ['.image-landing', '.image-mobile-landing'],
                anchor_element: 'template'
            },
            a: {
                count: 1,
                anchor: '.link-landing',
                extract_fn: 'attr',
                extract_attr: ['href', 'title', 'target', 'html'],
                bind_fn: function (extract, $dest, props) {
                  
                  if (extract[2] != undefined) {
                    $dest.find(props.anchor).append('<a href="' + extract[0] + '" title="' + extract[1] + '" class="button" target="'+extract[2]+'" role="button">' + extract[3] + '</a>');
                  } else {
                  	$dest.find(props.anchor).append('<a href="' + extract[0] + '" title="' + extract[1] + '" class="button" role="button">' + extract[3] + '</a>'); 
                  }
                },
                anchor_element: 'template'
            },
            h1: {
                count: 1,
                bind_fn: 'html',
                anchor: '.title-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            'h2,h3,h4,h5,h6': {
                count: 1,
                bind_fn: 'html',
                anchor: '.supertitle-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            rest: {
                anchor: '.rest-landing',
                bind_fn: 'append',
                extract_fn: 'self',
                anchor_element: 'template'
            }
        }
    };

    var remaining_attrs = [];
    var bg_color = null;
    function attrMod(attrs) {
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i].trim().toLowerCase();
            var pts = attr.split('-');
            if (pts[0] && pts[0] === 'header') {
                if (pts[1]) {
                    $('header#main').addClass(pts[1]);
                }
            } else if (pts[0] && pts[0] === 'placement') {
                if (pts[1]) {
                    if (pts[1] === 'content') {
                        descriptor.anchor = 'self';
                    } else {
                        descriptor.anchor = '.shortcode-landing-' + pts[1];
                    }
                }
            } else if (pts[0] && pts[0] === 'background') {
                if (pts[1]) {
                    bg_color = '#' + pts[1];
                }
            } else {
                remaining_attrs.push(attr);
            }
        }
    }
    attrMod(attrs);

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(remaining_attrs.join(' '));
    if (bg_color) {
        $template.css('background-color', bg_color);
    }
};

    fn['html-content'] = function (k, attrs, val) {
        var descriptor = {
            anchor: '.shortcode-landing',
            bind_fn: 'append',
            template: '.html-content',
            elements: {
    //            'h1, h2, h3, h4, h5, h6': {
    //                count: 1,
    //                bind_fn: 'html',
    //                anchor: '.title-landing',
    //                extract_fn: 'html',
    //                anchor_element: 'template'
    //            },
                rest: {
                    anchor: '.html-landing',
                    bind_fn: 'append',
                    extract_fn: 'self',
                    anchor_element: 'template'
                }
            }
        };

        if ($('#flexible').length) {
            descriptor.anchor = 'self';
        }

        var $template = shortcodeDataBinder(descriptor, val);
        $template.addClass(attrs.join(' '));
    };
    
/* custom tag added by lalmani */    
fn['video-player'] = function (k, attrs, val) {    
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.video-player',
        elements: {
            p: {
                count: 1,
                bind_fn: function (extract, $dest, props) {                    
                    var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi; 
                    var regex = new RegExp(expression); 
                    var thisVideoURL = extract;//$(extract).attr("href");

                    if (!thisVideoURL.match(regex)) { 
                        console.log("Invalid video URL: "+ thisVideoURL);
                    } else {
//                        console.log("Playing video URL: "+ thisVideoURL);

                        var displayControl = (attrs.indexOf('hide-controls') === -1);
                        var autoplay = (attrs.indexOf('autoplay') !== -1);
                        var fullHeight = (attrs.indexOf('fullheight') !== -1);
                      	var isMute = attrs.indexOf('autosound') == -1 ? true : false;
						
                        $destYoutube = $dest.find(props.anchor);
                        $destYoutube.attr('data-youtube', thisVideoURL);
                        
//                        console.log({
//                            'load-background' : false, 
//                            'display-controls' : displayControl, 
//                            'autoplay' : autoplay, 
//                            'full-height' : fullHeight
//                        });
                        
                        $destYoutube.youtube_background({
                            'load-background' : false, 
                            'display-controls' : displayControl, 
                            'autoplay' : autoplay, 
                            'full-height' : fullHeight,
							'mute': isMute
                        });
                    }
                },
                anchor: '.ytp',
                extract_fn: 'html',
                anchor_element: 'template'
            }
        }
    };
    
    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
};

fn['video-player-with-text'] = function (k, attrs, val) {  
    
//    console.log('attrs');
//    console.log(attrs);
    
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.video-player-with-text',
        elements: {
            a: {
                count: 1,
                bind_fn: function (extract, $dest, props) {    
                    var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi; 
                    var regex = new RegExp(expression); 
                    var thisVideoURL = extract;//$(extract).attr("href");

                    if (!thisVideoURL.match(regex)) { 
                        console.log("Invalid video URL: "+ thisVideoURL);
                    } else {
//                        console.log("Playing video URL: "+ thisVideoURL);

                        var displayControl = (attrs.indexOf('hide-controls') === -1);
                        var autoplay = (attrs.indexOf('autoplay') !== -1);
						var isMute = attrs.indexOf('autosound') == -1 ? true : false;
                      
                        $destYoutube = $dest.find(props.anchor);
                        $destYoutube.attr('data-youtube', thisVideoURL);
                        $destYoutube.youtube_background({'load-background': false, 'display-controls' : displayControl, 'autoplay': autoplay, 'mute': isMute});
                    }
                },
                anchor: '.ytp',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            'h1,h2,h3,h4,h5,h6': {
                count: 1,
                bind_fn: 'html',
                anchor: '.title-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            p: {
                count: 1,
                bind_fn: 'html',
                anchor: '.description',
                extract_fn: 'html',
                anchor_element: 'template'
            }
        }
    };
    
    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
};

fn['text-carousel'] = function (k, attrs, val) {
    
//    console.log(attrs);
    
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.text-carousel',
        elements: {
            img: {
                count: 1,
                bind_fn: function (extract, $dest, props) {
                    if(attrs.indexOf('full-width-image') === -1) {
                        $dest.find(props.anchor).html('<img src="'+extract[0]+'"/>');
                    } else {
                        $targetDest = $dest.find(props.anchor).parent();
                        $targetDest.css('background-image', 'url(' + extract[0] + ')');                    
                    }
                },
                anchor: '.image-landing',
                anchor_element: 'template',
                extract_fn: 'attr',
                extract_attr: ['src']
            },
            'h1,h2,h3,h4,h5,h6': {
                count: 1,
                bind_fn: 'html',
                anchor: '.title-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            p: {
                count: 1,
                bind_fn: 'html',
                anchor: '.description',
                extract_fn: 'html',
                anchor_element: 'template'
            }
        }
    };
    
    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
};

fn['big-carousel'] = function (k, attrs, val) {
    var descriptor = {
        template: 'section.big-carousel',
        anchor: '.shortcode-landing',
        item_template: '.slide.section-big-carousel',
        item_anchor: '.slides-landing',
        bind_fn: 'append',
        elements: {
            'img': {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
                    var $target = $dest.find(props.anchor);
                    if ($dest.is(props.anchor) && $target.length === 0) {
                        $target = $dest;
                    }

                    $target.css('background-image', 'url(' + extract[0] + ')');
                    $target.css('background-size', 'cover');
                    $target.find('.alt-image-landing').append('<img src="' + extract[0] + '" alt="' + extract[1] + '" />');
                },
                extract_fn: 'attr',
                extract_attr: ['src', 'alt'],
                anchor: '.image-landing',
                anchor_element: 'item'
            },
            'h2': {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
                    var $temp = $('<span class="tag"></span>');
                    $temp.html(extract);
                    $dest.find(props.anchor).append($temp);
                },
                extract_fn: 'html',
                anchor: '.tag-landing',
                anchor_element: 'item'
            },
            'h1': {
                count: 'many',
                bind_fn: 'html',
                extract_fn: 'html',
                anchor: '.title-landing',
                anchor_element: 'item'
            },
            'a': {
                count: 'many',
                anchor: '.link-landing',
                extract_fn: 'attr',
                extract_attr: ['href', 'title', 'html'],
                bind_fn: function (extract, $dest, props) {
                    $dest.find(props.anchor).append('<a href="' + extract[0] + '" title="' + extract[1] + '" class="button hollow">' + extract[2] + '</a>');
                },
                anchor_element: 'item'
            },
            p: {
                extract_fn: 'html',
                bind_fn: 'append',
                anchor: '.rest-landing',
                anchor_element: 'item'
            },
            'rest': {
                extract_fn: 'self',
                bind_fn: 'append',
                anchor: '.rest-landing',
                anchor_element: 'item'
            }
        }
    };

    if ($('#flexible').length) {
        descriptor.anchor = 'self';
    }

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
    var $slides = $template.find('.slides');

    $slides.on('init', function (event, slick, currentSlide, nextSlide) {
        var $nextSlide = $(slick.$slides[0]);
        if ($nextSlide.hasClass('invert')) {
            $($template).addClass('dark');
        } else {
            $($template).removeClass('dark');
        }

        $slides.css('opacity', 1);
    });

    $slides.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var $nextSlide = $(slick.$slides[nextSlide]);
        if ($nextSlide.hasClass('invert')) {
            $($template).addClass('dark');
        } else {
            $($template).removeClass('dark');
        }
    });
    
    $slides.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        adaptiveHeight: true,
        arrows: true,
        dots: true,
        appendDots: $template.find('.controls-landing'),
        appendArrows: $template.find('.controls-landing')
    });

    if ($slides.find('.slide').length < 2) {
        $template.find('.controls-landing').remove();
    }
};

fn['test-parent-child-section'] = function (k, attrs, val) {
    var descriptor = {
        template: 'section.test-parent',
        anchor: '.shortcode-landing',
        item_template: '.section-test-child',
        item_anchor: '.child-landing',
        bind_fn: 'append',
        elements: {
            'img': {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
                    $dest.find(props.anchor).append('<img src="' + extract[0] + '" alt="' + extract[1] + '" />');
                },
                extract_fn: 'attr',
                extract_attr: ['src', 'alt'],
                anchor: '.image-landing',
                anchor_element: 'item'
            },
            'h2': {
                count: 'many',
                bind_fn: 'html',
                extract_fn: 'html',
                anchor: '.title-landing',
                anchor_element: 'item'
            }
        }
    };

    
    if ($('#flexible').length) {
        descriptor.anchor = 'self';
    }

    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
    
};

fn['big-image'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.big-image',
        elements: {
            img: {
                count: 1,
                bind_fn: function (extract, $dest, props) {
                    $dest.find(props.anchor).html('<img style="width: 100%" src="'+extract[0]+'"/>');
                },
                anchor: '.image-landing',
                anchor_element: 'template',
                extract_fn: 'attr',
                extract_attr: ['src']
            }
        }
    };
    
    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
};

fn['photo-collage'] = function (k, attrs, val) {
    
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.photo-collage',
        elements: {
            img: {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
//                    console.log('==========================================================');
//                    console.log('extract');
//                    console.log(extract);
//                    console.log('$dest');
//                    console.log($dest);
//                    console.log('props');
//                    console.log(props);
//                    $dest.find(props.anchor).html('<img style="width: 100%" src="'+extract[0]+'"/>');

                    $leftImage = $dest.find('.left-image-landing');
                    $rightImage1 = $dest.find('.right-image1');
                    $rightImage2 = $dest.find('.right-image2');

                    var $imageBlocks = [$leftImage, $rightImage1, $rightImage2] 

                    $($imageBlocks).each(function(){
                        
                        $targetDest = $(this);
                        
                        if(!$targetDest.hasClass("having-bg")) {
                            $targetDest.css('background-image', 'url(' + extract[0] + ')');
                            $targetDest.css('background-position', 'center');
                            $targetDest.css('background-repeat', 'no-repeat');
                            $targetDest.css('background-size', 'cover');
                        
                            $targetDest.addClass("having-bg");
    //                        $dest.find('.left-image-landing').html('<img style="width: 100%;max-height: 100%;" src="'+extract[0]+'"/>');
                            return false;
                        }
                    });
                },
                anchor: '.left-image-landing',
                anchor_element: 'template',
                extract_fn: 'attr',
                extract_attr: ['src']
            }
        }
    };
    
    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
};

fn['feature-set-3'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.feature-set-3',
        elements: {
            'h1,h2,h3,h4,h5,h6': {
                count: 1,
                bind_fn: 'html',
                anchor: '.title-landing',
                anchor_element: 'template',
                extract_fn: 'html'
            },
            img: {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
//                    console.log('==========================================================');
//                    console.log('extract');
//                    console.log(extract);
//                    console.log('$dest');
//                    console.log($dest);
//                    console.log('props');
//                    console.log(props);
                    
                    if(!$($dest).hasClass('background-done')) {
                        $dest.css('background-image', 'url(' + extract[0] + ')');
                        $dest.addClass("background-done");
                        
                        return true;
                    }
                    
                    $dest.find(props.anchor).each(function(){
                        if(!$(this).hasClass('feature-icon-processed')) {
                            $(this).find('.feature-icon').attr('src', extract[0]);
                            $(this).addClass('feature-icon-processed');
                            
                            return false;
                        }
                    });
                },
                anchor: '.feature-block',
                anchor_element: 'template',
                extract_fn: 'attr',
                extract_attr: ['src']
            },
            p: {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
                    
//                    console.log('==========================================================');
//                    console.log('extract');
//                    console.log(extract);
//                    console.log('$dest');
//                    console.log($dest);
//                    console.log('props');
//                    console.log(props);
                    
                    $dest.find(props.anchor).each(function(){
                        if(!$(this).hasClass('feature-text-processed')) {
                            $(this).find('.feature-text').html(extract);
                            $(this).addClass('feature-text-processed');
                            
                            return false;
                        }
                    });
                },
                anchor: '.feature-block',
                anchor_element: 'template',
                extract_fn: 'html',
            }
        }
    };
    
    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
};


fn['feature-set'] = function (k, attrs, val) {
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.feature-set',
        elements: {
            'h1,h2,h3,h4,h5,h6': {
                count: 1,
                bind_fn: 'html',
                anchor: '.title-landing',
                anchor_element: 'template',
                extract_fn: 'html'
            },
            img: {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
//                    console.log('==========================================================');
//                    console.log('extract');
//                    console.log(extract);
//                    console.log('$dest');
//                    console.log($dest);
//                    console.log('props');
//                    console.log(props);
                    
                    if(!$($dest).hasClass('background-done')) {
                        $dest.css('background-image', 'url(' + extract[0] + ')');
                        $dest.addClass("background-done");
                        
                        return true;
                    }
                    
                    $dest.find(props.anchor).each(function(){
                        if(!$(this).hasClass('feature-icon-processed')) {
                            $(this).find('.feature-icon').attr('src', extract[0]);
                            $(this).addClass('feature-icon-processed');
                            
                            return false;
                        }
                    });
                },
                anchor: '.feature-block',
                anchor_element: 'template',
                extract_fn: 'attr',
                extract_attr: ['src']
            },
            p: {
                count: 'many',
                bind_fn: function (extract, $dest, props) {
                    
//                    console.log('==========================================================');
//                    console.log('extract');
//                    console.log(extract);
//                    console.log('$dest');
//                    console.log($dest);
//                    console.log('props');
//                    console.log(props);
                    
                    $dest.find(props.anchor).each(function(){
                        if(!$(this).hasClass('feature-text-processed')) {
                            $(this).find('.feature-text').html(extract);
                            $(this).addClass('feature-text-processed');
                            
                            return false;
                        }
                    });
                },
                anchor: '.feature-block',
                anchor_element: 'template',
                extract_fn: 'html',
            }
        }
    };
    
    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
};

fn['big-carousel-image'] = function (k, attrs, val) {
    
//    console.log(attrs);
    
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.big-carousel-image',
        elements: {
            img: {
                count: 1,
                bind_fn: function (extract, $dest, props) {
                    $dest.css('background-image', 'url(' + extract[0] + ')');
                    $dest.find('.alt-image-landing').append('<img src="' + extract[0] + '" />');
                },
                anchor: 'self',
                anchor_element: 'template',
                extract_fn: 'attr',
                extract_attr: ['src']
            },
            'h1,h2,h3,h4,h5,h6': {
                count: 1,
                bind_fn: 'html',
                anchor: '.title-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            p: {
                count: 1,
                bind_fn: 'html',
                anchor: '.description',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            ul: {
                count: 1,
                bind_fn: 'append',
                anchor: '.description',
                extract_fn: 'self',
                anchor_element: 'template'
            }
        }
    };
    
    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
};

fn['badge'] = function (k, attrs, val) {
    
//    console.log(attrs);
    
    var descriptor = {
        anchor: '.shortcode-landing',
        bind_fn: 'append',
        template: '.badge',
        elements: {
            img: {
                count: 1,
                bind_fn: function (extract, $dest, props) {
                    $dest.find('.badge-logo-landing').append('<img src="' + extract[0] + '" />');
                },
                anchor: 'self',
                anchor_element: 'template',
                extract_fn: 'attr',
                extract_attr: ['src']
            },
            'h1,h2,h3,h4,h5,h6': {
                count: 1,
                bind_fn: 'html',
                anchor: '.title-landing',
                extract_fn: 'html',
                anchor_element: 'template'
            },
            p: {
                count: 1,
                bind_fn: 'html',
                anchor: '.description',
                extract_fn: 'html',
                anchor_element: 'template'
            }
        }
    };
    
    var $template = shortcodeDataBinder(descriptor, val);
    $template.addClass(attrs.join(' '));
};

//Placed by Jason Torrado to have footer links open in a new tab
//jQuery('a[href^="http"]').not('a[href^="{{ shop.url }}"]').attr('target', '_blank');